const app = window.__initialData || {};
window.__initialData = app;

const GUIDED_BASE_SESSION_PREFIX = "swapwear:guided-base:";
const GUIDED_BASE_JOURNEY_TTL_MS = 30 * 60 * 1000;
const GUIDED_BASE_EVENT_NAMES = Object.freeze({
  prompt_view: "swapwear_guided_base_prompt_view",
  prompt_skip: "swapwear_guided_base_prompt_skip",
  view: "swapwear_guided_base_view",
  add: "swapwear_guided_base_add"
});
const GUIDED_ART_SESSION_PREFIX = "swapwear:guided-art:";
const GUIDED_ART_EVENT_NAMES = Object.freeze({
  prompt_view: "swapwear_guided_art_prompt_view",
  prompt_skip: "swapwear_guided_art_prompt_skip",
  view: "swapwear_guided_art_view",
  add: "swapwear_guided_art_add"
});

// Promo Planner is optional storefront enhancement data. A failed/partial page
// initialization must never make core product and cart Alpine components depend
// on a missing sale profile.
const rawSaleProfile = app.sale_profile && typeof app.sale_profile === "object"
  ? app.sale_profile
  : {};
app.sale_profile = {
  id: 0,
  active: false,
  type: "none",
  url: "",
  start: "",
  end: "",
  title: "",
  announcement: "",
  eventLabel: "",
  checkoutLabel: "",
  discountLabel: "",
  accordionContent: "",
  detailLine: "",
  disclaimer: "",
  badge: "",
  showTimer: false,
  messaging: {},
  offer: {},
  bogo: {},
  ...rawSaleProfile,
  active: rawSaleProfile.active === true,
  tiers: Array.isArray(rawSaleProfile.tiers) ? rawSaleProfile.tiers : [],
  messaging: rawSaleProfile.messaging && typeof rawSaleProfile.messaging === "object" ? rawSaleProfile.messaging : {},
  offer: rawSaleProfile.offer && typeof rawSaleProfile.offer === "object" ? rawSaleProfile.offer : {},
  bogo: rawSaleProfile.bogo && typeof rawSaleProfile.bogo === "object" ? rawSaleProfile.bogo : {}
};
if (!app.cart || !Array.isArray(app.cart.items)) {
  app.cart = {
    items: [],
    item_count: 0,
    total_price: 0,
    original_total_price: 0,
    total_discount: 0,
    cart_level_discount_applications: []
  };
}
window.swapwearFetch?.confirmCart(app.cart);

window.swapwearSyncBuildCartVariantIds = window.swapwearSyncBuildCartVariantIds || function(cartData = {}) {
  window.__buildCartVariantIds = new Set(
    (Array.isArray(cartData?.items) ? cartData.items : [])
      .map(item => String(item?.variant_id || item?.id || ''))
      .filter(Boolean)
  );
  return window.__buildCartVariantIds;
};

window.swapwearSyncBuildCartVariantIds(app?.cart || {});

window.swapwearBuildCardVisibility = window.swapwearBuildCardVisibility || (() => {
  const callbacks = new Map();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const callback = callbacks.get(entry.target);
          if (callback) callback();
          observer.unobserve(entry.target);
          callbacks.delete(entry.target);
        });
      }, { rootMargin: '200px 0px' })
    : null;

  return {
    observe(element, callback) {
      if (!element || typeof callback !== 'function') return;
      if (!observer) {
        callback();
        return;
      }
      callbacks.set(element, callback);
      observer.observe(element);
    },
    unobserve(element) {
      if (!element) return;
      observer?.unobserve(element);
      callbacks.delete(element);
    }
  };
})();

// Product cards are appended repeatedly by build-bundle pagination. Keep their
// behavior here once instead of embedding the same large Alpine object in every
// card returned by Shopify.
window.buildProductCard = window.buildProductCard || function() {
  return {
    button_loading: false,
    removing_variant: false,
    rare_closed: false,
    rare_expire_at: 0,
    optimistic_selected_variant_id: '',
    optimistic_selected_until: 0,
    optimistic_removing_variant_id: '',
    optimistic_removing_until: 0,
    artistPayload: null,
    inventoryPayload: null,
    panelPreview: null,
    card_variant_id: '',
    cart_selected: false,
    cartUpdatedHandler: null,
    cardElement: null,
    flipTimer: null,
    rareCloseTimer: null,
    optimisticAddTimer: null,
    optimisticRemoveTimer: null,
    inView: false,
    mediaLoaded: false,
    upcoming: false,
    activateEpoch: 0,
    upcoming_expired: true,

    init() {
      this.cardElement = this.$el;
      const data = this.cardElement.dataset;
      this.card_variant_id = data.buildVariantId || '';
      this.rare_closed = data.buildRareClosed === 'true';
      this.rare_expire_at = Number(data.buildRareExpireAt || 0) * 1000;
      this.upcoming = data.buildUpcoming === 'true';
      this.activateEpoch = Number(data.buildActivateEpoch || 0);
      this.upcoming_expired = !this.upcoming || this.activateEpoch < Math.floor(Date.now() / 1000);

      this.initCartSelection();
      this.initIO();
      this.scheduleFlip();
      this.scheduleRareClose();
    },

    initIO() {
      if (this.inView) return;
      window.swapwearBuildCardVisibility?.observe(this.cardElement, () => {
        this.inView = true;
        // Defer JSON parsing/registry work until a card approaches the viewport.
        this.registerBuildArtist();
        this.registerBuildVariantInventory();
        this.$nextTick(() => this.initMediaIO());
      });
    },

    syncCartSelection() {
      this.cart_selected = Boolean(window.__buildCartVariantIds?.has(String(this.card_variant_id)));
    },

    initCartSelection() {
      if (!window.__buildCartVariantIds) window.swapwearSyncBuildCartVariantIds?.(window.__initialData?.cart || {});
      this.syncCartSelection();
      this.cartUpdatedHandler = () => this.syncCartSelection();
      window.addEventListener('cart:updated', this.cartUpdatedHandler);
      window.addEventListener('build-cart-selection:updated', this.cartUpdatedHandler);
    },

    destroy() {
      window.swapwearBuildCardVisibility?.unobserve(this.cardElement);
      if (this.cartUpdatedHandler) {
        window.removeEventListener('cart:updated', this.cartUpdatedHandler);
        window.removeEventListener('build-cart-selection:updated', this.cartUpdatedHandler);
      }
      [this.flipTimer, this.rareCloseTimer, this.optimisticAddTimer, this.optimisticRemoveTimer]
        .filter(timer => timer !== null)
        .forEach(timer => clearTimeout(timer));
      this.flipTimer = null;
      this.rareCloseTimer = null;
      this.optimisticAddTimer = null;
      this.optimisticRemoveTimer = null;
    },

    initMediaIO() {
      const images = Array.from(this.cardElement.querySelectorAll('picture img'));
      const syncLoadedState = () => {
        this.mediaLoaded = images.length === 0 || images.every((img) => img.complete && img.naturalWidth > 0);
        images.forEach((img) => { img.style.visibility = this.mediaLoaded ? '' : 'hidden'; });
      };
      images.forEach((img) => {
        img.addEventListener('load', syncLoadedState, { once: true });
        img.addEventListener('error', syncLoadedState, { once: true });
      });
      syncLoadedState();
    },

    variantInCart(variantId) {
      if (String(variantId) === String(this.card_variant_id)) return this.cart_selected;
      return Boolean(window.__buildCartVariantIds?.has(String(variantId)));
    },
    variantSelected(variantId) {
      if (this.variantRemoving(variantId)) return false;
      return this.variantInCart(variantId) ||
        (String(this.optimistic_selected_variant_id) === String(variantId) && Date.now() < this.optimistic_selected_until);
    },
    beginVariantAdd(variantId) {
      this.optimistic_selected_variant_id = String(variantId);
      this.optimistic_selected_until = Date.now() + 2600;
      clearTimeout(this.optimisticAddTimer);
      this.optimisticAddTimer = setTimeout(() => {
        this.optimisticAddTimer = null;
        if (String(this.optimistic_selected_variant_id) === String(variantId) && !this.variantInCart(variantId)) this.clearOptimisticVariant(variantId);
      }, 2600);
    },
    clearOptimisticVariant(variantId) {
      if (String(this.optimistic_selected_variant_id) !== String(variantId)) return;
      clearTimeout(this.optimisticAddTimer);
      this.optimisticAddTimer = null;
      this.optimistic_selected_variant_id = '';
      this.optimistic_selected_until = 0;
    },
    variantRemoving(variantId) {
      return String(this.optimistic_removing_variant_id) === String(variantId) && Date.now() < this.optimistic_removing_until;
    },
    beginVariantRemove(variantId) {
      this.clearOptimisticVariant(variantId);
      this.optimistic_removing_variant_id = String(variantId);
      this.optimistic_removing_until = Date.now() + 2600;
      clearTimeout(this.optimisticRemoveTimer);
      this.optimisticRemoveTimer = setTimeout(() => {
        this.optimisticRemoveTimer = null;
        this.clearOptimisticRemoval(variantId);
      }, 2600);
    },
    clearOptimisticRemoval(variantId) {
      if (String(this.optimistic_removing_variant_id) !== String(variantId)) return;
      clearTimeout(this.optimisticRemoveTimer);
      this.optimisticRemoveTimer = null;
      this.optimistic_removing_variant_id = '';
      this.optimistic_removing_until = 0;
    },
    scheduleFlip() {
      if (this.flipTimer !== null || !this.upcoming || this.upcoming_expired) return;
      const delay = this.activateEpoch * 1000 - Date.now();
      if (delay <= 0) {
        this.upcoming_expired = true;
        return;
      }
      this.flipTimer = setTimeout(() => {
        this.flipTimer = null;
        this.scheduleFlip();
      }, Math.min(delay, 2147483647));
    },
    scheduleRareClose() {
      if (this.rareCloseTimer !== null || !this.rare_expire_at || this.rare_closed) return;
      const delay = this.rare_expire_at - Date.now();
      if (delay <= 0) {
        this.rare_closed = true;
        return;
      }
      this.rareCloseTimer = setTimeout(() => {
        this.rareCloseTimer = null;
        this.scheduleRareClose();
      }, Math.min(delay, 2147483647));
    },
    openSoldOutPopup() {
      const source = this.cardElement.dataset;
      window.dispatchEvent(new CustomEvent('build-sold-out-popup', { detail: {
        title: source.buildSoldOutTitle || '',
        variantId: source.buildSoldOutVariantId || '',
        canNotify: source.buildSoldOutCanNotify === 'true',
        message: source.buildSoldOutMessage || 'This artwork is sold out.'
      }}));
    },
    refreshBuilderProduct(variantId) {
      const sectionId = this.cardElement.dataset.buildSectionId || document.querySelector('[data-build-section-id]')?.dataset?.buildSectionId || window.pagination_section || '';
      if (typeof this.loadBuilderByHandle === 'function') {
        this.loadBuilderByHandle(this.cardElement.dataset.buildHandle || '', sectionId, variantId);
      }
    },
    registerBuildArtist() {
      if (!this.artistPayload) {
        try { this.artistPayload = JSON.parse(this.cardElement.dataset.buildArtist || 'null'); } catch (_) { this.artistPayload = null; }
      }
      if (!this.artistPayload) return;
      const initial = window.__initialData = window.__initialData || {};
      initial.build_swap_artists = initial.build_swap_artists || {};
      initial.build_swap_artists_by_variant = initial.build_swap_artists_by_variant || {};
      initial.build_swap_artists[this.cardElement.dataset.buildHandle || ''] = this.artistPayload;
      (this.artistPayload.variant_ids || []).forEach((id) => { initial.build_swap_artists_by_variant[String(id)] = this.artistPayload; });
    },
    registerBuildVariantInventory() {
      if (!this.inventoryPayload) {
        try { this.inventoryPayload = JSON.parse(this.cardElement.dataset.buildVariantInventory || '{}'); } catch (_) { this.inventoryPayload = {}; }
      }
      const initial = window.__initialData = window.__initialData || {};
      initial.build_variant_inventory_by_variant = initial.build_variant_inventory_by_variant || {};
      Object.entries(this.inventoryPayload).forEach(([id, inventory]) => { initial.build_variant_inventory_by_variant[String(id)] = inventory; });
    },
    panelDetail() {
      this.registerBuildArtist();
      if (!this.panelPreview) {
        try { this.panelPreview = JSON.parse(this.cardElement.dataset.buildPanelPreview || 'null'); } catch (_) { this.panelPreview = null; }
      }
      return {
        handle: this.cardElement.dataset.buildHandle || '',
        title: this.cardElement.dataset.buildTitle || '',
        url: this.cardElement.dataset.buildUrl || '',
        artist: this.artistPayload,
        preview: this.panelPreview
      };
    },
    prefetchPanelModal() {
      window.dispatchEvent(new CustomEvent('build-panel-prefetch', { detail: this.panelDetail() }));
    },
    openPanelModal() {
      window.dispatchEvent(new CustomEvent('build-panel-modal', { detail: this.panelDetail() }));
    }
  };
};

// Keep modal interaction available while Alpine initializes newly appended
// cards. Delegation also avoids installing a separate click handler per card.
window.swapwearBuildPanelCardEvents = window.swapwearBuildPanelCardEvents || (() => {
  if (typeof document === 'undefined') return false;
  const detailFor = (card) => {
    let artist = null;
    let preview = null;
    try { artist = JSON.parse(card.dataset.buildArtist || 'null'); } catch (_) {}
    try { preview = JSON.parse(card.dataset.buildPanelPreview || 'null'); } catch (_) {}

    if (artist) {
      const initial = window.__initialData = window.__initialData || {};
      initial.build_swap_artists = initial.build_swap_artists || {};
      initial.build_swap_artists_by_variant = initial.build_swap_artists_by_variant || {};
      initial.build_swap_artists[card.dataset.buildHandle || ''] = artist;
      (artist.variant_ids || []).forEach((id) => { initial.build_swap_artists_by_variant[String(id)] = artist; });
    }

    return {
      handle: card.dataset.buildHandle || '',
      title: card.dataset.buildTitle || '',
      url: card.dataset.buildUrl || '',
      artist,
      preview
    };
  };
  const cardFromEvent = (event) => event.target?.closest?.('[data-build-panel-trigger]')
    ?.closest?.('[data-product-anchor="true"]');
  const isPlainPrimaryActivation = (event) => !event.defaultPrevented &&
    (event.button === undefined || event.button === 0) &&
    !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  let pointerStart = null;
  let lastPointerOpenAt = 0;
  let lastPointerOpenCard = null;

  document.addEventListener('pointerdown', (event) => {
    pointerStart = null;
    if (!isPlainPrimaryActivation(event)) return;
    const card = cardFromEvent(event);
    if (!card) return;
    pointerStart = { card, x: event.clientX, y: event.clientY };
    window.dispatchEvent(new CustomEvent('build-panel-prefetch', { detail: detailFor(card) }));
  }, { passive: true });

  document.addEventListener('pointerup', (event) => {
    const start = pointerStart;
    pointerStart = null;
    if (!isPlainPrimaryActivation(event)) return;
    const card = cardFromEvent(event);
    if (!card || !start || card !== start.card) {
      return;
    }
    const movement = Math.hypot(event.clientX - start.x, event.clientY - start.y);
    if (movement > 10) {
      return;
    }
    lastPointerOpenAt = Date.now();
    lastPointerOpenCard = card;
    window.dispatchEvent(new CustomEvent('build-panel-modal', { detail: detailFor(card) }));
  }, { capture: true });

  document.addEventListener('click', (event) => {
    if (!isPlainPrimaryActivation(event)) return;
    const card = cardFromEvent(event);
    if (!card) return;
    event.preventDefault();
    if (event.detail !== 0 && card === lastPointerOpenCard && Date.now() - lastPointerOpenAt < 500) {
      return;
    }
    window.dispatchEvent(new CustomEvent('build-panel-modal', { detail: detailFor(card) }));
  }, { capture: true });

  return true;
})();
// CUSTOMIZATION URL PARAMS START
const urlParams = new URLSearchParams(window.location.search);
const urlParamsObj = {};

for (const [key, value] of urlParams.entries()) {
  urlParamsObj[key] = value;
}

// CUSTOMIZATION URL PARAMS END
const globals = {
  // Scroll
  is_scrolled: app.is_scrolled,
  // {boolean} Used to toggle dynamic header bar
  prev_scroll_pos: app.prev_scroll_pos,
  // {number} Previous scroll position of the page.
  show_scroll_up: app.show_scroll_up,
  // {boolean} To show the 'back to top' button
  // Audio
  click_audio: app.click_audio,
  // {string} URL for click sound
  success_audio: app.success_audio,
  // {string} URL for success sound
  enable_audio: app.enable_audio,
  // {boolean} To enable or disable audio
  // Popups
  age_popup: app.age_popup,
  // {boolean} To toggle the age popup
  filter_popup: app.filter_popup,
  // {boolean} To toggle the filter popup
  localization_popup: app.localization_popup,
  // {boolean} To toggle the localization popup
  audio_popup: app.audio_popup,
  // {boolean} To toggle audio settings popup
  cookie_popup: app.cookie_popup,
  // {boolean} To toggle the cookie compliance popup
  discount_popup: app.discount_popup,
  // {boolean} To toggle the discount popup
  // Quick sections
  quick_add_popup: app.quick_add_popup,
  // {boolean} To toggle the quick add popup
  quick_edit_popup: app.quick_edit_popup,
  // {boolean} To toggle the quick edit popup
  quick_edit_handle: app.quick_edit_handle,
  // {string} The product handle of the product being edited
  quick_add_handle: app.quick_add_handle,
  // {string} The product handle of the product being added
  // Menu 
  menu_drawer: app.menu_drawer,
  // {boolean} To toggle the menu drawer
  menu_nested: app.menu_nested,
  // {boolean} To check if the menu is nested
  // Header
  hide_header: app.hide_header,
  // {boolean} To hide the header
  // Errors
  // {boolean} To show the alert
  error_message: app.error_message,
  // {string} Error message
  // Prices
  price_format_with_currency: app.price_format_with_currency,
  // {string} Format for price with currency
  price_format_without_currency: app.price_format_without_currency,
  // {string} Format for price without currency
  price_enable_zeros: app.price_enable_zeros,
  // {Boolean} Set to false to hide '.00'
  price_enable_currency: app.price_enable_currency,
  // {Boolean} Set to false to hide 'CAD
  // Product
  recent_products: app.recent_products,
  // {array} of recently viewed products
  // Discount properties
  discount_text: app.discount_text,
  // {string} Text for the discount
  discount_code: app.discount_code,
  // {string} Code for the discount
  // Cart
  cart_alert: app.cart_alert,
  // {boolean} To show the cart alert
  cart_drawer: app.cart_drawer,
  // {boolean} To toggle the cart drawer
  cart_loading: app.cart_loading,
  // {boolean} To check if the cart is loading
  cart_behavior_desktop: app.cart_behavior_desktop,
  // {string} Behavior of the cart on desktop
  cart_behavior_mobile: app.cart_behavior_mobile,
  // {string} Behavior of the cart on mobile
  cart: app.cart,
  // {object} Object to store the cart data
  progress_bar_threshold: app.progress_bar_threshold,
  // {number} Set the threshold for the 'free shipping' progress bar
  // Search
  search_active: app.search_active,
  // {boolean} to toggle the search overlay
  search_loading: app.search_loading,
  // {boolean} To check if the search is loading
  search_term: app.search_term,
  // {string} Term for the search
  search_items: app.search_items,
  // {array} Array of search items
  search_focus_index: app.search_focus_index,
  // {string} Index of the focused search item
  search_focus_url: app.search_focus_url,
  // {string} URL of the focused search item
  search_items_pages: app.search_items_pages,
  // {array} Array of search items in pages
  search_items_collections: app.search_items_collections,
  // {array} Array of search items in collections
  search_items_articles: app.search_items_articles,
  // {array} Array of search items in articles
  search_items_queries: app.search_items_queries,
  // {array} Array of search items in queries
  // Pagination
  pagination_loading: app.pagination_loading,
  // {boolean} To show loading state in pagination
  pagination_error: app.pagination_error,
  // {boolean} To show a durable retry when infinite pagination exhausts retries
  pagination_total_pages: app.pagination_total_pages,
  // {number} Total number of pages for the current collection
  pagination_current_page: app.pagination_current_page,
  // {number} Current page number in pagination
  pagination_section: app.pagination_section,
  // {string} Points to a {{ section.id }} to paginate
  // Filter
  filter_min_price: app.filter_min_price,
  // {number} Value of the min price input
  filter_max_price: app.filter_max_price,
  // {number} Value of the max price input
  filter_min: app.filter_min,
  // {number} Min price for the current collection
  filter_max: app.filter_max,
  // {number} Max price for the current collection
  filter_min_thumb: app.filter_min_thumb,
  // {number} Sets position of min price thumb
  filter_max_thumb: app.filter_max_thumb,
  // {number} Sets position of max price thumb
  // TODO: - Remove, merge and connect. Referce Space
  show_alert: app.show_alert,
  enable_body_scrolling: app.enable_body_scrolling,
  // Custom Globals
  wishlist_loading: app.wishlist_loading,
  // Boolean to toggle the wishlist loading state
  wishing_loading: app.wishing_loading,
  wishlist_mode: app.wishlist_mode,
  search_mode: app.search_mode,
  // Boolean to toggle the wishlist loading state
  wishlist: app.wishlist,
  // Sets wishlist items in an object array
  wishlist_owner: null,
  // Sets wishlist owner to default null, Used for wishlist sharing
  shipping_profile: app.shipping_profile,
  bundle_tier_toast_messages: app.bundle_tier_toast_messages,
  sale_profile: app.sale_profile,
  swap_types: app.swap_types,
  bases: app.bases,
  urlParamsObj: urlParamsObj,
  mystery_data: app.mystery_data,
  _toastTimer: null,
  _toastWatchdog: null,
  _toastGeneration: 0,
  _toastQueue: [],
  _toastQueueTimer: null,
  _saleTierPopupQueue: null,
  _cartRequestInFlight: false,
  _cartMutationQueue: null,
  _cartUpdatePromise: null,
  _cartRefreshQueued: false,
  _cartOpenAfterUpdate: false,
  _pendingBundleTierToastState: null,
  _bundleTierToastTimer: null,
  _pendingCartRemovalKeys: {},
  _removingMystery2: false,
  _addingMystery2: false,
  guided_base_prompt: false,
  guided_base_prompt_item: null,
  guided_base_prompt_skipped: (function () {
    try {
      return JSON.parse(window.sessionStorage.getItem(`${GUIDED_BASE_SESSION_PREFIX}skipped`)) === true;
    } catch (_) {
      return false;
    }
  })(),
  _guidedBasePromptViewTracked: false,
  _guidedBaseCollectionViewTracked: false,
  _guidedBaseSkipTracked: false,
  guided_art_prompt: false,
  guided_art_prompt_item: null,
  guided_art_prompt_skipped: (function () {
    try {
      return JSON.parse(window.sessionStorage.getItem(`${GUIDED_ART_SESSION_PREFIX}skipped`)) === true;
    } catch (_) {
      return false;
    }
  })(),
  _guidedArtPromptViewTracked: false,
  _guidedArtCollectionViewTracked: false,
  _guidedArtSkipTracked: false,
  _guidedCartPromptFocusKind: "",
  _guidedCartPromptDisplayKind: "",
  toast: {
    show: false,
    type: '',
    message: '',
    timeout: 3000,
    icon: '',
    iconFill: 'var(--color-secondary-button-text-light)',
    className: ''
  },
  sale_tier_popup: {
    show: false,
    discount: 0,
    timer: null,
    dismiss_timer: null,
    shown_at: 0,
    minimum_visible_ms: 1000
  },
  selected_base: (function () {
    const LS_KEY = 'selected_base';
    const bases = Array.isArray(app.bases) ? app.bases : [];
    const readStoredBase = () => window.swapwearStorage?.get?.(LS_KEY, null);
    const storeBase = (value) => window.swapwearStorage?.setJSON?.(LS_KEY, value) === true;
    // Prefer URL param if present (supports ?base=<handle> or ?base=<index>)
    const urlBaseParam = (urlParamsObj && Object.prototype.hasOwnProperty.call(urlParamsObj, 'base'))
      ? urlParamsObj.base
      : null;
    let index;
    if (urlBaseParam != null && urlBaseParam !== '') {
      const normalized = String(urlBaseParam).trim().toLowerCase();
      const asInt = Number(normalized);
      if (Number.isInteger(asInt) && asInt >= 0 && asInt < bases.length) {
        // ?base=1 → numeric index
        index = asInt;
      } else {
        // ?base=raven → match by handle
        index = bases.findIndex((b) => {
          if (!b || typeof b !== 'object') return false;
          const handle = b.handle != null ? String(b.handle).toLowerCase() : '';
          return handle === normalized;
        });
        if (index < 0) index = 0; // fallback if no handle match
      }
      storeBase(index);
      return index;
    }
    // No URL param → use persisted value or default to 0 (Raven=0, Oceanside=1, Cobalt=2)
    const stored = readStoredBase();
    if (stored == null) {
      index = 0;
      storeBase(index);
      return index;
    }
    // Validate stored value and clamp if needed
    try {
      index = Number(JSON.parse(stored));
    } catch {
      index = NaN;
    }
    if (
      !Number.isInteger(index) ||
      index < 0 ||
      (bases.length && index >= bases.length)
    ) {
      index = 0;
      storeBase(index);
    }
    return index;
  })(),
  // CUSTOM END
};

// Check if urlParamsObj contains 'contact_posted' and its value is 'true'
if (urlParamsObj.contact_posted && urlParamsObj.contact_posted === 'true') {
  globals.error_message = "Allow 1-3 business days for us to reply ✅";
  globals.show_alert = true;
}

const cart = {
  isValidCartPayload(payload) {
    return !!(
      payload &&
      typeof payload === "object" &&
      Array.isArray(payload.items) &&
      Number.isFinite(Number(payload.item_count)) &&
      Number.isFinite(Number(payload.total_price))
    );
  },
  scheduleInitialCartRefresh() {
    if (window.__swapwearInitialCartRefreshScheduled) return;
    window.__swapwearInitialCartRefreshScheduled = true;

    const refresh = () => {
      if (window.__swapwearInitialCartRefreshStarted) return;
      window.__swapwearInitialCartRefreshStarted = true;
      this.updateCart(false);
    };
    const scheduleWhenIdle = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(refresh, { timeout: 3000 });
      } else {
        window.setTimeout(refresh, 1500);
      }
    };

    if (document.readyState === 'complete') scheduleWhenIdle();
    else window.addEventListener('load', scheduleWhenIdle, { once: true });
  },
  initCartRestoreSync() {
    if (window.__swapwearCartRestoreSyncAttached) return;
    window.__swapwearCartRestoreSyncAttached = true;

    window.addEventListener("swapwear:cart-restored", (event) => {
      const restoredCart = event?.detail?.cart;
      if (!this.isValidCartPayload(restoredCart)) return;
      this.cart.items = this.hydrateCartItemsWithArtists(restoredCart.items);
      this.cart.item_count = restoredCart.item_count;
      this.cart.total_price = restoredCart.total_price;
      this.cart.original_total_price = restoredCart.original_total_price;
      this.cart.total_discount = restoredCart.total_discount;
      this.cart.cart_level_discount_applications = Array.isArray(restoredCart.cart_level_discount_applications)
        ? restoredCart.cart_level_discount_applications
        : [];
      window.swapwearSyncBuildCartVariantIds?.({ items: this.cart.items });
      this.cart_loading = false;
    });

    window.addEventListener("swapwear:request-failed", (event) => {
      if (event?.detail?.mutation !== true) return;
      this.error_message = event?.detail?.message || "We couldn't update your cart. Please try again.";
      this.show_alert = true;
      this.cart_loading = false;
    });

    window.addEventListener("pageshow", (event) => {
      if (!event.persisted) return;

      this._cartMutationQueue = null;
      this._cartUpdatePromise = null;
      this._cartRefreshQueued = false;
      this._cartOpenAfterUpdate = false;
      this._cartRequestInFlight = false;
      this._pendingBundleTierToastState = null;
      clearTimeout(this._bundleTierToastTimer);
      this._bundleTierToastTimer = null;
      this._pendingCartRemovalKeys = {};
      this.cart_loading = false;
      this.updateCart(false);
    });
  },
  async checkoutWhenCartSettled() {
    this.cart_loading = true;
    const checkoutUrl = `${window.Shopify?.routes?.root || '/'}checkout`;
    // Slow mobile/in-app sessions need enough time to finish the mutation that
    // immediately preceded checkout. The cap still guarantees a broken request
    // cannot trap the shopper indefinitely.
    const maxCartSettleWaitMs = 15000;

    const waitForCart = async () => {
      if (window.swapwearAcquisitionReady) await window.swapwearAcquisitionReady;
      while (this._cartMutationQueue || this._cartUpdatePromise) {
        const pending = [this._cartMutationQueue, this._cartUpdatePromise].filter(Boolean);
        await Promise.allSettled(pending);
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    };

    try {
      await Promise.race([
        waitForCart(),
        new Promise(resolve => setTimeout(resolve, maxCartSettleWaitMs))
      ]);
    } catch (error) {
      console.error('Unable to settle cart before checkout:', error);
    }

    const panel = (this.cart?.items || []).find(item => this.isGuidedArtPanelCartItem(item));
    if (panel && !this.hasCompatibleBaseInCart() && !this.guided_base_prompt_skipped && this.readGuidedBaseSession('skipped', false) !== true) {
      this.handleSuccessfulGuidedCartAdd(panel);
      this.cart_loading = false;
      this.cart_alert = false;
      window.dispatchEvent(new CustomEvent('checkout:base-guidance'));
      this.cart_drawer = true;
      this.hide_header = false;
      window.dispatchEvent(new CustomEvent('checkout:reset'));
      return false;
    }

    window.location.assign(checkoutUrl);
  },
  isCartLineRemovalPending(item) {
    const key = String(item?.key || item?.id || item?.variant_id || '');
    return !!(key && this._pendingCartRemovalKeys?.[key]);
  },
  selectNextBuildItemForRemoval(key) {
    const removalKey = String(key || '');
    const currentLine = (this.cart?.items || []).find(item =>
      String(item?.key || item?.id || item?.variant_id || '') === removalKey
    );
    if (!currentLine) return;

    const selectedMatchesLine =
      String(this.build_selected?.variant_id || '') === String(currentLine.variant_id || currentLine.id || '') &&
      String(this.build_selected?.custom_id || '') === String(currentLine?.properties?.custom_id || '');
    if (!selectedMatchesLine) return;

    const panels = (this.cart?.items || []).filter(item =>
      this.isArtPanelCartItem(item) &&
      !String(item.product_title || '').includes('Mystery')
    );
    const currentIndex = panels.findIndex(item =>
      String(item?.key || item?.id || item?.variant_id || '') === removalKey
    );
    const remainingPanels = panels.filter(item =>
      String(item?.key || item?.id || item?.variant_id || '') !== removalKey
    );
    const nextPanel = currentIndex >= 0 && remainingPanels.length
      ? panels.slice(currentIndex + 1).concat(panels.slice(0, currentIndex)).find(item =>
          String(item?.key || item?.id || item?.variant_id || '') !== removalKey
        )
      : remainingPanels[0];
    const nextItem = nextPanel || (this.cart?.items || []).find(item =>
      this.isBuildBaseCartItem(item) &&
      String(item?.key || item?.id || item?.variant_id || '') !== removalKey
    );
    if (!nextItem) return;

    if (typeof this.loadBuilderByHandle === 'function') {
      this.loadBuilderByHandle(
        nextItem.handle,
        this._sectionId,
        this.isBuildBaseCartItem(nextItem) ? nextItem.variant_id : null,
        'swaps',
        nextItem?.properties?.custom_id || ''
      );
    }
    this.selectBuildItemFromCartLine(nextItem);
  },
  updateCartNote(note) {
    this.cart_loading = true;
    window.swapwearFetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ note })
    }).then(async (response) => {
      let data2 = await response.json();
      if (response.status === 200 && this.isValidCartPayload(data2)) {
        this.cart.items = this.hydrateCartItemsWithArtists(data2.items);
        window.swapwearSyncBuildCartVariantIds?.({ items: this.cart.items });
        this.updateCart(false);
      } else {
        this.error_title = data2?.message;
        this.error_message = data2?.description || "The cart response was incomplete. Please try again.";
        this.show_alert = true;
      }
    }).catch((error2) => {
      console.error("Error:", error2);
      this.cart_loading = false;
    });
  },
  async runCartMutation(task) {
    const previousMutation = this._cartMutationQueue || Promise.resolve();

    const nextMutation = previousMutation.catch(() => {}).then(async () => {
      this._cartRequestInFlight = true;
      try {
        return await task();
      } finally {
        this._cartRequestInFlight = false;
      }
    });

    const trackedMutation = nextMutation.catch(() => {}).finally(() => {
      if (this._cartMutationQueue === trackedMutation) {
        this._cartMutationQueue = null;
      }
    });
    this._cartMutationQueue = trackedMutation;

    return nextMutation;
  },
  cartErrorMessage(error, fallback = "We couldn't update your cart. Please try again.") {
    if (error?.swapwearFailureType === "network" || error?.name === "AbortError") {
      return "We couldn't update your cart. Check your connection and try again.";
    }
    return error?.message || fallback;
  },
  hydrateCartItemsWithArtists(items = []) {
    if (!Array.isArray(items)) return [];
    const initialItems = window.__initialData?.cart?.items || [];
    const currentItems = this.cart?.items || [];
    const artistMap = window.__initialData?.build_swap_artists || {};
    const artistVariantMap = window.__initialData?.build_swap_artists_by_variant || {};
    const inventoryVariantMap = window.__initialData?.build_variant_inventory_by_variant || {};

    return items.map(item => {
      const existingArtist = item.artist;
      const variantId = String(item.variant_id || item.id || "");

      const initialMatch = initialItems.find(initialItem => {
        const sameKey = initialItem.key && item.key && String(initialItem.key) === String(item.key);
        const sameVariant = String(initialItem.variant_id) === variantId;
        const sameHandle = initialItem.handle && item.handle && String(initialItem.handle) === String(item.handle);

        return sameKey || sameVariant || sameHandle;
      });
      const currentMatch = currentItems.find(currentItem => {
        const sameKey = currentItem.key && item.key && String(currentItem.key) === String(item.key);
        const sameVariant = String(currentItem.variant_id) === variantId;
        const sameHandle = currentItem.handle && item.handle && String(currentItem.handle) === String(item.handle);

        return sameKey || sameVariant || sameHandle;
      });
      const productVariant = (this.product?.variants || []).find(variant =>
        String(variant.id) === variantId
      );
      const inventoryMatch = inventoryVariantMap?.[variantId] || null;

      return {
        ...item,
        variant_inventory_quantity:
          item.variant_inventory_quantity ??
          currentMatch?.variant_inventory_quantity ??
          initialMatch?.variant_inventory_quantity ??
          inventoryMatch?.quantity ??
          productVariant?.inventory_quantity,
        variant_inventory_policy:
          item.variant_inventory_policy ??
          currentMatch?.variant_inventory_policy ??
          initialMatch?.variant_inventory_policy ??
          inventoryMatch?.policy ??
          productVariant?.inventory_policy,
        variant_inventory_management:
          item.variant_inventory_management ??
          currentMatch?.variant_inventory_management ??
          initialMatch?.variant_inventory_management ??
          inventoryMatch?.management ??
          productVariant?.inventory_management,
        artist:
          existingArtist ||
          initialMatch?.artist ||
          artistVariantMap?.[variantId] ||
          artistMap?.[item.handle] ||
          null
      };
    });
  },
  isArtPanelType(productType) {
    const type = String(productType || "").toLowerCase();
    return ["swappable patch", "swappable panel", "art panel"].some(label => type.includes(label));
  },
  isArtPanelCartItem(item) {
    return this.isArtPanelType(item?.product_type);
  },
  isBuildBaseCartItem(item) {
    return (globals.bases || []).some(base => base.handle === item?.handle);
  },
  guidedBaseSessionKey(key) {
    return `${GUIDED_BASE_SESSION_PREFIX}${key}`;
  },
  readGuidedBaseSession(key, fallback = null) {
    try {
      const value = window.sessionStorage.getItem(this.guidedBaseSessionKey(key));
      return value === null ? fallback : JSON.parse(value);
    } catch (_) {
      return fallback;
    }
  },
  writeGuidedBaseSession(key, value) {
    try {
      window.sessionStorage.setItem(this.guidedBaseSessionKey(key), JSON.stringify(value));
      return true;
    } catch (_) {
      return false;
    }
  },
  removeGuidedBaseSession(key) {
    try {
      window.sessionStorage.removeItem(this.guidedBaseSessionKey(key));
      return true;
    } catch (_) {
      return false;
    }
  },
  guidedArtSessionKey(key) {
    return `${GUIDED_ART_SESSION_PREFIX}${key}`;
  },
  readGuidedArtSession(key, fallback = null) {
    try {
      const value = window.sessionStorage.getItem(this.guidedArtSessionKey(key));
      return value === null ? fallback : JSON.parse(value);
    } catch (_) {
      return fallback;
    }
  },
  writeGuidedArtSession(key, value) {
    try {
      window.sessionStorage.setItem(this.guidedArtSessionKey(key), JSON.stringify(value));
      return true;
    } catch (_) {
      return false;
    }
  },
  removeGuidedArtSession(key) {
    try {
      window.sessionStorage.removeItem(this.guidedArtSessionKey(key));
      return true;
    } catch (_) {
      return false;
    }
  },
  hasCompatibleBaseInCart(items = this.cart?.items) {
    return (Array.isArray(items) ? items : []).some(item => this.isBuildBaseCartItem(item));
  },
  hasArtPanelInCart(items = this.cart?.items) {
    return (Array.isArray(items) ? items : []).some(item => this.isArtPanelCartItem(item));
  },
  guidedJourneySourceInCart(journey, predicate) {
    const source = journey?.source || {};
    const sourceVariantId = String(source?.variant_id || source?.id || "");
    const sourceHandle = String(source?.product_handle || source?.handle || "");

    if (!sourceVariantId && !sourceHandle) return false;

    return (this.cart?.items || []).some(item => {
      if (typeof predicate === "function" && !predicate(item)) return false;
      const itemVariantId = String(item?.variant_id || item?.id || "");
      const itemHandle = String(item?.product_handle || item?.handle || "");
      return sourceVariantId
        ? itemVariantId === sourceVariantId
        : itemHandle === sourceHandle;
    });
  },
  isGuidedArtPanelCartItem(item) {
    if (!this.isArtPanelCartItem(item)) return false;

    const identity = [
      item?.product_title,
      item?.title,
      item?.handle,
      item?.url
    ].join(" ").toLowerCase();

    return !identity.includes("mystery") && !identity.includes("custom patch") && !identity.includes("custom-patch");
  },
  cartAddLineFromResponse(payload, variantID = "") {
    const lines = Array.isArray(payload?.items) ? payload.items : [payload];
    const requestedVariantId = String(variantID || "");
    const responseLine = lines.find(item =>
      item && (!requestedVariantId || String(item?.variant_id || item?.id || "") === requestedVariantId)
    );
    if (responseLine) return responseLine;

    return (this.cart?.items || []).find(item =>
      requestedVariantId && String(item?.variant_id || item?.id || "") === requestedVariantId
    ) || null;
  },
  guidedBaseAnalyticsItem(item = {}) {
    return {
      product_id: String(item?.product_id || ""),
      product_handle: String(item?.product_handle || item?.handle || ""),
      product_title: String(item?.product_title || item?.title || ""),
      variant_id: String(item?.variant_id || item?.id || "")
    };
  },
  publishGuidedBaseEvent(action, item = {}, extra = {}) {
    const eventName = GUIDED_BASE_EVENT_NAMES[action];
    if (!eventName) return null;
    const properties = {
      funnel: "art_to_base",
      ...this.guidedBaseAnalyticsItem(item),
      ...extra
    };
    const payload = { event: eventName, properties };

    try {
      window.igEvents = window.igEvents || [];
      if (typeof window.igEvents.push === "function") window.igEvents.push(payload);
    } catch (_) {}

    try {
      window.dispatchEvent(new CustomEvent("swapwear:guided-base-action", {
        detail: { action, event: eventName, ...properties }
      }));
    } catch (_) {}

    return payload;
  },
  publishGuidedArtEvent(action, item = {}, extra = {}) {
    const eventName = GUIDED_ART_EVENT_NAMES[action];
    if (!eventName) return null;
    const properties = {
      funnel: "base_to_art",
      ...this.guidedBaseAnalyticsItem(item),
      ...extra
    };
    const payload = { event: eventName, properties };

    try {
      window.igEvents = window.igEvents || [];
      if (typeof window.igEvents.push === "function") window.igEvents.push(payload);
    } catch (_) {}

    try {
      window.dispatchEvent(new CustomEvent("swapwear:guided-art-action", {
        detail: { action, event: eventName, ...properties }
      }));
    } catch (_) {}

    return payload;
  },
  activeGuidedBaseJourney() {
    const journey = this.readGuidedBaseSession("journey", null);
    const startedAt = Number(journey?.started_at || 0);
    if (!journey || !startedAt || Date.now() - startedAt > GUIDED_BASE_JOURNEY_TTL_MS) {
      this.removeGuidedBaseSession("journey");
      this.removeGuidedBaseSession("collection-viewed");
      this.removeGuidedBaseSession("prompt-viewed");
      this._guidedBasePromptViewTracked = false;
      return null;
    }
    return journey;
  },
  activeGuidedArtJourney() {
    const journey = this.readGuidedArtSession("journey", null);
    const startedAt = Number(journey?.started_at || 0);
    if (!journey || !startedAt || Date.now() - startedAt > GUIDED_BASE_JOURNEY_TTL_MS) {
      this.removeGuidedArtSession("journey");
      this.removeGuidedArtSession("collection-viewed");
      this.removeGuidedArtSession("prompt-viewed");
      this._guidedArtPromptViewTracked = false;
      return null;
    }
    return journey;
  },
  syncGuidedBasePromptWithCart() {
    if (!this.guided_base_prompt) return;
    const hasGuidedPanel = (this.cart?.items || []).some(item => this.isGuidedArtPanelCartItem(item));
    if (this.hasCompatibleBaseInCart() || !hasGuidedPanel) {
      this.guided_base_prompt = false;
      this.guided_base_prompt_item = null;
      this.removeGuidedBaseSession("prompt-viewed");
      this._guidedBasePromptViewTracked = false;
    }
  },
  syncGuidedArtPromptWithCart() {
    if (!this.guided_art_prompt) return;
    if (!this.hasCompatibleBaseInCart() || this.hasArtPanelInCart()) {
      this.guided_art_prompt = false;
      this.guided_art_prompt_item = null;
      this.removeGuidedArtSession("prompt-viewed");
      this._guidedArtPromptViewTracked = false;
    }
  },
  handleSuccessfulGuidedCartAdd(addedItem) {
    const responseItem = addedItem || {};
    const variantId = responseItem?.variant_id || responseItem?.id || "";
    const hydratedItem = (this.cart?.items || []).find(item =>
      variantId && String(item?.variant_id || item?.id || "") === String(variantId)
    );
    const item = hydratedItem || this.cartAddLineFromResponse(responseItem, variantId) || responseItem;

    if (this.isBuildBaseCartItem(item)) {
      const journey = this.activeGuidedBaseJourney();
      let completedJourney = false;

      if (journey) {
        this.removeGuidedBaseSession("journey");
        this.removeGuidedBaseSession("collection-viewed");
        this.removeGuidedBaseSession("prompt-viewed");
        this._guidedBasePromptViewTracked = false;
        if (this.guidedJourneySourceInCart(journey, candidate => this.isGuidedArtPanelCartItem(candidate))) {
          this.publishGuidedBaseEvent("add", item, {
            source_product_handle: String(journey?.source?.product_handle || "")
          });
          completedJourney = true;
        }
      }

      this.guided_base_prompt = false;
      this.guided_base_prompt_item = null;

      if (this.hasArtPanelInCart()) {
        this.guided_art_prompt = false;
        this.guided_art_prompt_item = null;
        return completedJourney;
      }

      if (this.guided_art_prompt_skipped || this.readGuidedArtSession("skipped", false) === true) {
        this.guided_art_prompt = false;
        this.guided_art_prompt_item = null;
        return completedJourney;
      }

      this.guided_art_prompt_item = this.guidedBaseAnalyticsItem(item);
      this.guided_art_prompt = true;
      return true;
    }

    if (!this.isArtPanelCartItem(item)) return false;

    const journey = this.activeGuidedArtJourney();
    let completedJourney = false;

    if (journey) {
      this.removeGuidedArtSession("journey");
      this.removeGuidedArtSession("collection-viewed");
      this.removeGuidedArtSession("prompt-viewed");
      this._guidedArtPromptViewTracked = false;
      if (this.guidedJourneySourceInCart(journey, candidate => this.isBuildBaseCartItem(candidate))) {
        this.publishGuidedArtEvent("add", item, {
          source_product_handle: String(journey?.source?.product_handle || "")
        });
        completedJourney = true;
      }
    }

    this.guided_art_prompt = false;
    this.guided_art_prompt_item = null;

    if (!this.isGuidedArtPanelCartItem(item)) return completedJourney;

    if (this.hasCompatibleBaseInCart() || this.guided_base_prompt_skipped || this.readGuidedBaseSession("skipped", false) === true) {
      this.guided_base_prompt = false;
      this.guided_base_prompt_item = null;
      return completedJourney;
    }

    this.guided_base_prompt_item = this.guidedBaseAnalyticsItem(item);
    this.guided_base_prompt = true;
    return true;
  },
  trackGuidedBasePromptView() {
    if (!this.guided_base_prompt || !this.cart_drawer) return false;
    if (this._guidedBasePromptViewTracked || this.readGuidedBaseSession("prompt-viewed", false) === true) return false;

    this._guidedBasePromptViewTracked = true;
    this.writeGuidedBaseSession("prompt-viewed", true);
    this.publishGuidedBaseEvent("prompt_view", this.guided_base_prompt_item || {});
    return true;
  },
  dismissGuidedBasePrompt() {
    if (!this.guided_base_prompt) return false;
    const item = this.guided_base_prompt_item || {};
    this.guided_base_prompt = false;
    this.guided_base_prompt_item = null;
    this.guided_base_prompt_skipped = true;
    this.writeGuidedBaseSession("skipped", true);
    this.removeGuidedBaseSession("journey");
    this.removeGuidedBaseSession("collection-viewed");

    if (!this._guidedBaseSkipTracked) {
      this._guidedBaseSkipTracked = true;
      this.publishGuidedBaseEvent("prompt_skip", item);
    }
    return true;
  },
  startGuidedBaseSelection() {
    if (!this.guided_base_prompt) return false;
    const source = this.guided_base_prompt_item || {};
    this.writeGuidedBaseSession("journey", {
      started_at: Date.now(),
      source
    });
    this.removeGuidedBaseSession("collection-viewed");
    this.guided_base_prompt = false;
    this.guided_base_prompt_item = null;
    window.swapwearCloseCartVirtualPage?.({ trackPageView: false });
    this.cart_drawer = false;
    this.enable_body_scrolling = true;
    window.location.assign("/collections/bases");
    return true;
  },
  trackGuidedBaseCollectionView() {
    const journey = this.activeGuidedBaseJourney();
    if (!journey) return false;
    if (this._guidedBaseCollectionViewTracked || this.readGuidedBaseSession("collection-viewed", false) === true) return false;

    this._guidedBaseCollectionViewTracked = true;
    this.writeGuidedBaseSession("collection-viewed", true);
    this.publishGuidedBaseEvent("view", journey?.source || {}, {
      destination: "/collections/bases"
    });
    return true;
  },
  trackGuidedArtPromptView() {
    if (!this.guided_art_prompt || !this.cart_drawer) return false;
    if (this._guidedArtPromptViewTracked || this.readGuidedArtSession("prompt-viewed", false) === true) return false;

    this._guidedArtPromptViewTracked = true;
    this.writeGuidedArtSession("prompt-viewed", true);
    this.publishGuidedArtEvent("prompt_view", this.guided_art_prompt_item || {});
    return true;
  },
  dismissGuidedArtPrompt() {
    if (!this.guided_art_prompt) return false;
    const item = this.guided_art_prompt_item || {};
    this.guided_art_prompt = false;
    this.guided_art_prompt_item = null;
    this.guided_art_prompt_skipped = true;
    this.writeGuidedArtSession("skipped", true);
    this.removeGuidedArtSession("journey");
    this.removeGuidedArtSession("collection-viewed");

    if (!this._guidedArtSkipTracked) {
      this._guidedArtSkipTracked = true;
      this.publishGuidedArtEvent("prompt_skip", item);
    }
    return true;
  },
  startGuidedArtSelection() {
    if (!this.guided_art_prompt) return false;
    const source = this.guided_art_prompt_item || {};
    this.writeGuidedArtSession("journey", {
      started_at: Date.now(),
      source
    });
    this.removeGuidedArtSession("collection-viewed");
    this.guided_art_prompt = false;
    this.guided_art_prompt_item = null;
    window.swapwearCloseCartVirtualPage?.({ trackPageView: false });
    this.cart_drawer = false;
    this.enable_body_scrolling = true;
    window.location.assign("/collections/build-bundle");
    return true;
  },
  trackGuidedArtCollectionView() {
    const journey = this.activeGuidedArtJourney();
    if (!journey) return false;
    if (this._guidedArtCollectionViewTracked || this.readGuidedArtSession("collection-viewed", false) === true) return false;

    this._guidedArtCollectionViewTracked = true;
    this.writeGuidedArtSession("collection-viewed", true);
    this.publishGuidedArtEvent("view", journey?.source || {}, {
      destination: "/collections/build-bundle"
    });
    return true;
  },
  activeGuidedCartPromptKind() {
    if (this.guided_base_prompt && !this.hasCompatibleBaseInCart()) return "base";
    if (this.guided_art_prompt && this.hasCompatibleBaseInCart() && !this.hasArtPanelInCart()) return "art";
    return "";
  },
  guidedCartPromptDisplayKind() {
    return this.activeGuidedCartPromptKind() || this._guidedCartPromptDisplayKind || "base";
  },
  syncGuidedCartPromptEffect() {
    const promptKind = this.activeGuidedCartPromptKind();
    if (promptKind && this.cart_drawer) {
      this._guidedCartPromptDisplayKind = promptKind;
      this.trackGuidedCartPromptView(promptKind);
      if (this._guidedCartPromptFocusKind !== promptKind) {
        this._guidedCartPromptFocusKind = promptKind;
        this.$nextTick(() => window.setTimeout(() => this.$refs.guidedCartPrimary?.focus(), 0));
      }
    } else {
      this._guidedCartPromptFocusKind = "";
    }
  },
  trackGuidedCartPromptView(kind) {
    const promptKind = kind || this.activeGuidedCartPromptKind();
    if (promptKind === "base") return this.trackGuidedBasePromptView();
    if (promptKind === "art") return this.trackGuidedArtPromptView();
    return false;
  },
  dismissGuidedCartPrompt(kind) {
    const promptKind = kind || this.activeGuidedCartPromptKind();
    if (promptKind === "base") return this.dismissGuidedBasePrompt();
    if (promptKind === "art") return this.dismissGuidedArtPrompt();
    return false;
  },
  startGuidedCartPromptSelection(kind) {
    const promptKind = kind || this.activeGuidedCartPromptKind();
    if (promptKind === "base") return this.startGuidedBaseSelection();
    if (promptKind === "art") return this.startGuidedArtSelection();
    return false;
  },
  selectBuildItemFromCartLine(item) {
    if (!item || (!this.isArtPanelCartItem(item) && !this.isBuildBaseCartItem(item))) return false;
    if (String(item.product_title || "").includes("Mystery")) return false;
    if (!this.build_selected) return false;

    const selection = {
      handle: item.handle || "",
      variant_id: item.variant_id || item.id || "",
      custom_id: item?.properties?.custom_id || ""
    };

    this.build_selected.handle = selection.handle;
    this.build_selected.variant_id = selection.variant_id;
    this.build_selected.custom_id = selection.custom_id;

    if (this.isBuildBaseCartItem(item)) {
      const nextBaseIndex = (globals.bases || []).findIndex(base => base.handle === item.handle);
      if (nextBaseIndex >= 0) {
        this.selected_base = nextBaseIndex;
        window.swapwearStorage?.setJSON?.("selected_base", nextBaseIndex);
      }
    }

    try {
      window.dispatchEvent(new CustomEvent("build:item-selected", {
        detail: {
          selection,
          item,
          source: "cart"
        }
      }));
    } catch (_) {}

    return true;
  },
  selectAddedBuildItem(variantID, lineKey = "") {
    const variantId = String(variantID || "");
    if (!variantId) return false;

    const cleanLineKey = String(lineKey || "");
    const addedLine = (this.cart?.items || []).find(item =>
      cleanLineKey &&
      String(item.key || "") === cleanLineKey &&
      (this.isArtPanelCartItem(item) || this.isBuildBaseCartItem(item)) &&
      !String(item.product_title || "").includes("Mystery")
    ) || (this.cart?.items || []).find(item =>
      String(item.variant_id || item.id || "") === variantId &&
      (this.isArtPanelCartItem(item) || this.isBuildBaseCartItem(item)) &&
      !String(item.product_title || "").includes("Mystery")
    );

    return this.selectBuildItemFromCartLine(addedLine);
  },
  async enforceArtPanelLimit(cartData) {
    const updates = {};
    const seenDesigns = new Set();

    (Array.isArray(cartData?.items) ? cartData.items : []).forEach(item => {
      if (!this.isArtPanelCartItem(item)) return;

      const properties = Array.isArray(item.properties) ? Object.fromEntries(item.properties) : (item.properties || {});
      const customId = String(properties.custom_id || "");
      const bundleGroup = properties._bundle_role === 'panel' ? String(properties._bundle_journey || '') : '';
      const designKey = `${item.product_id || item.handle || item.variant_id}:${customId || "standard"}:${bundleGroup}`;

      if (seenDesigns.has(designKey)) {
        updates[item.key] = 0;
        return;
      }

      seenDesigns.add(designKey);
    });

    if (!Object.keys(updates).length) return cartData;

    const response = await window.swapwearFetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },
  // Update cart with fetched data
  async updateCart(openCart, options = {}) {
    if (options.tierToastBefore) {
      this._pendingBundleTierToastState ||= options.tierToastBefore;
    }
    if (this._cartUpdatePromise) {
      this._cartRefreshQueued = true;
      if (openCart) this._cartOpenAfterUpdate = true;
      return this._cartUpdatePromise;
    }

    const shouldOpenCart = openCart || this._cartOpenAfterUpdate;
    const previousBogoState = this.bogoCartState ? this.bogoCartState(this.cart) : null;
    const previousPanelBaseTierState = this.panelBaseTierCartState ? this.panelBaseTierCartState(this.cart) : null;
    const previousBundleTierState = this._pendingBundleTierToastState;
    this._pendingBundleTierToastState = null;
    this._cartRefreshQueued = false;
    this._cartOpenAfterUpdate = false;

    this._cartUpdatePromise = (async () => {
      this.cart_loading = true;

      try {
        const response = await window.swapwearFetch(`${window.Shopify.routes.root}cart.js`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        let data2;
        try {
          data2 = await response.json();
        } catch (_) {
          throw new Error("Cart response was not valid JSON");
        }

        if (!this.isValidCartPayload(data2)) {
          throw new Error("Cart response was empty or malformed");
        }

        data2 = await this.enforceArtPanelLimit(data2);

        if (!this.isValidCartPayload(data2)) {
          throw new Error("Updated cart response was empty or malformed");
        }

        this.cart.items = this.hydrateCartItemsWithArtists(data2.items);
        window.swapwearSyncBuildCartVariantIds?.({ items: this.cart.items });
        this.cart.item_count = data2.item_count;
        this.cart.total_price = data2.total_price;
        this.cart.original_total_price = data2.original_total_price;
        this.cart.total_discount = data2.total_discount;
        this.cart.cart_level_discount_applications = data2.cart_level_discount_applications;

        // CUSTOM SWAP/BASE SALE ROTATION CODE
        this.cart.swaps = this.cart.items.reduce((arr, item) => {
          if (this.isArtPanelCartItem(item) && !item.product_title.includes('Mystery')) {
            const existing = arr.find(i => i.variant_id === item.id);
            if (existing) {
              existing.quantity += item.quantity;
            } else {
              arr.push({
                key: item.key,
                handle: item.handle,
                variant_id: item.id,
                quantity: item.quantity
              });
            }
          }
          return arr;
        }, []);

        this.cart.total_swaps = this.cart.swaps.reduce((sum, item) => sum + item.quantity, 0);

        this.cart.bases = this.cart.items.reduce((arr, item) => {
          if (globals.bases.some(base => base.handle === item.handle)) {
            const existing = arr.find(i => i.variant_id === item.id);
            if (existing) {
              existing.quantity += item.quantity;
            } else {
              arr.push({
                key: item.key,
                handle: item.handle,
                variant_id: item.id,
                quantity: item.quantity
              });
            }
          }
          return arr;
        }, []);

        this.cart.total_bases = this.cart.bases.reduce((sum, item) => sum + item.quantity, 0);
        this.syncGuidedBasePromptWithCart();
        this.syncGuidedArtPromptWithCart();
        this.maybeShowBogoOfferToast(previousBogoState);
        this.maybeShowPanelBaseTierOfferToast(previousPanelBaseTierState);
        if (previousBundleTierState) {
          const currentBundleTierState = this.bundleTierCartState();
          const tierToast = this.bundleTierToastPayload(previousBundleTierState, currentBundleTierState);
          if (this._pendingBundleTierToastState) {
            for (const key of ['panelCount', 'baseCount']) {
              this._pendingBundleTierToastState[key] = Math.max(this._pendingBundleTierToastState[key], currentBundleTierState[key]);
            }
          }
          if (tierToast) this.scheduleBundleTierToast(tierToast);
        }
        if (!this.isBogoOffer() && !this.isPanelBaseTierOffer()) window.__promoCartActivity = false;

        const mystery2 = globals.mystery_data?.[2];
        const mysteryRequirementsFailed = mystery2 && this.cart.total_swaps < mystery2.req;
        const mysteryInactive = !mystery2?.active ||
          (globals.sale_profile?.acquisition === true && !this.hasAppliedAcquisitionCode());

        if (mystery2?.title) {
          this.cart.mystery_2 = this.cart.items.some(item => item.product_title === mystery2.title);
        }

        // Remove mystery swap if requirements not met
        if ((mysteryInactive || mysteryRequirementsFailed) && this.cart.mystery_2 && !this._removingMystery2) {
          const mysteryLine = this.cart.items.find(item => item.product_title === mystery2.title);

          if (mysteryLine) {
            this._removingMystery2 = true;

            mystery2.popup_pass = false;
            window.swapwearStorage?.setJSON?.('mystery_data', globals.mystery_data);

            try {
              await this.changeCartItemQuantity(mysteryLine.key, 0, false, false, { skipUpdateCart: true, skipQueue: true });
            } finally {
              this._removingMystery2 = false;
            }

            setTimeout(() => this.updateCart(false), 0);
            return;
          }
        }
        // CUSTOM ADD SWAP SUM END

        let calcTotal;
        if (this.cart.progress_bar_calculation === "total") {
          calcTotal = this.cart.total_price;
        } else {
          calcTotal = this.cart.original_total_price;
        }

        this.cart.progress_bar_remaining = (this.shipping_profile.freeShippingValue * 100) - calcTotal;
        this.cart.progress_bar_percent = calcTotal / (this.shipping_profile.freeShippingValue) + "%";

        setTimeout(() => {
          this.cart_loading = false;
        }, 200);

        const cartUpsells = document.querySelectorAll(".js-upsell");
        cartUpsells.forEach(function(target) {
          target.style.display = "flex";
        });

        this.cart.items.forEach((item) => {
          const upsellElements = document.querySelectorAll(".js-upsell-" + item.product_id);
          upsellElements.forEach((element) => {
            element.style.display = "none";
          });
        });

        window.dispatchEvent(new CustomEvent("cart:updated", {
          detail: { cart: this.cart }
        }));

        if (shouldOpenCart) {
          this.menu_drawer = false;
          this.age_popup = false;
          this.audio_popup = false;
          this.discount_popup = false;
          this.filter_popup = false;
          this.localization_popup = false;

          let cart_behavior;
          if (window.innerWidth < 768) {
            cart_behavior = this.cart_behavior_mobile;
          } else {
            cart_behavior = this.cart_behavior_desktop;
          }

          switch (cart_behavior) {
            case "alert":
              if (this.cart_drawer) {
                return;
              } else {
                this.cart_alert = true;
                this.cart.alert_delay = "0%";
                setTimeout(() => {
                  this.cart.alert_delay = "100%";
                }, 100);
                setTimeout(() => {
                  this.cart.alert_delay = "0%";
                  this.cart_alert = false;
                }, 3000);
              }
              break;

            case "drawer":
              this.cart_drawer = true;
              break;

            case "redirect":
              window.location.href = "/cart";
              break;
          }
        }
      } catch (error2) {
        console.warn("Cart refresh failed; preserving the last known cart state:", error2);
        this.cart_loading = false;
      } finally {
        const shouldRefreshAgain = this._cartRefreshQueued;
        const shouldOpenQueuedCart = this._cartOpenAfterUpdate;
        this._cartUpdatePromise = null;
        this._cartRefreshQueued = false;
        this._cartOpenAfterUpdate = false;

        if (shouldRefreshAgain) {
          setTimeout(() => this.updateCart(shouldOpenQueuedCart), 0);
        }
      }

      // CUSTOM
      this.maybeAutoAddMystery2Reward();

      if (!this.selectedBuildItemStillInCart()) {
        const nextBuildItem = this.firstSelectableBuildItem();

        this.build_selected.handle = nextBuildItem?.handle || null;
        this.build_selected.variant_id = nextBuildItem?.variant_id || null;
        this.build_selected.custom_id = nextBuildItem?.custom_id || '';

        if (nextBuildItem?.handle && globals.bases.some(base => base.handle === nextBuildItem.handle)) {
          const nextBaseIndex = globals.bases.findIndex(base => base.handle === nextBuildItem.handle);
          if (nextBaseIndex >= 0) {
            this.selected_base = nextBaseIndex;
          }
        }
      }
      //
    })();

    return this._cartUpdatePromise;
  },
  // Call change.js to update cart item then use updateCart()
  async changeCartItemQuantity(key, quantity, openCart = false, refresh = false, options = {}) {
    const changeLineItem = async () => {
      const tierToastBefore = this.bundleTierCartState();
      this.playAudioIfEnabled(this.click_audio);
      this.cart_loading = true;
      if (!options.skipUpdateCart) {
        window.__promoCartActivity = true;
      }

      const requestedQuantity = Math.max(0, Number(quantity) || 0);
      const removalKey = String(key || '');
      const requestedCartItem = (this.cart?.items || []).find(item =>
        String(item?.key || item?.id || item?.variant_id || '') === removalKey
      );
      const removalFeedbackStartedAt = requestedQuantity === 0 && !options.skipUpdateCart
        ? performance.now()
        : 0;
      if (requestedQuantity === 0 && removalKey && !options.skipUpdateCart) {
        this._pendingCartRemovalKeys = {
          ...this._pendingCartRemovalKeys,
          [removalKey]: true
        };
        this.selectNextBuildItemForRemoval(removalKey);
      }

      const formData = {
        id: key.toString(),
        quantity: requestedQuantity.toString()
      };

      let staleKeyRecoveryAttempted = false;

      while (true) {
        try {
          const response = await window.swapwearFetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
              "Content-Type": "application/json"
            }
          });

          if (response.status === 429) {
            throw new Error("Too many cart requests. Please try again.");
          }

          if (!response.ok) {
            let errorPayload = {};
            try {
              errorPayload = await response.json();
            } catch (_) {}
            const invalidLineId = response.status === 400 && /no valid id|line parameter/i.test(
              `${errorPayload.message || ''} ${errorPayload.description || ''}`
            );

            if (invalidLineId && !staleKeyRecoveryAttempted && requestedCartItem) {
              staleKeyRecoveryAttempted = true;
              await this.updateCart(false);

              const requestedVariantId = String(requestedCartItem.variant_id || requestedCartItem.id || '');
              const lineProperties = item => Array.isArray(item?.properties) ? Object.fromEntries(item.properties) : (item?.properties || {});
              const requestedCustomId = String(lineProperties(requestedCartItem).custom_id || '');
              const requestedBundleId = String(lineProperties(requestedCartItem)._bundle_journey || '');
              const refreshedLine = (this.cart?.items || []).find(item =>
                String(item.variant_id || item.id || '') === requestedVariantId &&
                String(lineProperties(item)._bundle_journey || '') === requestedBundleId &&
                String(lineProperties(item).custom_id || '') === requestedCustomId
              );

              if (refreshedLine?.key) {
                formData.id = String(refreshedLine.key);
                continue;
              }

              if (requestedQuantity === 0) {
                if (removalKey && this._pendingCartRemovalKeys?.[removalKey]) {
                  const nextPendingRemovals = { ...this._pendingCartRemovalKeys };
                  delete nextPendingRemovals[removalKey];
                  this._pendingCartRemovalKeys = nextPendingRemovals;
                }
                this.cart_loading = false;
                return { ok: true, recovered: true };
              }
            }
            throw new Error(errorPayload.description || `HTTP error! status: ${response.status}`);
          }

          let data2;
          try {
            data2 = await response.json();
          } catch (_) {
            throw new Error("Cart change response was not valid JSON");
          }
          if (!this.isValidCartPayload(data2)) {
            throw new Error("Cart change response was empty or malformed");
          }
          if (removalFeedbackStartedAt) {
            const minimumRemovalFeedbackMs = 320;
            const remainingFeedbackMs = minimumRemovalFeedbackMs - (performance.now() - removalFeedbackStartedAt);
            if (remainingFeedbackMs > 0) {
              await new Promise(resolve => setTimeout(resolve, remainingFeedbackMs));
            }
          }
          this.cart.items = this.hydrateCartItemsWithArtists(data2.items);
          window.swapwearSyncBuildCartVariantIds?.({ items: this.cart.items });
          window.dispatchEvent(new CustomEvent("build-cart-selection:updated"));
          this.cart.item_count = data2.item_count;
          this.cart.total_price = data2.total_price;
          this.cart.original_total_price = data2.original_total_price;
          this.cart.total_discount = data2.total_discount;
          this.cart.cart_level_discount_applications = data2.cart_level_discount_applications;

          if (refresh) {
            window.location.reload();
            return { ok: true, cart: data2 };
          }

          this.playAudioIfEnabled(this.success_audio);

          if (!options.skipUpdateCart) {
            if (options.deferRefresh || requestedQuantity === 0) {
              this.updateCart(openCart, { tierToastBefore })
                .catch(error2 => {
                  console.error("Deferred cart refresh failed:", error2);
                })
                .finally(() => {
                  if (removalKey && this._pendingCartRemovalKeys?.[removalKey]) {
                    const nextPendingRemovals = { ...this._pendingCartRemovalKeys };
                    delete nextPendingRemovals[removalKey];
                    this._pendingCartRemovalKeys = nextPendingRemovals;
                  }
                });
            } else {
              await this.updateCart(openCart, { tierToastBefore });
            }
          } else {
            this.cart_loading = false;
          }

          return { ok: true, cart: data2 };
        } catch (error2) {
          console.error("Error:", error2);
          if (removalKey && this._pendingCartRemovalKeys?.[removalKey]) {
            const nextPendingRemovals = { ...this._pendingCartRemovalKeys };
            delete nextPendingRemovals[removalKey];
            this._pendingCartRemovalKeys = nextPendingRemovals;
          }
          this.error_message = this.cartErrorMessage(error2, "Something went wrong updating your cart.");
          this.show_alert = true;
          this.cart_loading = false;
          return { ok: false, error: error2 };
        }
      }
    };

    if (options.skipQueue) {
      return changeLineItem();
    }

    return this.runCartMutation(changeLineItem);
  },
  // Load quick add with section render
  async fetchAndRenderQuickEdit(product_handle, template, variantId, quantity, lineKey = variantId) {
    this._quickEditController?.abort?.();
    const requestId = Number(this._quickEditRequestId || 0) + 1;
    const controller = new AbortController();
    this._quickEditRequestId = requestId;
    this._quickEditController = controller;
    const requestTimeout = window.setTimeout(() => controller.abort(), 10000);
    const isCurrentRequest = () => this._quickEditRequestId === requestId;
    this.edit_variant = variantId;
    this.edit_key = lineKey;
    this.edit_quantity = quantity;
    this.quick_edit_handle = product_handle;
    this.quick_edit_popup = false;

    const quickEditContainerId = (() => {
      switch (template) {
        case "build-desktop-tray":
          return "js-quickEdit-build-tray-desktop";
        case "build-tray":
          return "js-quickEdit-build-tray";
        case "cart-drawer":
        case "cart-page":
          return `js-quickEdit-${template}`;
        default:
          return `js-quickEdit-${template}-${product_handle}`;
      }
    })();
    const quickAddContainer = document.getElementById(quickEditContainerId) || document.getElementById(`js-quickEdit-${template}-${product_handle}`);

    this.clearQuickEditContainers(quickAddContainer);
    this.clearRenderedSectionContainer(quickAddContainer);

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${product_handle}?section_id=quick-edit`,
        { signal: controller.signal }
      );
      if (!isCurrentRequest()) return false;
      if (!response.ok) {
        this.quick_edit_handle = false;
        this.quick_edit_popup = false;
        this.enable_body_scrolling = true;
        if (template === "build-tray" || template === "build-desktop-tray") {
          console.warn(`Quick edit unavailable for ${product_handle}; product section returned ${response.status}.`);
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseHtml = await response.text();
      if (!isCurrentRequest()) return false;
      this.enable_body_scrolling = false;
      if (quickAddContainer) {
        quickAddContainer.innerHTML = responseHtml;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (isCurrentRequest()) this.quick_edit_popup = true;
          });
        });
        return true;
      } else {
        console.error(`Element 'js-quickEdit-${template}-${product_handle}' not found.`);
        return false;
      }
    } catch (error2) {
      if (error2?.name !== "AbortError" && isCurrentRequest()) console.error(error2);
      return false;
    } finally {
      window.clearTimeout(requestTimeout);
      if (isCurrentRequest() && this._quickEditController === controller) {
        this._quickEditController = null;
      }
    }
  },
  clearQuickEditContainers(activeContainer = null) {
    document.querySelectorAll('[id^="js-quickEdit-"]').forEach((container) => {
      if (container !== activeContainer) {
        this.clearRenderedSectionContainer(container);
      }
    });
  },
  clearRenderedSectionContainer(container) {
    if (!container) return;
    if (window.Alpine?.destroyTree) {
      Array.from(container.children).forEach(child => window.Alpine.destroyTree(child));
    }
    container.replaceChildren();
  },
  closeQuickEdit() {
    this._quickEditRequestId = Number(this._quickEditRequestId || 0) + 1;
    this._quickEditController?.abort?.();
    this._quickEditController = null;
    this.quick_edit_popup = false;
    this.quick_edit_handle = false;
    this.enable_body_scrolling = true;
    this.clearQuickEditContainers();
  },
  // Load quick add with section render
  async fetchAndRenderQuickAdd(product_handle, template) {
    window.clearTimeout(this._quickAddCleanupTimer);
    this._quickAddCleanupTimer = null;
    this._quickAddController?.abort?.();
    const requestId = Number(this._quickAddRequestId || 0) + 1;
    const controller = new AbortController();
    this._quickAddRequestId = requestId;
    this._quickAddController = controller;
    const requestTimeout = window.setTimeout(() => controller.abort(), 10000);
    const isCurrentRequest = () => this._quickAddRequestId === requestId;
    this.quick_add_handle = product_handle;
    const quickAddContainer = document.getElementById(`js-quickAdd-${template}-${product_handle}`);
    this.clearQuickAddContainers(quickAddContainer);
    this.clearRenderedSectionContainer(quickAddContainer);
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${product_handle}?section_id=quick-add`,
        { signal: controller.signal }
      );
      if (!isCurrentRequest()) return false;
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseHtml = await response.text();
      if (!isCurrentRequest()) return false;
      this.enable_body_scrolling = false;
      if (quickAddContainer) {
        quickAddContainer.innerHTML = responseHtml;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (isCurrentRequest()) this.quick_add_popup = true;
          });
        });
        return true;
      } else {
        console.error(`Element 'js-quickAdd-${template}-${product_handle}' not found.`);
        return false;
      }
    } catch (error2) {
      if (error2?.name !== "AbortError" && isCurrentRequest()) console.error(error2);
      return false;
    } finally {
      window.clearTimeout(requestTimeout);
      if (isCurrentRequest() && this._quickAddController === controller) {
        this._quickAddController = null;
      }
    }
  },
  closeQuickAdd() {
    const requestId = Number(this._quickAddRequestId || 0) + 1;
    this._quickAddRequestId = requestId;
    this._quickAddController?.abort?.();
    this._quickAddController = null;
    this.quick_add_popup = false;
    this.quick_add_handle = false;
    this.enable_body_scrolling = true;
    window.clearTimeout(this._quickAddCleanupTimer);
    this._quickAddCleanupTimer = window.setTimeout(() => {
      if (this._quickAddRequestId !== requestId || this.quick_add_popup) return;
      this.clearQuickAddContainers();
      this._quickAddCleanupTimer = null;
    }, 300);
  },
  clearQuickAddContainers(activeContainer = null) {
    document.querySelectorAll('[id^="js-quickAdd-"]').forEach((container) => {
      if (container !== activeContainer) {
        this.clearRenderedSectionContainer(container);
      }
    });
  },
  // Call add.js to add cart item then use updateCart()
  async editCartItem(oldQuantity, oldVariantId, newVariantId, sellingPlanId, newQuantity = oldQuantity, oldLineKey = oldVariantId) {
    return this.runCartMutation(async () => {
      const tierToastBefore = this.bundleTierCartState();
      this.cart_loading = true;
      this.playAudioIfEnabled(this.click_audio);
      window.__promoCartActivity = true;
      const oldCartLineId = (oldLineKey || oldVariantId).toString();
      const requestedQuantity = Math.max(0, Number(newQuantity) || 0);
      const quantityToAdd = requestedQuantity;
      const cartItemsBeforeReplacement = Array.isArray(this.cart?.items)
        ? this.cart.items.slice()
        : [];
      let replacementStage = "idle";

      if (String(oldVariantId) === String(newVariantId)) {
        return this.changeCartItemQuantity(oldCartLineId, quantityToAdd, false, false, { skipQueue: true });
      }

      const oldFormData = {
        id: oldCartLineId,
        quantity: "0"
      };
      const newFormData = sellingPlanId == 0 ? {
        id: newVariantId.toString(),
        quantity: quantityToAdd.toString()
      } : {
        id: newVariantId.toString(),
        quantity: quantityToAdd.toString(),
        selling_plan: sellingPlanId.toString()
      };
      try {
        if (quantityToAdd === 0) {
          const removeResponse = await window.swapwearFetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: "POST",
            body: JSON.stringify(oldFormData),
            headers: { "Content-Type": "application/json" }
          });
          if (!removeResponse.ok) {
            const removeError = await removeResponse.json().catch(() => ({}));
            throw new Error(removeError.description || `HTTP error! status: ${removeResponse.status}`);
          }
          this.playAudioIfEnabled(this.success_audio);
          await this.updateCart(false);
          return { ok: true };
        }

        // Preserve the converting cart line until Shopify confirms its
        // replacement. If cleanup later fails, showing both items is safer than
        // silently deleting the shopper's original selection.
        replacementStage = "adding";
        const addResponse = await window.swapwearFetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: JSON.stringify(newFormData),
          headers: {
            "Content-Type": "application/json"
          }
        });
        const addData = await addResponse.json().catch(() => ({}));
        if (!addResponse.ok) {
          throw new Error(addData.description || `HTTP error! status: ${addResponse.status}`);
        }

        const addedItems = Array.isArray(addData?.items) ? addData.items : [addData];
        const addedLine = addedItems.find(item =>
          String(item?.variant_id || item?.id || "") === String(newVariantId)
        ) || addedItems[0] || null;
        const addedLineKey = String(addedLine?.key || "");
        const priorAddedLine = addedLineKey
          ? cartItemsBeforeReplacement.find(item => String(item?.key || "") === addedLineKey)
          : null;
        const priorAddedLineQuantity = Math.max(0, Number(priorAddedLine?.quantity) || 0);

        replacementStage = "removing-original";
        const oldResponse = await window.swapwearFetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: "POST",
          body: JSON.stringify(oldFormData),
          headers: { "Content-Type": "application/json" }
        });
        if (!oldResponse.ok) {
          const oldError = await oldResponse.json().catch(() => ({}));
          let replacementRolledBack = false;

          // If Shopify accepted the new option but rejected removal of the old
          // line, restore the target line to its prior quantity. This keeps a
          // retry from adding the replacement a second time.
          if (addedLineKey) {
            try {
              const rollbackResponse = await window.swapwearFetch(`${window.Shopify.routes.root}cart/change.js`, {
                method: "POST",
                body: JSON.stringify({ id: addedLineKey, quantity: priorAddedLineQuantity }),
                headers: { "Content-Type": "application/json" }
              });
              replacementRolledBack = rollbackResponse.ok;
            } catch (_) {}
          }

          const removalMessage = oldError.description || oldError.message || "The original cart item could not be removed.";
          const cleanupError = new Error(replacementRolledBack
            ? `${removalMessage} Your original selection was kept.`
            : `${removalMessage} The new option may also be in your cart; please review it before checkout.`);
          cleanupError.cartReplacementNeedsReview = !replacementRolledBack;
          throw cleanupError;
        }

        replacementStage = "complete";
        this.playAudioIfEnabled(this.success_audio);
        await this.updateCart(false, { tierToastBefore });
        return { ok: true, data: addData };
      } catch (error2) {
        console.error("Error:", error2);
        // A network failure during either half of a replacement is ambiguous
        // even after bounded reconciliation. Do not leave the modal ready to
        // replay the add; refresh/open the cart so the shopper can confirm state.
        const ambiguousReplacement = error2?.swapwearFailureType === "network" &&
          (replacementStage === "adding" || replacementStage === "removing-original");
        const needsReview = error2?.cartReplacementNeedsReview === true || ambiguousReplacement;
        this.error_message = this.cartErrorMessage(
          error2,
          needsReview
            ? "We couldn't finish that edit. Please review your cart before checkout."
            : "We couldn't update that cart item. Your original selection was kept."
        );
        this.show_alert = true;
        await this.updateCart(needsReview);
        this.cart_loading = false;
        return needsReview
          ? { ok: true, partial: true, error: error2 }
          : { ok: false, error: error2 };
      }
    });
  },
  // Add multiple items to cart, used for cart sharing
  async addCartItems(items) {
    const normalizedItems = (Array.isArray(items) ? items : [])
      .map(item => ({
        id: Number(item?.variantId || item?.id || 0),
        quantity: Math.max(1, Math.min(100, Math.trunc(Number(item?.quantity) || 1)))
      }))
      .filter(item => Number.isSafeInteger(item.id) && item.id > 0);

    if (!normalizedItems.length) return { ok: false, error: new Error("No valid shared-cart items were found.") };

    return this.runCartMutation(async () => {
      const tierToastBefore = this.bundleTierCartState();
      this.cart_loading = true;
      this.playAudioIfEnabled(this.click_audio);
      try {
        const response = await window.swapwearFetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: normalizedItems })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.description || data.message || "The shared cart could not be added.");
        }

        this.playAudioIfEnabled(this.success_audio);
        await this.updateCart(true, { tierToastBefore });
        return { ok: true, data };
      } catch (error) {
        this.error_message = this.cartErrorMessage(error, "The shared cart could not be added.");
        this.show_alert = true;
        this.cart_loading = false;
        return { ok: false, error };
      }
    });
  },
  // Call add.js to add cart item then use updateCart()
  async addCartItem(variantID, sellingPlanId, quantity, openCart, options = {}) {
    return this.runCartMutation(async () => {
      const tierToastBefore = this.bundleTierCartState();
      this.playAudioIfEnabled(this.click_audio);
      window.__promoCartActivity = true;

      const preorderProperties = {
        ...(window.swapwearPreorderProperties?.(variantID) || {}),
        ...(window.swapwearBundleJourney?.panelProperties(options.bundlePanel) || {})
      };
      let formData;
      if (sellingPlanId == 0) {
        formData = {
          items: [
            {
              id: variantID,
              quantity,
              ...(Object.keys(preorderProperties).length ? { properties: preorderProperties } : {})
            }
          ]
        };
      } else {
        formData = {
          items: [
            {
              id: variantID,
              quantity,
              selling_plan: sellingPlanId,
              ...(Object.keys(preorderProperties).length ? { properties: preorderProperties } : {})
            }
          ]
        };
      }

      try {
        const response = await window.swapwearFetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        });

        const data2 = await response.json();

        if (response.status === 200) {
          const addedItems = Array.isArray(data2?.items) ? data2.items : [data2];
          const addedLine = addedItems.find(item =>
            String(item?.variant_id || item?.id || "") === String(variantID)
          );

          window.__buildCartVariantIds = window.__buildCartVariantIds || new Set();
          window.__buildCartVariantIds.add(String(variantID));
          window.dispatchEvent(new CustomEvent("build-cart-selection:updated"));

          this.playAudioIfEnabled(this.success_audio);

          if (options.deferRefresh) {
            // Collection product modals only need Shopify to confirm the add before
            // they can close. Reconcile discounts and the full reactive cart in the
            // background so this interaction does not get slower as the cart grows.
            this.selectBuildItemFromCartLine(addedLine);
            this.updateCart(openCart, { tierToastBefore }).catch(error2 => {
              console.error("Deferred cart refresh failed:", error2);
            });
          } else {
            await this.updateCart(openCart, { tierToastBefore });
            this.selectAddedBuildItem(variantID, addedLine?.key || "");
          }

          this.handleSuccessfulGuidedCartAdd(addedLine);

          return { ok: true, data: data2, addedLine };
        } else {
          this.error_message = data2.description || "Unable to add item to cart.";
          this.show_alert = true;
          return { ok: false, data: data2 };
        }
      } catch (error2) {
        console.error("Error:", error2);
        this.error_message = this.cartErrorMessage(error2, "Unable to add item to cart.");
        this.show_alert = true;
        this.cart_loading = false;
        return { ok: false, error: error2 };
      }
    });
  },
  // Add cart item by submitting form
  async submitCartForm(form) {
    return this.runCartMutation(async () => {
      const tierToastBefore = this.bundleTierCartState();
      this.cart_loading = true;
      this.enable_body_scrolling = true;
      this.playAudioIfEnabled(this.click_audio);
      const formData = new FormData(form);
      const requestedVariantId = formData.get("id");
      const preorderProperties = window.swapwearPreorderProperties?.(formData.get("id")) || {};
      for (const [key, value] of Object.entries(preorderProperties)) {
        formData.set(`properties[${key}]`, value);
      }
      if (formData.get("selling_plan") === "0") formData.delete("selling_plan");

      try {
        const response = await window.swapwearFetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.description || data.message || "Unable to add item to cart.");
        }

        this.playAudioIfEnabled(this.success_audio);
        await this.updateCart(true, { tierToastBefore });
        const addedLine = this.cartAddLineFromResponse(data, requestedVariantId);
        this.handleSuccessfulGuidedCartAdd(addedLine);
        return { ok: true, data, addedLine };
      } catch (error) {
        console.error("Error:", error);
        this.error_message = this.cartErrorMessage(error, "Unable to add item to cart.");
        this.show_alert = true;
        this.cart_loading = false;
        return { ok: false, error };
      }
    });
  },
  // Confirm a shared discount with the theme toast. The `dt` parameter is the
  // complete, campaign-controlled toast message.
  // e.g. /discount/SAVE10?dt=$10+OFF+code+applied!
  handleSharedDiscount() {
    const discountCode = this.getCookie("discount_code");
    const discountText = String(urlParams.get("dt") || "").trim();
    if (discountText) {
      if (discountCode) this.discount_code = discountCode;
      this.discount_text = discountText;

      // The discount redirect lands while the root app and initial cart refresh
      // are still settling. Present after that startup work so the confirmation
      // cannot be queued behind or reset by another initial notification.
      setTimeout(() => {
        this.presentToast({
          type: "discount",
          message: discountText,
          icon: "check",
          className: "custom-toast-sms--savings",
          timeout: 6000
        });
      }, 600);

      // Prevent the same confirmation from replaying on refresh while keeping
      // unrelated campaign and navigation parameters intact.
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("dt");
      window.history.replaceState({}, "", `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    }
  },
  // Add items to cart if cartshare url available
  handleSharedCart() {
    if (!location.search.includes("cartshare")) return;

    const segments = location.search.substring(1).split("&").filter(Boolean);
    const retainedSegments = [];
    const items = [];
    const safeDecode = (value) => {
      try {
        return decodeURIComponent(value);
      } catch (_) {
        return value;
      }
    };

    segments.forEach(segment => {
      const values = {};
      segment.split(",").forEach(property => {
        const separator = property.indexOf(":");
        if (separator < 0) return;
        const key = safeDecode(property.slice(0, separator));
        const value = safeDecode(property.slice(separator + 1));
        values[key] = value;
      });

      const variantId = Number(values.id);
      if (values.cartshare === "true" && Number.isSafeInteger(variantId) && variantId > 0) {
        items.push({ variantId, quantity: Number(values.q) || 1 });
      } else {
        retainedSegments.push(segment);
      }
    });

    if (!items.length) return;

    // Consume the import before its network work begins so refresh/back-forward
    // cannot add the same shared cart a second time.
    const cleanSearch = retainedSegments.length ? `?${retainedSegments.join("&")}` : "";
    window.history.replaceState({}, "", `${window.location.pathname}${cleanSearch}${window.location.hash}`);
    this.addCartItems(items);
  },
  // Generate url with query string based on cart contents
  generateUrl() {
    const serialize = (obj) => {
      return Object.entries(obj).reduce((str, [key, value]) => str.concat(`${encodeURIComponent(key)}:${encodeURIComponent(value.toString())},`), "").slice(0, -1);
    };
    const filteredCart = this.cart.items.map((item) => {
      return {
        cartshare: true,
        id: item.variant_id,
        q: item.quantity
      };
    });
    const queryString = filteredCart.map(serialize).join("&");
    return `${window.location.origin}?${queryString}`;
  },
  saleWindowActive(profile = globals.sale_profile || {}) {
    if (!profile || Number(profile?.id || 0) <= 0 || String(profile?.type || '').toLowerCase() === 'none') return false;
    if (profile.active === false) return false;

    const start = profile?.start ? new Date(profile.start).getTime() : 0;
    const end = profile?.end ? new Date(profile.end).getTime() : 0;
    const now = Date.now();

    if (start && now < start) return false;
    if (end && now >= end) return false;

    return true;
  },
  saleOfferType(profile = globals.sale_profile || {}) {
    return String(profile?.type || profile?.offer?.type || '').toLowerCase();
  },
  isBogoOffer(profile = globals.sale_profile || {}) {
    return this.saleOfferType(profile) === 'bogo';
  },
  isPanelBaseTierOffer(profile = globals.sale_profile || {}) {
    return this.saleOfferType(profile) === 'panel_base_tier';
  },
  panelBaseTierConfig(profile = globals.sale_profile || {}) {
    const offer = profile?.offer || {};
    const validQuantity = (value) => {
      const number = Number(value);
      return Number.isInteger(number) && number > 0 ? number : 0;
    };
    const validPercentage = (value) => {
      const number = Number(value);
      return Number.isFinite(number) && number > 0 && number <= 100 ? number : 0;
    };
    const rawBase = offer?.tier_1 || {};
    const normalizedBase = {
      panelQuantity: validQuantity(rawBase?.panel_quantity),
      baseQuantity: validQuantity(rawBase?.base_quantity),
      percentageOff: validPercentage(rawBase?.percentage_off),
      usesPerOrder: validQuantity(rawBase?.uses_per_order) || 1
    };
    const baseOffer = normalizedBase.panelQuantity && normalizedBase.baseQuantity && normalizedBase.percentageOff
      ? normalizedBase
      : null;
    const panelTiers = (Array.isArray(offer?.panel_discount_tiers) ? offer.panel_discount_tiers : [])
      .map((tier) => ({
        panelQuantity: validQuantity(tier?.panel_quantity),
        percentageOff: validPercentage(tier?.percentage_off)
      }))
      .filter((tier) => tier.panelQuantity > 0 && tier.percentageOff > 0)
      .sort((a, b) => a.panelQuantity - b.panelQuantity)
      .filter((tier, index, tiers) => index === 0 || tier.panelQuantity !== tiers[index - 1].panelQuantity)
      .slice(0, 2);

    return { baseOffer, panelTiers };
  },
  panelBaseTierRows(profile = globals.sale_profile || {}) {
    const config = this.panelBaseTierConfig(profile);
    const rows = [];
    if (config.baseOffer) {
      rows.push({
        kind: 'base',
        panelQuantity: config.baseOffer.panelQuantity,
        baseQuantity: config.baseOffer.baseQuantity,
        percentageOff: config.baseOffer.percentageOff
      });
    }
    return rows.concat(config.panelTiers.map((tier) => ({ ...tier, kind: 'panels' })));
  },
  panelBaseTierRowTitle(row) {
    if (!row) return '';
    if (row.kind === 'base') {
      return `Your first Swap unlocks ${row.percentageOff}% off your base.`;
    }
    if (Number(row.panelQuantity) === 2) {
      return `Your 2nd and additional Swaps get ${row.percentageOff}% off.`;
    }
    return `Swap ${Number(row.panelQuantity)} and additional Swaps get ${row.percentageOff}% off.`;
  },
  panelBaseTierCartState(cartData = this.cart, profile = globals.sale_profile || {}) {
    const config = this.panelBaseTierConfig(profile);
    const rawPanelCount = Number(cartData?.total_swaps);
    const eligibleQuantityReliable = Number.isFinite(rawPanelCount);
    const panelCount = eligibleQuantityReliable ? Math.max(0, rawPanelCount) : 0;
    const reachedPanelTiers = config.panelTiers.filter((tier) => panelCount >= tier.panelQuantity);
    const currentPanelTier = reachedPanelTiers[reachedPanelTiers.length - 1] || null;
    const nextPanelTier = config.panelTiers.find((tier) => panelCount < tier.panelQuantity) || null;
    const baseUnlocked = Boolean(config.baseOffer && panelCount >= config.baseOffer.panelQuantity);
    const target = config.panelTiers[config.panelTiers.length - 1]?.panelQuantity || config.baseOffer?.panelQuantity || 0;
    return {
      ...config,
      eligibleQuantityReliable,
      panelCount,
      baseUnlocked,
      currentPanelTier,
      nextPanelTier,
      target,
      highestUnlocked: Boolean(config.panelTiers.length && !nextPanelTier),
      hasAny: panelCount > 0 || Number(cartData?.item_count || 0) > 0
    };
  },
  panelBaseTierPopupAllowed(cartData = this.cart, profile = globals.sale_profile || {}) {
    if (!this.isPanelBaseTierOffer(profile)) return true;
    const state = this.panelBaseTierCartState(cartData, profile);
    return !(state.target > 0 && state.panelCount > state.target);
  },
  panelBaseTierProgressMessage(state = this.panelBaseTierCartState()) {
    if (!state?.eligibleQuantityReliable) return '';
    const base = state.baseOffer;
    if (base && !state.baseUnlocked) {
      const remaining = Math.max(0, base.panelQuantity - state.panelCount);
      return `Add ${this.quantityLabel(remaining, 'Swap')} to unlock ${base.percentageOff}% off a base.`;
    }
    if (state.nextPanelTier) {
      const remaining = Math.max(0, state.nextPanelTier.panelQuantity - state.panelCount);
      const prefix = state.currentPanelTier
        ? `${state.currentPanelTier.percentageOff}% off eligible Swaps unlocked.`
        : (state.baseOffer ? 'Your 1st Swap unlocked the base offer.' : 'Keep building your set.');
      const scope = Number(state.nextPanelTier.panelQuantity) === 2 ? 'your 2nd and additional Swaps' : 'eligible Swaps';
      return `${prefix} Add ${this.quantityLabel(remaining, 'more Swap', 'more Swaps')} to unlock ${state.nextPanelTier.percentageOff}% off ${scope}.`;
    }
    if (state.currentPanelTier) {
      const scope = Number(state.currentPanelTier.panelQuantity) === 2 ? 'your 2nd and additional Swaps' : 'eligible Swaps';
      return `${state.currentPanelTier.percentageOff}% off ${scope} unlocked.`;
    }
    if (state.baseUnlocked) return 'Your 1st Swap unlocked the base offer.';
    return '';
  },
  panelBaseTierProgressWidth(state = this.panelBaseTierCartState()) {
    if (!state?.eligibleQuantityReliable || !state?.target) return '0%';
    const percent = Math.min(100, Math.max(0, (state.panelCount / state.target) * 100));
    return `${percent.toFixed(2)}%`;
  },
  maybeShowPanelBaseTierOfferToast(previousState = null) {
    const profile = globals.sale_profile || {};
    if (!this.isPanelBaseTierOffer(profile) || !this.saleWindowActive(profile)) return;

    // Panel/base progress already uses the dedicated sale-card toast. Keep
    // these updates out of the general chat-style notification queue.
    window.__promoCartActivity = false;
    this._toastQueue = this._toastQueue.filter((toast) => toast?.type !== 'panel-base-tier');
    if (this.toast?.show && this.toast?.type === 'panel-base-tier') this.hideToast(false);
  },
  bogoConfig(profile = globals.sale_profile || {}) {
    const source = profile?.bogo || {};
    const offer = profile?.offer || {};
    const numberOrDefault = (value, fallback) => {
      const number = Number(value);
      return Number.isFinite(number) && number > 0 ? number : fallback;
    };

    return {
      buyQuantity: Math.max(1, numberOrDefault(source.buyQuantity ?? offer.buy_quantity, 1)),
      getQuantity: Math.max(1, numberOrDefault(source.getQuantity ?? offer.get_quantity, 1)),
      discountPercentage: Math.min(100, Math.max(1, numberOrDefault(source.discountPercentage ?? offer.discount_percentage, 100)))
    };
  },
  quantityLabel(count, singular, plural = `${singular}s`) {
    const quantity = Number(count || 0);
    return `${quantity} ${quantity === 1 ? singular : plural}`;
  },
  bogoDiscountPhrase(profile = globals.sale_profile || {}) {
    const discount = this.bogoConfig(profile).discountPercentage;
    return discount >= 100 ? 'free' : `${discount}% off`;
  },
  bogoRewardLabel(profile = globals.sale_profile || {}) {
    const config = this.bogoConfig(profile);
    const panelLabel = config.getQuantity === 1 ? 'panel' : 'panels';

    if (config.discountPercentage >= 100 && config.buyQuantity === 1 && config.getQuantity === 1) {
      return 'Free first panel';
    }

    return `Get ${config.getQuantity} ${panelLabel} ${this.bogoDiscountPhrase(profile)}`;
  },
  bogoOfferLabel(profile = globals.sale_profile || {}) {
    return (
      profile?.checkoutLabel ||
      profile?.badge ||
      profile?.discountLabel ||
      profile?.eventLabel ||
      profile?.title ||
      this.bogoRewardLabel(profile)
    );
  },
  bogoOfferDetail(profile = globals.sale_profile || {}) {
    const configured = profile?.detailLine || profile?.accordionContent || profile?.beforeTimerMsg;
    if (configured) return configured;

    const config = this.bogoConfig(profile);
    const baseText = this.quantityLabel(config.buyQuantity, 'base');
    const panelText = this.quantityLabel(config.getQuantity, 'art panel');
    return `Buy ${baseText}, get ${panelText} ${this.bogoDiscountPhrase(profile)}.`;
  },
  bogoCartState(cartData = this.cart, profile = globals.sale_profile || {}) {
    const config = this.bogoConfig(profile);
    const baseCount = Math.max(0, Number(cartData?.total_bases || 0));
    const panelCount = Math.max(0, Number(cartData?.total_swaps || 0));
    const baseRemaining = Math.max(0, config.buyQuantity - baseCount);
    const panelRemaining = Math.max(0, config.getQuantity - panelCount);
    const target = config.buyQuantity + config.getQuantity;
    const current = Math.min(baseCount, config.buyQuantity) + Math.min(panelCount, config.getQuantity);

    return {
      ...config,
      baseCount,
      panelCount,
      baseRemaining,
      panelRemaining,
      current,
      target,
      unlocked: baseRemaining === 0 && panelRemaining === 0,
      hasAny: baseCount > 0 || panelCount > 0 || Number(cartData?.item_count || 0) > 0
    };
  },
  bogoProgressPercent(state = this.bogoCartState()) {
    if (!state?.target) return 0;
    return Math.min(100, Math.max(0, (Number(state.current || 0) / Number(state.target || 1)) * 100));
  },
  bogoProgressWidth(state = this.bogoCartState()) {
    return `${this.bogoProgressPercent(state).toFixed(2)}%`;
  },
  bogoProgressMessage(state = this.bogoCartState(), profile = globals.sale_profile || {}) {
    if (state?.unlocked) return `${this.bogoRewardLabel(profile)} unlocked in your cart.`;

    const reward = this.bogoRewardLabel(profile).toLowerCase();
    const parts = [];
    if (state?.baseRemaining > 0) parts.push(this.quantityLabel(state.baseRemaining, 'base'));
    if (state?.panelRemaining > 0) parts.push(this.quantityLabel(state.panelRemaining, 'art panel'));

    if (!parts.length) return '';
    const needed = parts.length === 1 ? parts[0] : `${parts[0]} and ${parts[1]}`;
    return `Add ${needed} to unlock ${reward}.`;
  },
  bogoToastMessage(state = this.bogoCartState(), previousState = null, profile = globals.sale_profile || {}) {
    if (!state?.hasAny) return '';
    if (state.unlocked && !previousState?.unlocked) return `${this.bogoRewardLabel(profile)} unlocked in your cart.`;
    if (!state.unlocked) return this.bogoProgressMessage(state, profile);
    return '';
  },
  maybeShowBogoOfferToast(previousState = null) {
    if (!window.__promoCartActivity) return;
    const profile = globals.sale_profile || {};
    if (!this.isBogoOffer(profile) || !this.saleWindowActive(profile)) return;
    window.__promoCartActivity = false;

    const state = this.bogoCartState(this.cart, profile);
    const baseChanged = Number(state.baseCount || 0) !== Number(previousState?.baseCount || 0);
    const panelChanged = Number(state.panelCount || 0) !== Number(previousState?.panelCount || 0);
    if (!baseChanged && !panelChanged) return;

    const message = this.bogoToastMessage(state, previousState, profile);
    if (!message) return;

    this.showToast({
      type: 'bogo',
      message,
      icon: state.unlocked ? 'celebrate' : 'info',
      className: state.unlocked ? 'custom-toast-sms--savings' : '',
      timeout: state.unlocked ? 3800 : 3200
    });
  },
  saleOfferProgressActive() {
    const profile = globals.sale_profile || {};
    if (!this.saleWindowActive(profile)) return false;
    if (this.isBogoOffer(profile)) return true;
    if (this.isPanelBaseTierOffer(profile)) {
      const config = this.panelBaseTierConfig(profile);
      return Boolean(config.baseOffer || config.panelTiers.length);
    }
    return this.saleProgressTiers().length > 0;
  },
  // CUSTOM FOR SALE ROTATION
  saleProgressTiers: function() {
    const saleProfile = globals.sale_profile || {};
    const saleType = (saleProfile.type || '').toLowerCase();
    const discount = Number(saleProfile.discount || 0);
    const mode = String(saleProfile.tierMode || saleProfile.offer?.tier_mode || '').toLowerCase();
    const discountsBase = mode === 'panel_and_base';
    const normalizeTier = (tier) => ({
      ...tier,
      discounts_base: mode ? discountsBase : (tier?.discounts_base === true || Number(tier?.req_jackets || 0) > 0),
      req_jackets: mode ? (discountsBase ? 1 : 0) : Number(tier?.req_jackets || 0),
    });

    if (saleType === 'sitewide') {
      if (discount <= 0) return [];

      return [
        { name: 'Starter', req_jackets: discountsBase ? 1 : 0, req_art: 2, discount },
        { name: 'Most Popular', req_jackets: discountsBase ? 1 : 0, req_art: 3, discount },
        { name: 'Best Value', req_jackets: discountsBase ? 1 : 0, req_art: 5, discount },
      ].map(normalizeTier);
    }

    const mysteryTitle = globals.mystery_data?.[2]?.title || '';
    return (Array.isArray(saleProfile.tiers) ? saleProfile.tiers : [])
      .filter(t => !mysteryTitle || !(t?.name || '').includes(mysteryTitle))
      .map(normalizeTier)
      .sort((a, b) => Number(a?.req_art || 0) - Number(b?.req_art || 0));
  },
  visibleSaleProgressTiers: function(tiers = this.saleProgressTiers()) {
    const list = Array.isArray(tiers) ? tiers : [];
    const total = list.length;

    if (total <= 3) return list;

    const sumArt = this.cart.total_swaps;
    const reachedCount = list.filter(t => sumArt >= Number(t?.req_art || 0)).length;
    const maxStart = Math.max(0, total - 3);
    const start = reachedCount <= 2
      ? 0
      : Math.min(reachedCount - 1, maxStart);

    return list.slice(start, start + 3);
  },
  currentAndNextTier: function() {
    const sumArt = this.cart.total_swaps;
    let lastQualifyingTier = null;
    let nextTier = null;

    for (let tier of this.saleProgressTiers()) {
        if (sumArt >= tier.req_art) {
            lastQualifyingTier = tier;
        } else if (!nextTier) {
            nextTier = tier; // The first tier that does not qualify is the next tier
        }
    }
    return { current: lastQualifyingTier, next: nextTier };
  },
  additionalItemsNeeded: function() {
    const { current, next } = this.currentAndNextTier();
    if (!next) return 0;

    const sumArt = this.cart.total_swaps;
    return {
      artNeeded: Math.max(0, next.req_art - sumArt),
      nextDiscount: next.discount,
      nextTier: next
    };
  },
  bundleProgress: function () {
    const sumArt = this.cart.total_swaps;
    const visible = this.visibleSaleProgressTiers();

    if (visible.length === 0) return '0.00%';
    if (visible.length === 1) {
      const requirement = Number(visible[0]?.req_art || 0);
      if (requirement <= 0) return '100.00%';
      const progress = Math.min(100, Math.max(0, (sumArt / requirement) * 100));
      return `${progress.toFixed(2)}%`;
    }

    const first = visible[0]?.req_art ?? 0;
    const last = visible[visible.length - 1]?.req_art ?? 0;

    if (sumArt < first) return '0.00%';
    if (sumArt >= last) return '100.00%';

    let currentIndex = -1;
    for (let i = 0; i < visible.length; i++) {
      if (sumArt >= visible[i].req_art) {
        currentIndex = i;
      }
    }

    if (currentIndex === -1) {
      const next = visible[0].req_art;
      const progress = ((sumArt - first) / (next - first)) * 100;
      return `${progress.toFixed(2)}%`;
    }

    if (currentIndex === visible.length - 1) {
      return '100.00%';
    }

    const current = visible[currentIndex].req_art;
    const next = visible[currentIndex + 1].req_art;
    const progress = ((sumArt - current) / (next - current)) * 100;

    const visibleStep = 100 / (visible.length - 1);
    const base = visibleStep * currentIndex;
    const result = base + (progress / 100 * visibleStep);

    return `${result.toFixed(2)}%`;
  },
  bundleTierCartState(cartData = this.cart) {
    return (Array.isArray(cartData?.items) ? cartData.items : []).reduce((state, item) => {
      const quantity = Math.max(0, Number(item?.quantity) || 0);
      if (this.isArtPanelCartItem(item) && !/mystery/i.test(String(item.product_title || ''))) {
        state.panelCount += quantity;
      }
      if (this.isBuildBaseCartItem(item)) state.baseCount += quantity;
      return state;
    }, { panelCount: 0, baseCount: 0 });
  },
  bundleTierToastCopy(key, replacements = {}) {
    const templates = globals.bundle_tier_toast_messages || {};
    const fallback = {
      progress_one: 'Panel added · Add {{ panels_remaining }} more panel to unlock {{ discount_percentage }}% off',
      progress_many: 'Panel added · Add {{ panels_remaining }} more panels to unlock {{ discount_percentage }}% off',
      progress_requirements: 'Add {{ items_remaining }} to unlock {{ discount_percentage }}% off',
      tier_unlocked: '{{ discount_percentage }}% off panels unlocked!',
      best_unlocked: 'Best panel savings unlocked: {{ discount_percentage }}% off'
    };
    let message = String(templates[key] || fallback[key] || '');
    Object.entries(replacements).forEach(([name, value]) => {
      message = message
        .replaceAll(`{{ ${name} }}`, String(value))
        .replaceAll(`__${name.toUpperCase()}__`, String(value));
    });
    return message;
  },
  bundleTierToastBlocked() {
    const panelModal = document.querySelector('.custom-panel-modal');
    const modalState = panelModal ? window.Alpine?.$data?.(panelModal) : null;
    return Boolean(modalState?.open || modalState?.basePickerOpen ||
      (this.cart_drawer && (this.guided_base_prompt || this.guided_art_prompt)));
  },
  scheduleBundleTierToast(payload) {
    clearTimeout(this._bundleTierToastTimer);
    this._bundleTierToastTimer = setTimeout(() => {
      this._bundleTierToastTimer = null;
      const latestPayload = this.bundleTierToastPayload(payload.previousState);
      if (!latestPayload) return;
      if (this.bundleTierToastBlocked()) {
        this.scheduleBundleTierToast(latestPayload);
        return;
      }
      this.showToast(latestPayload);
    }, 200);
  },
  bundleTierToastPayload(previousState, state = this.bundleTierCartState()) {
    const profile = globals.sale_profile || {};
    if (!previousState || !this.saleWindowActive(profile) || this.saleOfferType(profile) !== 'tier') return null;
    const panelsAdded = state.panelCount > previousState.panelCount;
    const basesAdded = state.baseCount > previousState.baseCount;
    if (!panelsAdded && !basesAdded) return null;

    const tiers = this.saleProgressTiers()
      .map(tier => ({ ...tier, req_art: Number(tier?.req_art || 0), discount: Number(tier?.discount || 0) }))
      .filter(tier => Number.isInteger(tier.req_art) && tier.req_art > 0 && tier.discount > 0 && tier.discount <= 100);
    if (!tiers.length) return null;

    const qualifies = (tier, counts) => counts.panelCount >= tier.req_art && counts.baseCount >= tier.req_jackets;
    const discountFor = counts => tiers.reduce((discount, tier) => qualifies(tier, counts) ? Math.max(discount, tier.discount) : discount, 0);
    const previousDiscount = discountFor(previousState);
    const currentDiscount = discountFor(state);
    const bestDiscount = Math.max(...tiers.map(tier => tier.discount));
    if (currentDiscount > previousDiscount) {
      return {
        type: 'bundle-tier',
        previousState,
        message: this.bundleTierToastCopy(currentDiscount === bestDiscount ? 'best_unlocked' : 'tier_unlocked', { discount_percentage: currentDiscount }),
        icon: 'celebrate',
        className: 'custom-toast-sms--savings',
        timeout: 3500
      };
    }

    const nextTier = tiers.find(tier => tier.discount > currentDiscount && !qualifies(tier, state));
    if (!nextTier || (!panelsAdded && Number(nextTier.req_jackets || 0) <= previousState.baseCount)) return null;
    const panelsRemaining = Math.max(0, nextTier.req_art - state.panelCount);
    const basesRemaining = Math.max(0, nextTier.req_jackets - state.baseCount);
    const requirements = [];
    if (panelsRemaining) requirements.push(this.quantityLabel(panelsRemaining, 'more panel'));
    if (basesRemaining) requirements.push(this.quantityLabel(basesRemaining, 'base'));
    return {
      type: 'bundle-tier',
      previousState,
      message: this.bundleTierToastCopy(basesRemaining || !panelsAdded ? 'progress_requirements' : (panelsRemaining === 1 ? 'progress_one' : 'progress_many'), {
        panels_remaining: panelsRemaining,
        items_remaining: requirements.join(' and '),
        discount_percentage: nextTier.discount
      }),
      icon: 'check',
      timeout: 3000
    };
  },
  mystery_2_popup: false,
  mystery2RewardVariantId(mystery2) {
    const rawVariantId = mystery2?.rewardVariantId?.id || mystery2?.rewardVariantId?.value || mystery2?.rewardVariantId || '';
    const normalizedVariantId = String(rawVariantId).replace('gid://shopify/ProductVariant/', '').trim();
    const variantId = Number(normalizedVariantId);

    return Number.isFinite(variantId) && variantId > 0 ? variantId : 0;
  },
  queueMystery2AutoAdd(variantId, manual = false) {
    if (this._addingMystery2) return;

    this._addingMystery2 = true;
    setTimeout(() => {
      this.autoAddMystery2Reward(variantId, 0, manual);
    }, 0);
  },
  async autoAddMystery2Reward(variantId, attempt = 0, manual = false) {
    if (!variantId) {
      this._addingMystery2 = false;
      return;
    }

    if (this._cartRequestInFlight) {
      if (attempt < 40) {
        setTimeout(() => {
          this.autoAddMystery2Reward(variantId, attempt + 1, manual);
        }, 100);
        return;
      }

      this._addingMystery2 = false;
      return;
    }

    if (!this.canAddMystery2Reward(manual)) {
      this._addingMystery2 = false;
      return;
    }

    try {
      await this.addCartItem(variantId, 0, 1, false);

      const mysteryTitle = globals.mystery_data?.[2]?.title || '';
      const mysteryAdded = this.cart.mystery_2 || this.cart.items.some(item => item.product_title === mysteryTitle);

      if (mysteryAdded) {
        this.showToast({
          type: 'gift',
          message: 'FREE Mystery Swap unlocked with your order',
          icon: 'surprise',
          reward: 'mystery-swap',
        });
      }
    } finally {
      this._addingMystery2 = false;
    }
  },
  handleMystery2OfferClick() {
    const mystery2 = globals.mystery_data?.[2];
    if (!mystery2?.active) return;

    mystery2.popup = false;
    this.mystery_2_popup = false;
    window.swapwearStorage?.setJSON?.('mystery_data', globals.mystery_data);

    if (this.cart.mystery_2) return;
    this.maybeAutoAddMystery2Reward(true);
  },
  hasAppliedAcquisitionCode() {
    const profile = globals.sale_profile;
    return profile?.acquisition === true && Date.parse(profile.end) > Date.now() &&
      this.cart.discount_codes?.some(entry =>
        entry.code?.toUpperCase() === profile.acquisitionCode && entry.applicable === true
      );
  },
  canAddMystery2Reward(manual = false) {
    const mystery2 = globals.mystery_data?.[2];
    const profile = globals.sale_profile;
    const acquisition = profile?.acquisition === true;
    if (acquisition && !this.hasAppliedAcquisitionCode()) return false;
    return Boolean(mystery2?.active && !this.cart.mystery_2 &&
      this.mystery2RewardVariantId(mystery2) && Number(mystery2.req) > 0 &&
      this.cart.total_swaps >= Number(mystery2.req));
  },
  maybeAutoAddMystery2Reward(manual = false) {
    const md = globals.mystery_data;
    const mystery2 = md?.[2];
    const sumArt = this.cart.total_swaps;

    if (!this.canAddMystery2Reward(manual)) return;

    const rewardVariantId = this.mystery2RewardVariantId(mystery2);
    const req = Number(mystery2.req || 0);
    const eligible =
      !this.cart.mystery_2 &&
      !this._addingMystery2 &&
      rewardVariantId &&
      sumArt >= req;

    mystery2.popup = false;
    this.mystery_2_popup = false;

    if (eligible) {
      mystery2.popup_pass = false;
      this.queueMystery2AutoAdd(rewardVariantId, manual);
    }

    window.swapwearStorage?.setJSON?.('mystery_data', md);
  },
  // END CUSTOM FOR SALE ROTATION
};
const search = {
  // Fetch search suggestions and update alpine variables
  async fetchAndUpdateSearch(event, params, resources) {
    this.search_focus_index = "";
    this.search_focus_url = "";
    const buildParams = () => {
      return Object.entries(params).reduce((acc, [key, value]) => value ? acc.concat(key) : acc, []).join();
    };
    const buildResources = () => {
      let resourceArr = [];
      for (const [key, value] of Object.entries(resources)) {
        if (value) {
          resourceArr.push(key.toString());
        }
      }
      const resourcesString = resourceArr.join();
      return resourcesString;
    };
    this.search_term = event.target.value.trim();
    this._predictiveSearchController?.abort?.();
    this.search_loading = true;
    if (!this.search_term) {
      this.search_loading = false;
      this.search_items = [];
      this.search_items_collections = [];
      this.search_items_pages = [];
      this.search_items_articles = [];
      this.search_items_queries = [];
      return;
    }
    const requestId = Number(this._predictiveSearchRequestId || 0) + 1;
    const controller = new AbortController();
    const requestedTerm = this.search_term;
    this._predictiveSearchRequestId = requestId;
    this._predictiveSearchController = controller;
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    const requestUrl = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(requestedTerm)}&resources[type]=${encodeURIComponent(buildResources())}&resources[limit]=6&[options][fields]=${encodeURIComponent(buildParams())}`;
    const isCurrentRequest = () => this._predictiveSearchRequestId === requestId;
    try {
      const response = await fetch(requestUrl, { signal: controller.signal });
      if (!response.ok) {
        throw new Error(response.status.toString());
      }
      const data2 = await response.json();
      if (!isCurrentRequest() || this.search_term !== requestedTerm) return false;
      const { products: products2, collections: collections2, pages, articles, queries } = data2?.resources?.results || {};
      this.search_items = products2 ? products2 : [];
      this.search_items_collections = collections2 ? collections2 : [];
      this.search_items_pages = pages ? pages : [];
      this.search_items_articles = articles ? articles : [];
      this.search_items_queries = queries ? queries : [];
      return true;
    } catch (error2) {
      if (error2?.name !== "AbortError" && isCurrentRequest()) {
        console.warn("Predictive search unavailable:", error2);
      }
      return false;
    } finally {
      window.clearTimeout(timeout);
      if (isCurrentRequest()) {
        this.search_loading = false;
        this.search_focus_index = "";
        this.search_focus_url = "";
        if (this._predictiveSearchController === controller) this._predictiveSearchController = null;
      }
    }
  },
  // Get total search results
  getSearchItems() {
    const totalResults = [
      ...this.search_items_queries,
      ...this.search_items_pages,
      ...this.search_items_articles,
      ...this.search_items_collections,
      ...this.search_items
    ];
    return totalResults;
  },
  // Update selected search index when using arrow keys
  updateSelectedSearch(increment) {
    const searchItems = this.getSearchItems();
    if (this.search_focus_index === "") {
      this.search_focus_index = 0;
    } else {
      this.search_focus_index = (this.search_focus_index + increment + searchItems.length) % searchItems.length;
    }
    this.search_focus_url = searchItems[this.search_focus_index].url;
  },
  // Go to selected search item when using arrow keys
  goToSelectedItem(formElement) {
    if (this.search_focus_url === "") {
      formElement.submit();
    } else {
      window.location.href = this.search_focus_url;
    }
  }
};
const products = {
  // Update page when variant selection changes
  handleProductFormChange(enableUrlParameters, preselectedVariantId) {
    if (!this.product || !Array.isArray(this.product.options) || !Array.isArray(this.product.variants)) {
      return;
    }
    this.setOptionsFromPreselectedVariantId(preselectedVariantId);
    let selectedVariant = this.setSelectedVariant();
    this.setUnavailableOptions();
    this.setDefaultsFromSelectedVariant(selectedVariant);
    this.setallOptionsSelected();
    if (!preselectedVariantId && this.all_options_selected && selectedVariant?.available) {
      window.swapwearBundleJourney?.rememberSelection(this.product, selectedVariant);
    }
    this.reorderProductGallery();
    if (enableUrlParameters && this.all_options_selected) {
      this.updateUrlParameters();
    }
    this.fetchAndRefreshPickup();
    this.calculated_price = this.quantity * this.current_variant_price;
  },
  // If using combined listing this loads and sets title, description and images switching between products
  async handleCombinedListing(productURL, sectionId) {
    if (!productURL || !sectionId) return false;

    const requestId = (window.__combinedListingRequestId || 0) + 1;
    window.__combinedListingRequestId = requestId;
    const previousController = window.__combinedListingController;
    const controller = new AbortController();
    window.__combinedListingController = controller;
    previousController?.abort?.();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    const isCurrentRequest = () => window.__combinedListingRequestId === requestId;
    const targetUrl = new URL(productURL, window.location.origin);
    const sectionUrl = new URL(targetUrl.href);
    sectionUrl.searchParams.set("section_id", sectionId);

    try {
      const response = await fetch(sectionUrl.toString(), { signal: controller.signal });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseHtml = await response.text();
      if (!isCurrentRequest()) return false;

      const html = new DOMParser().parseFromString(responseHtml, "text/html");
      const oldSection = document.querySelector(".js-product");
      const newSection = html.querySelector(".js-product");
      if (!oldSection || !newSection) {
        throw new Error("Combined product response did not include .js-product");
      }

      oldSection.replaceWith(newSection);
      if (!isCurrentRequest()) return false;

      const publicUrl = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
      window.history.replaceState({ combinedListing: true }, "", publicUrl);

      try {
        const productPath = targetUrl.pathname.replace(/\/$/, "");
        const productResponse = await fetch(`${productPath}.json`, { signal: controller.signal });
        if (productResponse.ok && isCurrentRequest()) {
          const productJson = await productResponse.json();
          if (!isCurrentRequest()) return true;
          const productData = productJson?.product || {};
          const previousProductTitle = String(this.product?.title || "");
          if (productData.title) {
            document.title = previousProductTitle && document.title.includes(previousProductTitle)
              ? document.title.replace(previousProductTitle, productData.title)
              : productData.title;
          }
          window.dispatchEvent(new CustomEvent("product:combined-listing-updated", {
            detail: {
              url: publicUrl,
              product: productData,
              title: productData.title || "",
              description: productData.body_html || productData.description || ""
            }
          }));
        }
      } catch (eventError) {
        if (eventError?.name !== "AbortError" && isCurrentRequest()) {
          console.warn("Unable to update dependent product sections", eventError);
        }
      }
      if (!isCurrentRequest()) return false;
      window.swapwearTrackSpaPageChange?.(publicUrl, {
        title: document.title,
        eventName: "product_view"
      });
      return true;
    } catch (error2) {
      if (error2?.name !== "AbortError" && isCurrentRequest()) {
        console.error("Unable to switch combined product:", error2);
      }
      return false;
    } finally {
      window.clearTimeout(timeout);
      if (isCurrentRequest() && window.__combinedListingController === controller) {
        window.__combinedListingController = null;
      }
    }
  },
  // Find options that are not available based on selected options
  setUnavailableOptions() {
    const findMatchingVariants = (excludeOptionIndex) => {
      return this.product.variants.filter((variant) => {
        if (variant.available) {
          return false;
        }
        for (let i = 1; i <= this.product.options.length; i++) {
          if (i === excludeOptionIndex)
            continue;
          const optionKey = `option${i}`;
          if (variant[optionKey].toLowerCase() !== this[`option${i}`].toLowerCase()) {
            return false;
          }
        }
        return true;
      });
    };
    for (let i = 1; i <= this.product.options.length; i++) {
      const matchingVariants = findMatchingVariants(i);
      const unavailableOptionsSet = /* @__PURE__ */ new Set();
      matchingVariants.forEach((variant) => {
        const optionKey = `option${i}`;
        unavailableOptionsSet.add(this.handleize(variant[optionKey]));
      });
      this[`unavailable_options${i}`] = Array.from(unavailableOptionsSet);
    }
  },
  // Set selectedVariant based on selected options
  // This will find the selectedVariant based on selected options
  setSelectedVariant() {
    let optionsSize = this.product.options.length;
    let selectedVariant;
    switch (optionsSize) {
      case 1:
        selectedVariant = this.product.variants.find(
          (variant) => this.handleize(variant.option1) === this.handleize(this.option1)
        );
        break;
      case 2:
        selectedVariant = this.product.variants.find(
          (variant) => this.handleize(variant.option1) === this.handleize(this.option1) && this.handleize(variant.option2) === this.handleize(this.option2)
        );
        break;
      case 3:
        selectedVariant = this.product.variants.find(
          (variant) => this.handleize(variant.option1) === this.handleize(this.option1) && this.handleize(variant.option2) === this.handleize(this.option2) && this.handleize(variant.option3) === this.handleize(this.option3)
        );
        break;
    }
    return selectedVariant;
  },
  // Check if preselectedVariantId exists and set options
  setOptionsFromPreselectedVariantId(preselectedVariantId) {
    if (!this.product || !Array.isArray(this.product.options) || !Array.isArray(this.product.variants)) {
      return;
    }
    let optionsSize = this.product.options.length;
    if (preselectedVariantId) {
      this.current_variant_id = preselectedVariantId;
      const normalizedPreselectedVariantId = String(preselectedVariantId);
      const selectedVariant = this.product.variants.find(
        (variant) => String(variant.id) === normalizedPreselectedVariantId
      );
      if (selectedVariant) {
        switch (optionsSize) {
          case 1:
            this.option1 = this.handleize(selectedVariant.option1);
            break;
          case 2:
            this.option1 = this.handleize(selectedVariant.option1);
            this.option2 = this.handleize(selectedVariant.option2);
            break;
          case 3:
            this.option1 = this.handleize(selectedVariant.option1);
            this.option2 = this.handleize(selectedVariant.option2);
            this.option3 = this.handleize(selectedVariant.option3);
            break;
        }
      }
    }
  },
  // Update values based on selected variant
  setDefaultsFromSelectedVariant(selectedVariant) {
    let formContainer = this.$refs.formContainer;
    if (selectedVariant) {
      this.current_variant_available = selectedVariant.available;
      this.current_variant_exists = true;
      this.current_variant_id = selectedVariant.id;
      this.current_variant_price = selectedVariant.price;
      this.current_variant_compare_price = selectedVariant.compare_at_price;
      this.current_variant_sku = selectedVariant.sku;
      this.current_variant_title = selectedVariant.title;
      const customSelectedVariant = this.variants[this.current_variant_id];
      if (customSelectedVariant && customSelectedVariant.length > 0) {
        this.current_variant_inventory_quantity = customSelectedVariant[0].inventory_quantity;
        this.current_variant_inventory_policy = customSelectedVariant[0].inventory_policy;
      }
      this.current_variant_featured_image_id = selectedVariant.featured_image ? selectedVariant.featured_image.id : null;
      this.current_variant_featured_media_id = selectedVariant.featured_media ? selectedVariant.featured_media.id : null;
      if (selectedVariant.unit_price) {
        this.current_variant_unit_price = selectedVariant.unit_price;
        this.current_variant_unit_label = selectedVariant.unit_price_measurement.reference_unit;
      }
      this.current_variant_has_selling_plan = Array.isArray(selectedVariant.selling_plan_allocations) && selectedVariant.selling_plan_allocations.length > 0;
      if (this.current_variant_has_selling_plan && this.enable_selling_plan_widget) {
        this.current_variant_requires_selling_plan = selectedVariant.requires_selling_plan;
        this.current_variant_selling_group_ids = selectedVariant.selling_plan_allocations.map((allocation) => allocation.selling_plan_group_id);
        this.current_variant_selling_group_ids.push("0");
        this.current_variant_selling_group_id = this.current_variant_selling_group_ids.includes(this.current_variant_selling_group_id) ? this.current_variant_selling_group_id : this.current_variant_selling_group_ids[0];
        let matchingAllocation = selectedVariant.selling_plan_allocations.find(
          (allocation) => allocation.selling_plan_group_id === this.current_variant_selling_group_id && allocation.selling_plan_id === parseInt(this.current_variant_selling_plan_id)
        );
        if (!matchingAllocation) {
          const firstAllocationInGroup = selectedVariant.selling_plan_allocations.find(
            (allocation) => allocation.selling_plan_group_id === this.current_variant_selling_group_id
          );
          if (firstAllocationInGroup) {
            matchingAllocation = firstAllocationInGroup;
            this.current_variant_selling_plan_id = firstAllocationInGroup.selling_plan_id;
          }
        }
        if (matchingAllocation) {
          this.defaultSellingPlanPrice = matchingAllocation.per_delivery_price;
          this.current_variant_price = matchingAllocation.per_delivery_price;
          this.current_variant_compare_price = matchingAllocation.compare_at_price;
          this.current_variant_unit_price = matchingAllocation.unit_price;
        }
        if (this.current_variant_selling_plan_id !== 0) {
          let sellingPlanInput = formContainer.querySelector(".js-" + this.current_variant_selling_plan_id);
          let sellingPlanData = JSON.parse(sellingPlanInput.getAttribute("data-selling-plan"));
          this.current_variant_selling_plan_name = sellingPlanData.name.trim() + ".";
          this.current_variant_selling_plan_description = sellingPlanData.description.trim();
          let savingSummary = "";
          let savingHighlight = "";
          sellingPlanData.price_adjustments.forEach((price_adjustment, index, array) => {
            let savingValue = price_adjustment.value;
            if (savingValue <= 0)
              return;
            let savingsPercentLabel = "";
            let savingsCount = price_adjustment.order_count || "ongoing";
            let punctuation = index === array.length - 1 ? ". " : "";
            let sentenceStart = "Save ";
            switch (price_adjustment.value_type) {
              case "percentage":
                savingsPercentLabel = "%";
                break;
              case "price":
                savingValue = Shopify.formatMoney(sellingPlanData.compare_at_price - savingValue);
                sentenceStart = "";
                savingHighlight = `Save ${savingValue}${savingsPercentLabel}`;
                break;
              case "fixed_amount":
                savingValue = Shopify.formatMoney(savingValue);
                break;
            }
            savingSummary += `${sentenceStart}${savingValue}${savingsPercentLabel} for ${savingsCount} orders${punctuation}`;
            if (index === 0) {
              savingHighlight = `Save ${savingValue}${savingsPercentLabel}`;
            }
          });
          this.current_variant_selling_plan_savings_description = savingSummary;
          this.current_variant_selling_plan_savings_summary = savingHighlight;
        }
        if (this.current_variant_selling_group_id == "0") {
          this.current_variant_selling_plan_id = 0;
        }
      }
    } else {
      this.current_variant_exists = false;
    }
  },
  // Update all_options_selected if all options are selected
  setallOptionsSelected() {
    let optionsSize = this.product.options.length;
    this.all_options_selected = optionsSize === 1 && this.option1 || optionsSize === 2 && this.option1 && this.option2 || optionsSize === 3 && this.option1 && this.option2 && this.option3;
    if (this.current_variant_has_only_default_variant === true) {
      this.all_options_selected = true;
    }
  },
  // Update order of product gallery images
  reorderProductGallery() {
    let formContainer = this.$refs.formContainer;
    if (this.enable_variant_images) {
      setTimeout(() => {
        this.galleryScrollToStart(0);
      }, 100);
    } else {
      const featuredImages = formContainer.querySelectorAll(".js-" + this.current_variant_featured_media_id);
      if (featuredImages.length > 0) {
        const slideIndex = featuredImages[0].getAttribute("data-slide");
        if (slideIndex) {
          this.galleryScrollToIndex(parseInt(slideIndex));
        } else {
          const parentElement = featuredImages[0].parentNode;
          if (parentElement) {
            parentElement.insertBefore(featuredImages[0], parentElement.firstChild);
          }
        }
      }
    }
  },
  // Add variant id to URL parameters
  updateUrlParameters() {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("variant", this.current_variant_id);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.replaceState(history.state, "", newRelativePathQuery);
  },
  // Refresh pickup availability block
  fetchAndRefreshPickup() {
    const formContainer = this.$refs.formContainer;
    const pickupContainer = formContainer?.querySelector(".js-pickup");
    if (!pickupContainer || !this.current_variant_id) return Promise.resolve(false);

    this._pickupController?.abort?.();
    const controller = new AbortController();
    const requestId = Number(this._pickupRequestId || 0) + 1;
    this._pickupController = controller;
    this._pickupRequestId = requestId;
    const pickupTimeout = window.setTimeout(() => controller.abort(), 8000);

    const pickupUrl = new URL(window.location.href);
    pickupUrl.searchParams.set("variant", String(this.current_variant_id));
    pickupUrl.searchParams.set("section_id", "product__pickup");

    return fetch(pickupUrl.toString(), {
      signal: controller.signal,
      headers: { "X-Requested-With": "XMLHttpRequest" }
    }).then(async (response) => {
      if (!response.ok) throw new Error(`Pickup availability returned HTTP ${response.status}`);
      const data2 = await response.text();
      if (this._pickupRequestId !== requestId || !pickupContainer.isConnected) return false;

      const html = document.createElement("div");
      html.innerHTML = data2;
      const htmlCleaned = html.querySelector(".js-pickup");
      if (!htmlCleaned) throw new Error("Pickup response did not include .js-pickup");
      pickupContainer.innerHTML = htmlCleaned.innerHTML;
      return true;
    }).catch((error) => {
      if (error?.name !== "AbortError" && this._pickupRequestId === requestId) {
        console.warn("Unable to refresh pickup availability:", error);
      }
      return false;
    }).finally(() => {
      window.clearTimeout(pickupTimeout);
      if (this._pickupRequestId === requestId && this._pickupController === controller) {
        this._pickupController = null;
      }
    });
  },
  // Scroll to next gallery item
  galleryScrollNext() {
    this.galleryResetZoom();
    const visibleIndexes = this.visibleGalleryIndexes();
    const currentPosition = visibleIndexes.indexOf(Number(this.gallery_index));
    this.gallery_next = visibleIndexes[(currentPosition + 1 + visibleIndexes.length) % visibleIndexes.length] ?? 0;
    this.galleryScrollToIndex(this.gallery_next);
  },
  // Scroll to previous gallery item
  galleryScrollBack() {
    this.galleryResetZoom();
    const visibleIndexes = this.visibleGalleryIndexes();
    const currentPosition = Math.max(0, visibleIndexes.indexOf(Number(this.gallery_index)));
    this.gallery_next = visibleIndexes[(currentPosition - 1 + visibleIndexes.length) % visibleIndexes.length] ?? 0;
    this.galleryScrollToIndex(this.gallery_next);
  },
  visibleGalleryIndexes() {
    const slider = this.$refs.formContainer?.querySelector('.js-slider');
    if (!slider) return Array.from({ length: Number(this.gallery_size || 0) + 1 }, (_, index) => index);
    return [...slider.querySelectorAll('[data-slide]')]
      .filter(slide => !slide.hidden && window.getComputedStyle(slide).display !== 'none')
      .map(slide => Number(slide.dataset.slide))
      .filter(index => Number.isInteger(index));
  },
  // Scroll to a specific gallery item
  galleryScrollToIndex(index) {
    this.galleryResetZoom();
    let formContainer = this.$refs.formContainer;
    let slider = formContainer.querySelector(".js-slider");
    let thumbnailSlider = formContainer.querySelector(".js-thumbnailSlider");
    let zoomSlider = formContainer.querySelector(".js-zoomSlider");
    let currentSlide = slider.querySelector('[data-slide="' + index + '"]');
    if (currentSlide) {
      let currentSlidePosition = currentSlide.offsetLeft;
      slider.scrollTo({
        top: 0,
        left: currentSlidePosition,
        behavior: "smooth"
      });
    }
    if (thumbnailSlider) {
      let currentThumb = thumbnailSlider.querySelector('[data-slide="' + index + '"]');
      if (currentThumb) {
        let currentThumbPosition = currentThumb.offsetTop;
        thumbnailSlider.scrollTo({
          top: currentThumbPosition - 200,
          left: 0,
          behavior: "smooth"
        });
      }
    }
    clearTimeout(this._galleryScrollTimer);
    this._galleryScrollTimer = setTimeout(() => {
      this._galleryScrollTimer = null;
      if (zoomSlider) {
        let currentSlide2 = zoomSlider.querySelector('[data-slide="' + index + '"]');
        if (currentSlide2) {
          let currentSlidePosition = currentSlide2.offsetLeft;
          zoomSlider.scrollTo({
            top: 0,
            left: currentSlidePosition,
            behavior: "smooth"
          });
        }
      }
    }, 100);
    this.gallery_index = index;
  },
  // Scroll to start of gallery slider
  galleryScrollToStart() {
    this.galleryResetZoom();
    let formContainer = this.$refs.formContainer;
    let slider = formContainer.querySelector(".js-slider");
    let thumbnailSlider = formContainer.querySelector(".js-thumbnailSlider");
    slider.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    if (thumbnailSlider) {
      thumbnailSlider.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
    this.gallery_index = 0;
  },
  // Unzoom all images
  galleryResetZoom() {
    for (let i = 0; i < this.gallery_size; i++) {
      this["gallery_zoom_" + i] = false;
    }
  },
  galleryZoomIn() {
    this["gallery_zoom_" + this.gallery_index] = true;
  },
  galleryZoomOut() {
    this["gallery_zoom_" + this.gallery_index] = false;
  }
};

// Helper: Preserve all URL params when pagination form submits
function preservePaginationParams(formElement, excludedParams = '') {
  // Use pagination_query from initialData (which was set by fetchAndRenderCollection)
  // This is the authoritative source of filter params since replaceState doesn't update window.location.search
  let queryString = window.__initialData?.pagination_query || window.location.search.replace(/^\?/, '');
  
  const currentParams = new URLSearchParams(queryString);
  const excluded = (excludedParams || '').split(',').map(p => p.trim());
  
  // Remove any existing hidden inputs (but keep form buttons and the page number input)
  formElement.querySelectorAll('input[type="hidden"]').forEach(input => {
    if (
      (input.name === 'artist_collection' && input.value === 'build-bundle') ||
      (input.name === 'artist_name' && currentParams.get('artist_collection') === 'build-bundle')
    ) {
      input.remove();
      return;
    }
    if (input.name !== 'artist_collection' && input.name !== 'artist_name') {
      input.remove();
    }
  });
  
  // Remove the page number text input to avoid duplicate page params
  const pageInput = formElement.querySelector('input[type="number"][name="page"]');
  if (pageInput) {
    pageInput.remove();
  }
  
  for (const [key, value] of currentParams.entries()) {
    if (key === 'page' || key === 'section_id' || excluded.includes(key)) {
      continue;
    }
    if (key === 'artist_collection' && value === 'build-bundle') {
      continue;
    }
    if (key === 'artist_name' && currentParams.get('artist_collection') === 'build-bundle') {
      continue;
    }
    
    // Add fresh input
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    formElement.appendChild(input);
  }
}

const collections = {
  startBuildCollectionProgressBar() {
    const rootData =
      this && this.cart
        ? this
        : window.Alpine && window.Alpine.$data
          ? window.Alpine.$data(document.documentElement)
          : null;

    if (!rootData || !rootData.cart) return null;

    clearTimeout(window.__paginationProgressTimer);
    clearTimeout(window.__paginationProgressFillTimer);
    rootData.cart_alert = false;
    rootData.cart.alert_delay = "0%";

    requestAnimationFrame(() => {
      rootData.cart_alert = true;
      rootData.cart.alert_delay = "0%";
      window.__paginationProgressFillTimer = setTimeout(() => {
        rootData.cart.alert_delay = "100%";
      }, 100);
    });

    return rootData;
  },
  finishBuildCollectionProgressBar(rootData) {
    if (!rootData || !rootData.cart) return;

    clearTimeout(window.__paginationProgressTimer);
    window.__paginationProgressTimer = setTimeout(() => {
      rootData.cart.alert_delay = "0%";
      rootData.cart_alert = false;
    }, 3000);
  },
  // Call section render API with data from filter
  async fetchAndRenderCollection(filterData) {
    this.pagination_error = false;
    window.__buildPaginationRequestId = (window.__buildPaginationRequestId || 0) + 1;
    window.__buildPaginationController?.abort?.();
    const requestId = (window.__collectionRenderRequestId || 0) + 1;
    window.__collectionRenderRequestId = requestId;
    window.__collectionRenderController?.abort?.();
    const controller = new AbortController();
    window.__collectionRenderController = controller;
    let collectionRequestTimedOut = false;
    const collectionRequestTimeout = window.setTimeout(() => {
      collectionRequestTimedOut = true;
      controller.abort();
    }, 12000);
    const isCurrentRequest = () => window.__collectionRenderRequestId === requestId;

    const filterUrl = this.buildUrlFilter(filterData); // returns like "&filter.p.tag=..."
    const currentParams = new URLSearchParams(window.location.search);
    const q = currentParams.get("q");
    const searchUrl = q ? `&q=${encodeURIComponent(q)}` : "";
    const query = `${filterUrl}${searchUrl}`;
    const cleanQuery = query.startsWith("&") ? query.slice(1) : query;
    const publicUrl = cleanQuery
      ? `${window.location.pathname}?${cleanQuery}`
      : window.location.pathname;

    // Fetch just this section with section_id. The public URL is committed only
    // after the newest response has been validated and rendered.
    const fetchUrl = `${window.location.pathname}?section_id=${this.pagination_section}${filterUrl}${searchUrl}`;

    this.pagination_loading = true;
    const progressRootData = this.startBuildCollectionProgressBar?.();

    try {
      const response = await fetch(fetchUrl, {
        signal: controller.signal,
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      if (!isCurrentRequest()) return false;

      // Parse returned HTML safely
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Pull ONLY the updated collection markup out of the returned section
      const incomingCollectionArea = doc.querySelector("#collection-area");
      const currentCollectionArea = document.querySelector("#collection-area");
      const incomingResults = doc.querySelector("#js-results");

      if (incomingCollectionArea && currentCollectionArea) {
        currentCollectionArea.innerHTML = incomingCollectionArea.innerHTML;
      } else {
        // Fallback (if markup changes): replace full section
        const sectionElement = document.getElementById(
          `shopify-section-${this.pagination_section}`
        );
        if (!sectionElement) throw new Error("Collection section is no longer mounted");
        sectionElement.innerHTML = html;
      }

      if (!isCurrentRequest()) return false;

      const totalPages = parseInt(incomingResults?.dataset.serverTotalPages || '1', 10);
      const currentPage = parseInt(incomingResults?.dataset.serverCurrentPage || '1', 10);
      this.pagination_total_pages = totalPages;
      this.pagination_current_page = currentPage;
      window.__initialData = window.__initialData || {};
      window.__initialData.pagination_total_pages = totalPages;
      window.__initialData.pagination_current_page = currentPage;
      window.__initialData.pagination_base_path = window.location.pathname;
      window.__initialData.pagination_query = cleanQuery;

      try {
        window.history.replaceState(null, "", publicUrl);
      } catch (historyError) {
        console.warn("Unable to update the filtered collection URL", historyError);
      }

      this.filter_popup = false;
      return true;
    } catch (err) {
      if ((err?.name !== "AbortError" || collectionRequestTimedOut) && isCurrentRequest()) {
        console.error("Unable to update collection filters:", err);
      }
      return false;
    } finally {
      window.clearTimeout(collectionRequestTimeout);
      if (isCurrentRequest()) {
        this.pagination_loading = false;
        this.finishBuildCollectionProgressBar?.(progressRootData);
        if (window.__collectionRenderController === controller) {
          window.__collectionRenderController = null;
        }
      }
    }
  },
  // Check if next page is avaible and inject more products
  scheduleBuildPaginationRetry(options = {}) {
    const busyRetry = Number(options.busyRetry || 0);
    const errorRetry = Number(options.errorRetry || 0);
    const retryKind = options.retryKind === "error" ? "error" : "busy";
    // A cart mutation can legitimately span multiple bounded request and
    // reconciliation attempts. Keep the intersection sentinel alive beyond
    // that worst-case window so an in-view paginator cannot stall permanently.
    const maxRetries = retryKind === "error" ? 2 : 180;
    const retryCount = retryKind === "error" ? errorRetry : busyRetry;
    if (retryCount >= maxRetries) return false;

    clearTimeout(window.__buildPaginationRetryTimer);
    const delay = retryKind === "error"
      ? Math.min(1500, 400 * 2 ** retryCount)
      : 300;

    window.__buildPaginationRetryTimer = setTimeout(() => {
      window.__buildPaginationRetryTimer = null;
      this.fetchAndRenderNextPage({
        busyRetry: retryKind === "busy" ? busyRetry + 1 : busyRetry,
        errorRetry: retryKind === "error" ? errorRetry + 1 : errorRetry
      });
    }, delay);
    return true;
  },
  async fetchAndRenderNextPage(options = {}) {
    // Don't double-fire or overrun the last page
    const currentPage = parseInt(this.pagination_current_page || window.__initialData?.pagination_current_page || '1', 10) || 1;
    const totalPages = parseInt(this.pagination_total_pages || window.__initialData?.pagination_total_pages || '1', 10) || 1;
    if (currentPage >= totalPages) {
      clearTimeout(window.__buildPaginationRetryTimer);
      window.__buildPaginationRetryTimer = null;
      return false;
    }
    if (this.pagination_loading || this.cart_loading || this._cartRequestInFlight || this._cartUpdatePromise) {
      this.scheduleBuildPaginationRetry({ ...options, retryKind: "busy" });
      return false;
    }

    clearTimeout(window.__buildPaginationRetryTimer);
    window.__buildPaginationRetryTimer = null;
    this.pagination_loading = true;
    this.pagination_error = false;
    const requestId = (window.__buildPaginationRequestId || 0) + 1;
    window.__buildPaginationRequestId = requestId;
    window.__buildPaginationController?.abort?.();
    const paginationController = new AbortController();
    window.__buildPaginationController = paginationController;
    let paginationRequestTimedOut = false;
    const paginationRequestTimeout = window.setTimeout(() => {
      paginationRequestTimedOut = true;
      paginationController.abort();
    }, 12000);
    const isCurrentRequest = () => window.__buildPaginationRequestId === requestId;

    try {
      // 1) Use initialData as source of truth since replaceState doesn't update window.location.search
      let basePath =
        (window.__initialData && window.__initialData.pagination_base_path) ||
        window.location.pathname;

      let baseQuery =
        window.__initialData && typeof window.__initialData.pagination_query === "string"
          ? window.__initialData.pagination_query
          : window.location.search.replace(/^\?/, '');

      let activeBuildArtistCollection = (window.__activeBuildArtistCollection || "").trim();
      if (activeBuildArtistCollection === "build-bundle") {
        activeBuildArtistCollection = "";
        window.__activeBuildArtistCollection = "";
      }
      if (activeBuildArtistCollection) {
        basePath = `/collections/${encodeURIComponent(activeBuildArtistCollection)}`;
        baseQuery = "view=build-bundle-swaps";
      }

      const currentParams = new URLSearchParams(baseQuery);
      if (currentParams.get("artist_collection") === "build-bundle") {
        currentParams.delete("artist_collection");
        currentParams.delete("artist_name");
        baseQuery = currentParams.toString();
      }
      const isBuildBundleSwapView = currentParams.get("view") === "build-bundle-swaps";

      const url = new URL(
        window.location.origin + basePath + (baseQuery ? `?${baseQuery}` : "")
      );

      // 2) Bump page + ensure section_id is set
      const nextPage = currentPage + 1;
      url.searchParams.set("page", String(nextPage));
      if (this.pagination_section && !isBuildBundleSwapView) {
        url.searchParams.set("section_id", this.pagination_section);
      }

      // 3) (Optional) merge current filter form state on top
      const filter = document.getElementById("js-mobileFilter");
      if (filter) {
        const fd = new FormData(filter);
        // overwrite existing params with form values
        for (const [key, value] of fd.entries()) {
          if (isBuildBundleSwapView && (key === "artist_collection" || key === "artist_name" || key === "view")) continue;
          if (value == null || value === "") continue;
          url.searchParams.delete(key);      // avoid duplicates
          url.searchParams.append(key, value);
        }
      }

      if (!isBuildBundleSwapView && !currentParams.get("artist_collection")) {
        url.searchParams.delete("artist_collection");
        url.searchParams.delete("artist_name");
        url.searchParams.delete("view");
      }

      if (this.pagination_section && !isBuildBundleSwapView) {
        url.searchParams.set("section_id", this.pagination_section);
      }

      // 4) Fetch and append results
      const response = await fetch(url.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
        signal: paginationController.signal,
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const html = await response.text();
      if (!isCurrentRequest()) return false;

      const tempElement = document.createElement("div");
      tempElement.innerHTML = html;

      const fetchedElement =
        tempElement.querySelector('#js-results[data-build-results="true"]') ||
        tempElement.querySelector("#js-results");
      const resultsElement =
        document.querySelector('#js-results[data-build-results="true"]') ||
        document.getElementById("js-results");

      if (!fetchedElement || !resultsElement) {
        throw new Error("Pagination response did not include #js-results");
      }

      const beforeCount = resultsElement.children.length;
      resultsElement.insertAdjacentHTML("beforeend", fetchedElement.innerHTML);

      if (resultsElement.children.length <= beforeCount) {
        console.warn("No products appended from next page:", url.toString());
        this.pagination_current_page = Math.min(nextPage, totalPages);
        window.__initialData = window.__initialData || {};
        window.__initialData.pagination_current_page = this.pagination_current_page;
        return false;
      }

      const returnedCurrentPage = parseInt(fetchedElement?.dataset.serverCurrentPage || String(nextPage), 10);
      const returnedTotalPages = parseInt(fetchedElement?.dataset.serverTotalPages || String(this.pagination_total_pages), 10);
      this.pagination_current_page = Number.isFinite(returnedCurrentPage) ? returnedCurrentPage : nextPage;
      this.pagination_total_pages = Number.isFinite(returnedTotalPages) ? returnedTotalPages : this.pagination_total_pages;

      window.__initialData = window.__initialData || {};
      window.__initialData.pagination_current_page = this.pagination_current_page;
      window.__initialData.pagination_total_pages = this.pagination_total_pages;
      clearTimeout(window.__buildPaginationRetryTimer);
      window.__buildPaginationRetryTimer = null;
      return true;
    } catch (error) {
      if (error?.name !== "AbortError" || paginationRequestTimedOut) {
        console.error("Error in fetchAndRenderNextPage:", error);
      }
      if (isCurrentRequest() && (error?.name !== "AbortError" || paginationRequestTimedOut)) {
        const retryScheduled = this.scheduleBuildPaginationRetry({ ...options, retryKind: "error" });
        if (!retryScheduled) this.pagination_error = true;
      }
      return false;
    } finally {
      window.clearTimeout(paginationRequestTimeout);
      if (isCurrentRequest()) {
        this.pagination_loading = false;
        if (window.__buildPaginationController === paginationController) {
          window.__buildPaginationController = null;
        }
      }
    }
  },
  // Handle filter changes on price
  handlePriceFilterChange(filterType) {
    const { filter_min_price, filter_max_price, filter_min, filter_max } = this;
    const priceRange = filter_max - filter_min;
    if (filterType === "max") {
      this.filter_max_price = Math.max(filter_max_price, filter_min_price);
      this.filter_max_thumb = 100 - (this.filter_max_price - filter_min) / priceRange * 100;
    } else if (filterType === "min") {
      this.filter_min_price = Math.min(filter_min_price, filter_max_price);
      this.filter_min_thumb = (this.filter_min_price - filter_min) / priceRange * 100;
    } else {
      console.error('Invalid filter type. Expected "min" or "max".');
    }
  },
  // Handle filter change
  handleFilterChange(id) {
    this.pagination_loading = true;
    this.pagination_current_page = 1;
    const filter = document.getElementById(id);
    if (filter) {
      const filterData = new FormData(filter);
      this.fetchAndRenderCollection(filterData);
    } else {
      console.error("Filter element not found.");
    }
  },
  // Handle deleting filters
  handleFilterDelete(filterToReset) {
    this.pagination_loading = true;
    const filter = document.getElementById("js-mobileFilter");
    if (filter) {
      const filterData = new FormData(filter);
      filterData.delete(filterToReset);
      if (filterToReset.indexOf("price") !== -1) {
        filterData.delete("filter.v.price.gte");
        filterData.delete("filter.v.price.lte");
        this.filter_min_price = this.filter_min;
        this.filter_max_price = this.filter_max;
      }
      this.fetchAndRenderCollection(filterData);
    } else {
      console.error("Filter element 'js-mobileFilter' not found.");
    }
  },
  // Handle deleting all filters
  handleFilterDeleteAll: function() {
    this.pagination_loading = true;
    let filterData = new FormData();
    this.filter_min_price = this.filter_min;
    this.filter_max_price = this.filter_max;
    this.fetchAndRenderCollection(filterData);
  },
  // Build urlFilter
  buildUrlFilter(filterData) {
    let urlFilter = "";
    for (let pair of filterData.entries()) {
      const [key, value] = pair;
      if (key.includes("price")) {
        if (key === "filter.v.price.lte" && value < this.filter_max) {
          urlFilter += `&${key}=${value}`;
        }
        if (key === "filter.v.price.gte" && value > this.filter_min) {
          urlFilter += `&${key}=${value}`;
        }
      } else {
        if (key === "artist_collection" && value === "build-bundle") continue;
        if (key === "artist_name" && filterData.get("artist_collection") === "build-bundle") continue;
        urlFilter += `&${key}=${encodeURIComponent(value)}`;
      }
    }
    return urlFilter;
  }
};
const utils = {
  // Initiate animation setup - classes will swap when elements scroll into view
  initAnimationObserver() {
    const animationElements = Array.from(document.querySelectorAll(".js-animation:not([data-animation-observed])"));
    if (animationElements.length === 0) return;

    const pendingElements = new Set(animationElements);
    let animationObserver;
    let fallbackFrame;

    const removeFallbackListeners = function() {
      window.removeEventListener("scroll", scheduleFallbackCheck);
      window.removeEventListener("resize", scheduleFallbackCheck);
    };

    const revealElement = function(target) {
      if (!pendingElements.has(target)) return;

      let replaceClasses;
      try {
        replaceClasses = JSON.parse((target.dataset.replace || "{}").replace(/'/g, '"'));
      } catch (error2) {
        console.error("Error parsing replaceClasses:", error2);
        return;
      }

      pendingElements.delete(target);
      animationObserver?.unobserve(target);

      const element = target.dataset.id ? document.getElementById(target.dataset.id) : null;
      const revealTarget = element || target;
      const delay3 = Number.parseInt(target.dataset.delay || "0", 10) || 0;
      const callback = target.dataset.callback;
      if (callback && window[callback] && typeof window[callback] === "function") {
        window[callback]();
      }

      window.setTimeout(function() {
        Object.keys(replaceClasses).forEach(function(key) {
          revealTarget.classList.remove(key);
          if (replaceClasses[key]) revealTarget.classList.add(replaceClasses[key]);
        });
      }, delay3);

      if (pendingElements.size === 0) removeFallbackListeners();
    };

    const checkVisibleElements = function() {
      fallbackFrame = void 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      pendingElements.forEach(function(target) {
        const bounds = target.getBoundingClientRect();
        if (bounds.bottom >= 0 && bounds.top <= viewportHeight) revealElement(target);
      });
    };

    function scheduleFallbackCheck() {
      if (fallbackFrame) return;
      fallbackFrame = window.requestAnimationFrame(checkVisibleElements);
    }

    if ("IntersectionObserver" in window) {
      animationObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) revealElement(entry.target);
        });
      });
    }

    animationElements.forEach(function(target) {
      target.dataset.animationObserved = "true";
      if (animationObserver) animationObserver.observe(target);
    });

    // Some browsers/webviews intermittently miss IntersectionObserver updates
    // during layout shifts. Keep a lightweight viewport check as a safety net so
    // animation classes can never leave content permanently transparent.
    window.addEventListener("scroll", scheduleFallbackCheck, { passive: true });
    window.addEventListener("resize", scheduleFallbackCheck);
    scheduleFallbackCheck();
  },
  // set query params
  // NEEDS TO GET REWORKED
  setQuery: (query) => {
    if (query === "") {
      window.history.replaceState({}, "", window.location.pathname);
      return;
    } else {
      const path = window.location.pathname;
      const params = new URLSearchParams(window.location.search);
      const hash = window.location.hash;
      params.set("edit", query);
      window.history.replaceState({}, "", `${path}?${params.toString()}${hash}`);
    }
  },
  // Refresh when using back button when history states were changed
  initPopstate() {
    window.addEventListener("popstate", async () => {
      window.location.href = location.href;
    });
  },
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },
  // Match to liquid handle filter
  handleize(str) {
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\p{L}\p{N}]+/gu, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
  },
  // Add classes to images after loading
  loadImages() {
    const loadImage = (img) => {
      var _a, _b;
      img.classList.add("loaded");
      (_b = (_a = img.parentElement) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.classList.add("loaded");
    };
    const images = document.querySelectorAll("img.js-image");
    images.forEach((img) => {
      const imageElement = img;
      if (imageElement.complete) {
        loadImage(imageElement);
      } else {
        imageElement.onload = () => {
          loadImage(imageElement);
        };
      }
      setTimeout(() => {
        loadImage(imageElement);
      }, 2e3);
    });
  },
  // Copy value of input to clipboard and focus element
  copyToClipboard(id) {
    const copyText = document.getElementById(id);
    if (copyText) {
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      try {
        navigator.clipboard.writeText(copyText.value);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    } else {
      console.error("Element not found: ", id);
    }
  },
  // Get cookie by name
  getCookie(name) {
    const cookieMatch = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return cookieMatch ? cookieMatch.pop() : null;
  },
  // Handle audio playing
  playAudioIfEnabled(audioFile) {
    if (this.enable_audio) {
      const audio = new Audio(audioFile);
      if (window.innerWidth > 768) {
        audio.play();
      }
    }
  },
  // Open menu drawer
  openMenu() {
    this.menu_drawer = true;
    this.enable_body_scrolling = false;
    this.playAudioIfEnabled(this.click_audio);
  },
  // Open cart drawer
  openCart() {
    this.cart_drawer = true;
    this.cart_alert = false;
    this.enable_body_scrolling = false;
    this.playAudioIfEnabled(this.click_audio);
  },
  // Open search drawer
  openSearch() {
    this.menu_drawer = false;
    this.search_drawer = true;
    this.enable_body_scrolling = false;
    setTimeout(() => {
      let searchField = document.querySelector("#search-field");
      if (searchField) {
        searchField.focus();
      }
    }, 400);
  },
  // Close cart drawer
  closeCart() {
    this.cart_drawer = false;
    this.cart_alert = false;
    this.enable_body_scrolling = true;
  },
  // Close menu drawer
  closeMenu() {
    this.menu_drawer = false;
    this.enable_body_scrolling = true;
  },
  // Close menu drawer
  closeSearch() {
    this.search_drawer = false;
    this.enable_body_scrolling = true;
  },
  // Initiate header scrolling (unless in preview mode)
  initScroll: function() {
    if (!Shopify.visualPreviewMode) {
      const body = document.querySelector("body");
      body.setAttribute("x-on:scroll.window", `() => {
        if (window.pageYOffset > 400) {
          is_scrolled = window.pageYOffset > prev_scroll_pos ? true : false; 
          prev_scroll_pos = window.pageYOffset;
          $refs.header.style.transform = 'none'
        } else {
          is_scrolled = false;
          prev_scroll_pos = window.pageYOffset;
          $refs.header.style.transform = 'none'
        }
      }`);
      body.setAttribute("x-intersect.half:enter", "scroll_up = false");
      body.setAttribute("x-intersect.half:leave", "scroll_up = true");
    }
  },
  // Check line items values
  // REWORK
  checkLineItems(handle) {
    const inputs = document.querySelectorAll(
      `.custom-input_${handle}`
    );
    const inputsArr = Array.from(inputs);
    const requiredFields = inputsArr.filter((inp) => inp.required);
    if (requiredFields.some((field) => field.value === "")) {
      this.incomplete_fields = true;
    } else {
      this.incomplete_fields = false;
    }
  },
  presentToast(payload = {}) {
    if (payload.type === 'bundle-tier') {
      payload = this.bundleTierToastPayload(payload.previousState);
      if (!payload) {
        this.hideToast(false);
        return;
      }
      if (this.bundleTierToastBlocked()) {
        this.scheduleBundleTierToast(payload);
        this.hideToast(false);
        return;
      }
    }
    if (typeof this.updateSaleTierPopupPosition === "function") {
      this.updateSaleTierPopupPosition();
    }

    clearTimeout(this._toastTimer);
    clearTimeout(this._toastQueueTimer);
    clearInterval(this._toastWatchdog);

    const requestedTimeout = Number(payload.timeout || 3000);
    const timeout = Math.min(8000, Math.max(1000, Number.isFinite(requestedTimeout) ? requestedTimeout : 3000));
    const generation = ++this._toastGeneration;

    this.toast = {
      ...this.toast,
      show: false,
      type: payload.type || 'default',
      message: payload.message || '',
      timeout,
      generation,
      expiresAt: Date.now() + timeout,
      icon: payload.icon || 'surprise',
      iconFill: payload.iconFill || 'var(--color-secondary-button-text-light)',
      reward: payload.reward || '',
      className: payload.className || ''
    };

    requestAnimationFrame(() => {
      if (this.toast.generation !== generation) return;
      this.toast.show = true;
    });

    this._toastTimer = setTimeout(() => {
      this.hideToast(false, generation);
    }, timeout);

    // Independent fallback in case another interaction clears the primary
    // timer while leaving the toast visible.
    this._toastWatchdog = setInterval(() => {
      if (this.toast.generation !== generation || !this.toast.show) return;
      if (Date.now() >= Number(this.toast.expiresAt || 0)) {
        this.hideToast(false, generation);
      }
    }, 500);
  },
  showToast(payload = {}) {
    this.updateSaleTierPopupPosition();

    const message = String(payload.message || '').trim();
    const type = String(payload.type || 'default');
    const queuePayload = () => {
      if (type === 'bundle-tier') {
        this._toastQueue = this._toastQueue.filter(item => item?.type !== 'bundle-tier');
      }
      const lastQueued = this._toastQueue[this._toastQueue.length - 1];
      const isAlreadyQueued = lastQueued &&
        String(lastQueued.message || '').trim() === message &&
        String(lastQueued.type || 'default') === type;
      if (isAlreadyQueued) return;

      if (payload.replace === true) {
        this._toastQueue = [payload];
      } else {
        this._toastQueue.push(payload);
        this._toastQueue = this._toastQueue.slice(-3);
      }
    };

    // A general/mystery toast must not interrupt an active sale-tier toast.
    // Its own timeout starts only when it is presented after the tier timer.
    if (this.sale_tier_popup?.show || this.sale_tier_popup?.timer || this.sale_tier_popup?.dismiss_timer) {
      queuePayload();
      return;
    }

    const isCurrentToast = this.toast.show &&
      String(this.toast.message || '').trim() === message &&
      String(this.toast.type || 'default') === type;

    // Repeated cart refreshes can report the same unlock more than once. Do
    // not extend its lifetime or enqueue an identical copy.
    if (isCurrentToast) return;

    if (this.toast.show) {
      queuePayload();
      return;
    }

    this.presentToast(payload);
  },
  hideToast(clearQueue = true, expectedGeneration = null) {
    if (expectedGeneration !== null && this.toast.generation !== expectedGeneration) return;

    clearTimeout(this._toastTimer);
    clearTimeout(this._toastQueueTimer);
    clearInterval(this._toastWatchdog);
    this._toastTimer = null;
    this._toastWatchdog = null;
    this.toast.generation = ++this._toastGeneration;
    this.toast.show = false;

    if (clearQueue) {
      this._toastQueue = [];
      return;
    }

    const nextToast = this._toastQueue.shift();
    if (nextToast) {
      this._toastQueueTimer = setTimeout(() => {
        this.presentToast(nextToast);
      }, 180);
      return;
    }

    if (this._saleTierPopupQueue) {
      const queuedPopup = this._saleTierPopupQueue;
      this._saleTierPopupQueue = null;
      this._toastQueueTimer = setTimeout(() => {
        this.showSaleTierPopup(queuedPopup.tier, queuedPopup.timeout);
      }, 180);
    }
  },
  updateSaleTierPopupPosition() {
    const header = this.$refs?.header || document.querySelector('[x-ref="header"]') || document.querySelector("body > header") || document.querySelector("header");
    const rect = header ? header.getBoundingClientRect() : null;
    const headerOffset = rect && rect.bottom > 0 ? Math.max(0, Math.ceil(rect.bottom)) : 0;
    document.documentElement.style.setProperty("--tiered-sale-popup-header-offset", `${headerOffset}px`);
  },
  showSaleTierPopup(tier = {}, timeout = 3400) {
    if (!this.panelBaseTierPopupAllowed()) {
      this._saleTierPopupQueue = null;
      this.hideSaleTierPopupImmediately();
      return;
    }

    if (this.toast?.show) {
      this._saleTierPopupQueue = { tier, timeout };
      return;
    }

    this.hideToast(true);
    clearTimeout(this.sale_tier_popup.timer);
    clearTimeout(this.sale_tier_popup.dismiss_timer);
    this.updateSaleTierPopupPosition();

    this.sale_tier_popup = {
      ...this.sale_tier_popup,
      show: false,
      discount: Number(tier.discount || 0),
      tier,
      timer: null,
      dismiss_timer: null,
      shown_at: 0
    };

    requestAnimationFrame(() => {
      this.sale_tier_popup.shown_at = Date.now();
      this.sale_tier_popup.show = true;
    });

    this.sale_tier_popup.timer = setTimeout(() => {
      this.hideSaleTierPopup();
    }, timeout);
  },
  hideSaleTierPopupImmediately() {
    clearTimeout(this.sale_tier_popup.timer);
    clearTimeout(this.sale_tier_popup.dismiss_timer);
    this.sale_tier_popup.show = false;
    this.sale_tier_popup.timer = null;
    this.sale_tier_popup.dismiss_timer = null;
    this.sale_tier_popup.shown_at = 0;
  },
  showNextToastAfterSaleTier() {
    if (this.toast?.show || this._toastQueueTimer) return;
    const nextToast = this._toastQueue.shift();
    if (!nextToast) return;

    this._toastQueueTimer = setTimeout(() => {
      this._toastQueueTimer = null;
      this.presentToast(nextToast);
    }, 180);
  },
  hideSaleTierPopup() {
    clearTimeout(this.sale_tier_popup.timer);
    this.sale_tier_popup.timer = null;

    if (this.sale_tier_popup.dismiss_timer) return;

    const shownAt = Number(this.sale_tier_popup.shown_at || Date.now());
    const minimumVisibleMs = Number(this.sale_tier_popup.minimum_visible_ms || 0);
    const remainingMs = Math.max(0, minimumVisibleMs - (Date.now() - shownAt));

    if (remainingMs > 0) {
      this.sale_tier_popup.dismiss_timer = setTimeout(() => {
        this.sale_tier_popup.show = false;
        this.sale_tier_popup.dismiss_timer = null;
        this.sale_tier_popup.shown_at = 0;
        this.showNextToastAfterSaleTier();
      }, remainingMs);
      return;
    }

    this.sale_tier_popup.show = false;
    this.sale_tier_popup.dismiss_timer = null;
    this.sale_tier_popup.shown_at = 0;
    this.showNextToastAfterSaleTier();
  },
};
let Shopify$1 = window.Shopify ?? {};
function formatMoney(cents, forceEnableCurrency) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatStringWithoutCurrency = globals.price_format_without_currency;
  let formatStringWithCurrency = globals.price_format_with_currency;
  let formatString = "";
  let enableZeros = globals.price_enable_zeros;
  let enableCurrency = globals.price_enable_currency;
  formatString = enableCurrency === false ? formatStringWithCurrency : formatStringWithoutCurrency;
  if (forceEnableCurrency === false) {
    formatString = formatStringWithCurrency;
  } else if (forceEnableCurrency === true) {
    formatString = formatStringWithoutCurrency;
  }
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  value = formatString.replace(placeholderRegex, value);
  if (enableZeros === false) {
    value = value.replace(".00", "");
  }
  return value;
}
Shopify$1.formatMoney = formatMoney;
utils.loadImages();

// CUSTOM OTHER FEATURES START
const buildCollection = {
  build_loader: false,
  build_load_more: false,
  build_selected: { handle: '', variant_id: '', custom_id: '' },
  build_gallery_index: 0,
  _reqId: 0,
  _controller: null,
  _lastKey: null, // stage|section|handle|variant|custom-id de-dupe
  _lastSuccessfulBuilderBase: null,
  _lastSuccessfulBuilderBaseIndex: null,
  _pendingBuilderBaseRollback: null,
  selectedBuildItemStillInCart() {
    if (!this.build_selected?.handle) return false;

    if (this.build_selected?.custom_id) {
      return (this.cart?.items || []).some(item =>
        item.handle === this.build_selected.handle &&
        String(item.variant_id) === String(this.build_selected.variant_id) &&
        String(item?.properties?.custom_id || '') === String(this.build_selected.custom_id)
      );
    }

    const selectedBase = (this.cart?.bases || []).some(base =>
      base.handle === this.build_selected.handle &&
      String(base.variant_id) === String(this.build_selected.variant_id)
    );

    if (selectedBase) return true;

    return (this.cart?.swaps || []).some(swap =>
      swap.handle === this.build_selected.handle &&
      String(swap.variant_id) === String(this.build_selected.variant_id)
    );
  },
  firstSelectableBuildItem() {
    const latestSelectableLine = [...(this.cart?.items || [])].reverse().find(item =>
      (
        this.isArtPanelCartItem(item) ||
        globals.bases.some(base => base.handle === item.handle)
      ) &&
      !String(item.product_title || '').includes('Mystery')
    );

    if (latestSelectableLine) {
      return {
        handle: latestSelectableLine.handle,
        variant_id: latestSelectableLine.variant_id,
        custom_id: this.isArtPanelCartItem(latestSelectableLine)
          ? (latestSelectableLine?.properties?.custom_id || '')
          : ''
      };
    }

    const fallbackBase = this.bases?.[this.selected_base] || null;
    return fallbackBase
      ? { handle: fallbackBase.handle, variant_id: null, custom_id: '' }
      : null;
  },
  removeSelected() {
    const displayItems = [
      ...((this.cart?.swaps || []).flatMap(swap => {
        const customItems = (this.cart?.items || [])
          .filter(item =>
            String(item.variant_id) === String(swap.variant_id) &&
            item?.properties?.custom_id
          )
          .map(item => ({
            ...item,
            handle: item.handle || swap.handle,
            _is_custom_split: true,
            _nav_key: `${item.variant_id}-${item.properties.custom_id}`
          }));

        const customQty = customItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
        const standardQty = (Number(swap.quantity) || 0) - customQty;

        const standardEntry = standardQty > 0 ? [{
          ...swap,
          _is_custom_split: false,
          _nav_key: `standard-${swap.variant_id}`
        }] : [];

        return [...standardEntry, ...customItems];
      })),
      ...(this.cart?.bases || []).map(base => ({
        ...base,
        _is_base: true,
        _nav_key: `base-${base.handle}-${base.variant_id}`
      }))
    ];

    const selectedKey = this.build_selected?.custom_id
      ? `${this.build_selected.variant_id}-${this.build_selected.custom_id}`
      : (
          (this.cart?.bases || []).some(b =>
            b.handle === this.build_selected?.handle &&
            String(b.variant_id) === String(this.build_selected?.variant_id)
          )
            ? `base-${this.build_selected.handle}-${this.build_selected.variant_id}`
            : `standard-${this.build_selected.variant_id}`
        );

    const currentIndex = Math.max(
      displayItems.findIndex(item => item._nav_key === selectedKey),
      0
    );

    const currentDisplayItem = displayItems[currentIndex];
    if (!currentDisplayItem) return;

    let cartLine = null;

    if (currentDisplayItem._is_custom_split) {
      cartLine = (this.cart?.items || []).find(item =>
        String(item.variant_id) === String(this.build_selected?.variant_id) &&
        String(item?.properties?.custom_id || '') === String(this.build_selected?.custom_id || '')
      );
    } else if (currentDisplayItem._is_base) {
      cartLine = (this.cart?.items || []).find(item =>
        String(item.variant_id) === String(currentDisplayItem.variant_id) &&
        item.handle === currentDisplayItem.handle
      );
    } else {
      cartLine = (this.cart?.items || []).find(item =>
        String(item.variant_id) === String(currentDisplayItem.variant_id) &&
        !item?.properties?.custom_id
      );
    }

    if (!cartLine?.key) return;

    const newQuantity = currentDisplayItem._is_base && (Number(cartLine.quantity) || 0) > 1
      ? cartLine.quantity - 1
      : 0;

    const nextIndex = displayItems.length > 1
      ? ((currentIndex + 1) % displayItems.length)
      : -1;

    const nextItem = nextIndex >= 0 ? displayItems[nextIndex] : null;

    this.changeCartItemQuantity(cartLine.key, newQuantity, false, false);

    if (currentDisplayItem._is_base && (this.cart?.bases?.length || 0) > 1) {
      const nextBase = (this.cart.bases || []).find(b =>
        String(b.variant_id) !== String(currentDisplayItem.variant_id)
      );
      this.selected_base = (this.bases || []).findIndex(b => b.handle === nextBase?.handle);
    }

    if (newQuantity === 0 && nextItem) {
      this.loadBuilderByHandle(
        nextItem.handle,
        this._sectionId,
        nextItem._is_base ? nextItem.variant_id : null,
        'swaps',
        nextItem?.properties?.custom_id || ''
      );

      this.build_selected.handle = nextItem.handle;
      this.build_selected.variant_id = nextItem.variant_id;
      this.build_selected.custom_id = nextItem?.properties?.custom_id || '';
    }
  },

  rememberSuccessfulBuilderBase(selection = {}, baseIndex = null) {
    const normalizedBaseIndex = Number(baseIndex);
    if (Number.isInteger(normalizedBaseIndex) && normalizedBaseIndex >= 0) {
      this._lastSuccessfulBuilderBaseIndex = normalizedBaseIndex;
    }
    const indexedBase = Number.isInteger(this._lastSuccessfulBuilderBaseIndex)
      ? (this.bases || [])[this._lastSuccessfulBuilderBaseIndex]
      : null;
    this._lastSuccessfulBuilderBase = {
      handle: indexedBase?.handle || selection?.handle || '',
      variant_id: selection?.variant_id || indexedBase?.variant_id || null
    };
  },

  loadBuilderByHandle(handle, sectionId, variantId = null, stage = 'swaps', customId = '', rollbackState = null) {
    // A superseding base request must inherit the original mounted state, not
    // the previous request's optimistic selection.
    const effectiveRollbackState = stage === 'bases' && this._pendingBuilderBaseRollback
      ? this._pendingBuilderBaseRollback
      : rollbackState;
    const rollbackSource = effectiveRollbackState?.selection || this.build_selected || {};
    const rollbackSelection = {
      handle: rollbackSource?.handle || '',
      variant_id: rollbackSource?.variant_id || null,
      custom_id: rollbackSource?.custom_id || ''
    };
    const explicitRollbackBaseIndex = Number(effectiveRollbackState?.baseIndex);
    const selectedRollbackBaseIndex = Number(this.selected_base);
    const rollbackBaseIndex = Number.isInteger(explicitRollbackBaseIndex) && explicitRollbackBaseIndex >= 0
      ? explicitRollbackBaseIndex
      : Number.isInteger(this._lastSuccessfulBuilderBaseIndex) && this._lastSuccessfulBuilderBaseIndex >= 0
        ? this._lastSuccessfulBuilderBaseIndex
        : Number.isInteger(selectedRollbackBaseIndex) && selectedRollbackBaseIndex >= 0
          ? selectedRollbackBaseIndex
          : null;
    const restoreBuilderSelection = () => {
      this.build_selected.handle = rollbackSelection.handle;
      this.build_selected.variant_id = rollbackSelection.variant_id;
      this.build_selected.custom_id = rollbackSelection.custom_id;

      if (stage !== 'bases' || !Number.isInteger(rollbackBaseIndex)) return;
      this.selected_base = rollbackBaseIndex;
      window.swapwearStorage?.setJSON?.('selected_base', rollbackBaseIndex);
      const rollbackBase = (this.bases || [])[rollbackBaseIndex];
      const rollbackDetail = {
        handle: rollbackBase?.handle || this._lastSuccessfulBuilderBase?.handle || rollbackSelection.handle,
        index: rollbackBaseIndex,
        rollback: true
      };
      window.dispatchEvent(new CustomEvent('build-base-selection-change', { detail: rollbackDetail }));
      window.dispatchEvent(new CustomEvent('build:base-selected', { detail: rollbackDetail }));
    };

    // Resolve sectionId robustly (search results may not pass it)
    const resolvedSectionId =
      sectionId ||
      this._sectionId ||
      window.pagination_section ||
      document.querySelector('[data-build-section-id]')?.dataset?.buildSectionId ||
      document.querySelector('[id^="shopify-section-"] [data-build-section-id]')?.dataset?.buildSectionId ||
      '';

    if (!handle || !resolvedSectionId) {
      console.warn('[builder] Missing sectionId for loadBuilderByHandle', { handle, variantId, stage });
      restoreBuilderSelection();
      return Promise.resolve(false);
    }

    this._sectionId = resolvedSectionId; // keep last valid sectionId

    const key = `${stage}|${resolvedSectionId}|${handle}|${variantId ?? ''}|${customId || ''}`;
    if (this._lastKey === key && !this.build_loader) return Promise.resolve(true);
    if (this._pendingKey === key && this._loadBuilderPromise) return this._loadBuilderPromise;
    this._pendingKey = key;
    if (stage === 'bases') {
      this._pendingBuilderBaseRollback = {
        selection: { ...rollbackSelection },
        baseIndex: rollbackBaseIndex
      };
    }
    if (!this._lastSuccessfulBuilderBase && Number.isInteger(rollbackBaseIndex)) {
      const rollbackBase = (this.bases || [])[rollbackBaseIndex];
      this.rememberSuccessfulBuilderBase({
        handle: rollbackBase?.handle || rollbackSelection.handle,
        variant_id: rollbackBase?.variant_id || null
      }, rollbackBaseIndex);
    }

    window.__builderBootstrapped = true;

    const reqId = ++this._reqId;
    this.build_loader = true;

    const previousController = this._controller;
    const controller = new AbortController();
    this._controller = controller;
    let builderRequestTimedOut = false;
    const builderRequestTimeout = window.setTimeout(() => {
      builderRequestTimedOut = true;
      controller.abort();
    }, 12000);

    try {
      previousController?.abort();
    } catch (err) {
      if (err?.name !== 'AbortError') console.warn('[builder] abort error', err);
    }

    this.build_selected.handle = handle;
    this.build_selected.variant_id = variantId;
    this.build_selected.custom_id = customId || '';
    const variantParam = variantId ? `&variant=${encodeURIComponent(variantId)}` : '';
    const url = `${window.Shopify.routes.root}products/${handle}?section_id=${resolvedSectionId}${variantParam}`;

    const loadOperation = Promise.resolve()
      .then(() => fetch(url, { signal: controller.signal }))
      .then(res => {
        if (!res.ok) throw new Error(`Builder product returned HTTP ${res.status}`);
        return res.text();
      })
      .then(html => {
        if (reqId !== this._reqId) return false;
        const doc = new DOMParser().parseFromString(html, 'text/html');

	        if (stage === 'swaps') {
	          const newMedia = doc.querySelector('#media-module');
	          const current = document.getElementById('media-module');
	
	          if (current && newMedia) {
	            const suppressItemTransition = window.matchMedia('(min-width: 768px)').matches;
	            const replaceMediaContents = () => {
	              try {
	                if (window.Alpine?.destroyTree) {
	                  window.Alpine.destroyTree(current);
	                }
	              } catch (err) {
	                console.warn('[builder] previous media cleanup failed', err);
	              }

	              if (suppressItemTransition) {
	                current.classList.add('build-gallery-suppress-item-transition');
	              }

	              current.innerHTML = newMedia.innerHTML;
	            };

	            if (window.Alpine?.mutateDom) {
	              window.Alpine.mutateDom(replaceMediaContents);
	            } else {
	              replaceMediaContents();
	            }

	            try {
	              if (window.Alpine?.initTree) {
	                window.Alpine.initTree(current);
	              }
	            } catch (err) {
	              console.warn('[builder] replacement media initialization failed', err);
	            }

	            if (suppressItemTransition) {
	              requestAnimationFrame(() => {
	                requestAnimationFrame(() => {
	                  current.classList.remove('build-gallery-suppress-item-transition');
	                });
	              });
	            }
	          } else {
	            throw new Error('Builder response did not include #media-module');
	          }
        } else {
          if (reqId !== this._reqId) return false;
          const newSection = doc.querySelector(`#shopify-section-${resolvedSectionId}`);
          const currentSection = document.getElementById(`shopify-section-${resolvedSectionId}`);

          if (currentSection && newSection) {
            const replaceSectionContents = () => {
              try {
                if (window.Alpine?.destroyTree) {
                  window.Alpine.destroyTree(currentSection);
                }
              } catch (err) {
                console.warn("[builder] previous section cleanup failed", err);
              }

              currentSection.__buildAlpineInitialized = false;
              currentSection.innerHTML = newSection.innerHTML;
            };

            if (window.Alpine?.mutateDom) {
              window.Alpine.mutateDom(replaceSectionContents);
            } else {
              replaceSectionContents();
            }

            const refreshLoadedBuildOptions = (attempt = 0) => {
              if (reqId !== this._reqId) return;
              const nextRoot = currentSection.querySelector(".js-product");
              if (!nextRoot) return;

              try {
                if (window.Alpine?.initTree && !currentSection.__buildAlpineInitialized) {
                  window.Alpine.initTree(currentSection);
                  currentSection.__buildAlpineInitialized = true;
                }

                const data = window.Alpine?.$data ? window.Alpine.$data(nextRoot) : null;
                if (data?.product?.handle && handle && data.product.handle !== handle) {
                  console.warn("[builder] loaded base product did not match selected base", {
                    expected: handle,
                    received: data.product.handle
                  });
                }
                if (data?.attachStandardForm) {
                  data.attachStandardForm();
                }
                if (data?.initProductForm) {
                  data.initProductForm(variantId || data.current_variant_id);
                  return;
                }
                if (data?.handleProductFormChange) {
                  data.handleProductFormChange(false, variantId || data.current_variant_id);
                  return;
                }
                if (data?.setUnavailableOptions) {
                  data.setUnavailableOptions();
                  return;
                }
              } catch (err) {
                if (attempt >= 6) console.warn("[builder] option availability refresh failed", err);
              }

              if (attempt < 6) {
                setTimeout(() => refreshLoadedBuildOptions(attempt + 1), 50);
              }
            };
            requestAnimationFrame(() => {
              if (reqId === this._reqId) refreshLoadedBuildOptions();
            });
          } else {
            throw new Error(`Builder response did not include section ${resolvedSectionId}`);
          }
        }

        if (reqId !== this._reqId) return false;
        this._lastKey = key;
        if (stage === 'bases') {
          const successfulBaseIndex = (this.bases || []).findIndex(base => base?.handle === handle);
          this.rememberSuccessfulBuilderBase({ handle, variant_id: variantId }, successfulBaseIndex);
        }
        return true;
      })
      .catch(err => {
        if ((err?.name === 'AbortError' || controller.signal.aborted) && !builderRequestTimedOut) return false;
        console.error('[builder] fetch error', err);
        if (reqId === this._reqId) restoreBuilderSelection();
        return false;
      })
      .finally(() => {
        window.clearTimeout(builderRequestTimeout);
        if (reqId === this._reqId && this._controller === controller) {
          this.build_loader = false;
          this._controller = null;
          this._pendingKey = '';
          this._loadBuilderPromise = null;
          if (stage === 'bases') this._pendingBuilderBaseRollback = null;
        }
      });

    this._loadBuilderPromise = loadOperation;
    return loadOperation;
  }
};

const wish = {
  wishing(topic, payload) {
    this.wishing_loading = true;
    fetch(`/apps/features/wishlist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
          topic: topic,
          payload: payload,
      })
    })
    .then(response => {
      // Handle the response
      if (response.ok) {
        console.log("Wishing: Success");
      } else {
        this.error_title = '🧞‍♂️ Oops, something went wrong!', this.error_message = "Let's try wishing again later.", this.show_alert = true;
      }
    })
    .catch(error => {
      console.error("Wishing:", error);
    })
    .finally(() => {
      this.wishing_loading = false;
    });
  },

  getWishlist() {
    this.wishlist_loading = true;
    fetch(`/apps/features/wishlist`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then((response) => response.json())
    .then((data) => { 
      this.wishlist = data;
    })
    .catch(error => {
      console.error("Wishlist:", error);
      this.error_title = '🧞‍♂️ Oops, something went wrong!', this.error_message = "Give your wishlist a little break and come back later to view it.", this.show_alert = true;
    })
    .finally(() => {
      this.wishlist_loading = false;
    });
  },

  getSharedWishlist() {
    this.wishlist_loading = true;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const id = params.get('id');
    const name = params.get('name');

    // Retrieve a shared wishlist
    fetch(`/apps/features/sharedwishlist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        name,
      })
    })

    .then((response) => response.json())
    .then((data) => { 
      this.wishlist = data.wishlist;
      this.wishlist_owner = data.customer_name;      
    })
    .catch(error => {
      console.error("Wishlist:", error);
      this.error_title = '🧞‍♂️ Oops, something went wrong!', this.error_message = "Try viewing this wishlist later.", this.show_alert = true;
    })
    .finally(() => {
      this.wishlist_loading = false;
    });

  }

};
// CUSTOM END
window.app = function() {
  return {
    // Spread globals
    ...globals,
    ...cart,
    ...search,
    ...products,
    ...collections,
    ...utils,
    ...Shopify$1,
    ...buildCollection,
    ...wish
  };
};
window.checkoutWhenCartSettled = function() {
  const rootData = (document.documentElement?._x_dataStack || []).find(scope =>
    scope && typeof scope.checkoutWhenCartSettled === 'function'
  );

  if (rootData) {
    try {
      return Promise.resolve(rootData.checkoutWhenCartSettled()).catch(error => {
        console.error('Checkout redirect failed:', error);
        window.location.assign('/checkout');
      });
    } catch (error) {
      console.error('Checkout redirect failed:', error);
      window.location.assign('/checkout');
      return Promise.resolve();
    }
  }

  window.location.assign('/checkout');
  return Promise.resolve();
};
window.resetCheckoutLoadingStates = function() {
  const seenScopes = new Set();
  document.querySelectorAll('*').forEach(element => {
    (element._x_dataStack || []).forEach(scope => {
      if (!scope || seenScopes.has(scope)) return;
      seenScopes.add(scope);
      if (Object.prototype.hasOwnProperty.call(scope, 'checkout_redirecting')) {
        scope.checkout_redirecting = false;
      }
      if (Object.prototype.hasOwnProperty.call(scope, 'checkout_button_loading')) {
        scope.checkout_button_loading = false;
      }
    });
  });
  window.dispatchEvent(new CustomEvent('checkout:reset'));
};
window.addEventListener('pageshow', () => {
  window.resetCheckoutLoadingStates();
  requestAnimationFrame(() => window.resetCheckoutLoadingStates());
  setTimeout(() => window.resetCheckoutLoadingStates(), 100);
});
/*! instant.page v5.1.1 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
let mouseoverTimer;
let lastTouchTimestamp;
const prefetches = /* @__PURE__ */ new Set();
const prefetchElement = document.createElement("link");
const isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports("prefetch") && window.IntersectionObserver && "isIntersecting" in IntersectionObserverEntry.prototype;
const allowQueryString = "instantAllowQueryString" in document.body.dataset;
const allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;
const useWhitelist = "instantWhitelist" in document.body.dataset;
const mousedownShortcut = "instantMousedownShortcut" in document.body.dataset;
const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
let delayOnHover = 65;
let useMousedown = false;
let useMousedownOnly = false;
let useViewport = false;
if ("instantIntensity" in document.body.dataset) {
  const intensity = document.body.dataset.instantIntensity;
  if (intensity.substr(0, "mousedown".length) == "mousedown") {
    useMousedown = true;
    if (intensity == "mousedown-only") {
      useMousedownOnly = true;
    }
  } else if (intensity.substr(0, "viewport".length) == "viewport") {
    if (!(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g")))) {
      if (intensity == "viewport") {
        if (document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4) {
          useViewport = true;
        }
      } else if (intensity == "viewport-all") {
        useViewport = true;
      }
    }
  } else {
    const milliseconds = parseInt(intensity);
    if (!isNaN(milliseconds)) {
      delayOnHover = milliseconds;
    }
  }
}
if (isSupported) {
  const eventListenersOptions = {
    capture: true,
    passive: true
  };
  if (!useMousedownOnly) {
    document.addEventListener("touchstart", touchstartListener, eventListenersOptions);
  }
  if (!useMousedown) {
    document.addEventListener("mouseover", mouseoverListener, eventListenersOptions);
  } else if (!mousedownShortcut) {
    document.addEventListener("mousedown", mousedownListener, eventListenersOptions);
  }
  if (mousedownShortcut) {
    document.addEventListener("mousedown", mousedownShortcutListener, eventListenersOptions);
  }
  if (useViewport) {
    let triggeringFunction;
    if (window.requestIdleCallback) {
      triggeringFunction = (callback) => {
        requestIdleCallback(callback, {
          timeout: 1500
        });
      };
    } else {
      triggeringFunction = (callback) => {
        callback();
      };
    }
    triggeringFunction(() => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const linkElement = entry.target;
            intersectionObserver.unobserve(linkElement);
            preload(linkElement.href);
          }
        });
      });
      document.querySelectorAll("a").forEach((linkElement) => {
        if (isPreloadable(linkElement)) {
          intersectionObserver.observe(linkElement);
        }
      });
    });
  }
}
function touchstartListener(event) {
  lastTouchTimestamp = performance.now();
  const linkElement = event.target.closest("a");
  if (!isPreloadable(linkElement)) {
    return;
  }
  preload(linkElement.href);
}
function mouseoverListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }
  if (!("closest" in event.target)) {
    return;
  }
  const linkElement = event.target.closest("a");
  if (!isPreloadable(linkElement)) {
    return;
  }
  linkElement.addEventListener("mouseout", mouseoutListener, { passive: true });
  mouseoverTimer = setTimeout(() => {
    preload(linkElement.href);
    mouseoverTimer = void 0;
  }, delayOnHover);
}
function mousedownListener(event) {
  const linkElement = event.target.closest("a");
  if (!isPreloadable(linkElement)) {
    return;
  }
  preload(linkElement.href);
}
function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest("a") == event.relatedTarget.closest("a")) {
    return;
  }
  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = void 0;
  }
}
function mousedownShortcutListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }
  const linkElement = event.target.closest("a");
  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return;
  }
  if (!linkElement) {
    return;
  }
  linkElement.addEventListener("click", function(event2) {
    if (event2.detail == 1337) {
      return;
    }
    event2.preventDefault();
  }, { capture: true, passive: false, once: true });
  const customEvent = new MouseEvent("click", { view: window, bubbles: true, cancelable: false, detail: 1337 });
  linkElement.dispatchEvent(customEvent);
}
function isPreloadable(linkElement) {
  if (!linkElement || !linkElement.href) {
    return;
  }
  if (useWhitelist && !("instant" in linkElement.dataset)) {
    return;
  }
  if (!allowExternalLinks && linkElement.origin != location.origin && !("instant" in linkElement.dataset)) {
    return;
  }
  if (!["http:", "https:"].includes(linkElement.protocol)) {
    return;
  }
  if (linkElement.protocol == "http:" && location.protocol == "https:") {
    return;
  }
  if (!allowQueryString && linkElement.search && !("instant" in linkElement.dataset)) {
    return;
  }
  if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
    return;
  }
  if ("noInstant" in linkElement.dataset) {
    return;
  }
  return true;
}
function preload(url) {
  if (prefetches.has(url)) {
    return;
  }
  const prefetcher = document.createElement("link");
  prefetcher.rel = "prefetch";
  prefetcher.href = url;
  document.head.appendChild(prefetcher);
  prefetches.add(url);
}
var flushPending = false;
var flushing = false;
var queue = [];
var lastFlushedIndex = -1;
function scheduler(callback) {
  queueJob(callback);
}
function queueJob(job) {
  if (!queue.includes(job))
    queue.push(job);
  queueFlush();
}
function dequeueJob(job) {
  let index = queue.indexOf(job);
  if (index !== -1 && index > lastFlushedIndex)
    queue.splice(index, 1);
}
function queueFlush() {
  if (!flushing && !flushPending) {
    flushPending = true;
    queueMicrotask(flushJobs);
  }
}
function flushJobs() {
  flushPending = false;
  flushing = true;
  for (let i = 0; i < queue.length; i++) {
    queue[i]();
    lastFlushedIndex = i;
  }
  queue.length = 0;
  lastFlushedIndex = -1;
  flushing = false;
}
var reactive;
var effect;
var release;
var raw;
var shouldSchedule = true;
function disableEffectScheduling(callback) {
  shouldSchedule = false;
  callback();
  shouldSchedule = true;
}
function setReactivityEngine(engine) {
  reactive = engine.reactive;
  release = engine.release;
  effect = (callback) => engine.effect(callback, { scheduler: (task) => {
    if (shouldSchedule) {
      scheduler(task);
    } else {
      task();
    }
  } });
  raw = engine.raw;
}
function overrideEffect(override) {
  effect = override;
}
function elementBoundEffect(el) {
  let cleanup2 = () => {
  };
  let wrappedEffect = (callback) => {
    let effectReference = effect(callback);
    if (!el._x_effects) {
      el._x_effects = /* @__PURE__ */ new Set();
      el._x_runEffects = () => {
        el._x_effects.forEach((i) => i());
      };
    }
    el._x_effects.add(effectReference);
    cleanup2 = () => {
      if (effectReference === void 0)
        return;
      el._x_effects.delete(effectReference);
      release(effectReference);
    };
    return effectReference;
  };
  return [wrappedEffect, () => {
    cleanup2();
  }];
}
var onAttributeAddeds = [];
var onElRemoveds = [];
var onElAddeds = [];
function onElAdded(callback) {
  onElAddeds.push(callback);
}
function onElRemoved(el, callback) {
  if (typeof callback === "function") {
    if (!el._x_cleanups)
      el._x_cleanups = [];
    el._x_cleanups.push(callback);
  } else {
    callback = el;
    onElRemoveds.push(callback);
  }
}
function onAttributesAdded(callback) {
  onAttributeAddeds.push(callback);
}
function onAttributeRemoved(el, name, callback) {
  if (!el._x_attributeCleanups)
    el._x_attributeCleanups = {};
  if (!el._x_attributeCleanups[name])
    el._x_attributeCleanups[name] = [];
  el._x_attributeCleanups[name].push(callback);
}
function cleanupAttributes(el, names) {
  if (!el._x_attributeCleanups)
    return;
  Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
    if (names === void 0 || names.includes(name)) {
      value.forEach((i) => i());
      delete el._x_attributeCleanups[name];
    }
  });
}
var observer = new MutationObserver(onMutate);
var currentlyObserving = false;
function startObservingMutations() {
  observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
  currentlyObserving = true;
}
function stopObservingMutations() {
  flushObserver();
  observer.disconnect();
  currentlyObserving = false;
}
var recordQueue = [];
var willProcessRecordQueue = false;
function flushObserver() {
  recordQueue = recordQueue.concat(observer.takeRecords());
  if (recordQueue.length && !willProcessRecordQueue) {
    willProcessRecordQueue = true;
    queueMicrotask(() => {
      processRecordQueue();
      willProcessRecordQueue = false;
    });
  }
}
function processRecordQueue() {
  onMutate(recordQueue);
  recordQueue.length = 0;
}
function mutateDom(callback) {
  if (!currentlyObserving)
    return callback();
  stopObservingMutations();
  let result = callback();
  startObservingMutations();
  return result;
}
var isCollecting = false;
var deferredMutations = [];
function deferMutations() {
  isCollecting = true;
}
function flushAndStopDeferringMutations() {
  isCollecting = false;
  onMutate(deferredMutations);
  deferredMutations = [];
}
function onMutate(mutations) {
  if (isCollecting) {
    deferredMutations = deferredMutations.concat(mutations);
    return;
  }
  let addedNodes = [];
  let removedNodes = [];
  let addedAttributes = /* @__PURE__ */ new Map();
  let removedAttributes = /* @__PURE__ */ new Map();
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].target._x_ignoreMutationObserver)
      continue;
    if (mutations[i].type === "childList") {
      mutations[i].addedNodes.forEach((node) => node.nodeType === 1 && addedNodes.push(node));
      mutations[i].removedNodes.forEach((node) => node.nodeType === 1 && removedNodes.push(node));
    }
    if (mutations[i].type === "attributes") {
      let el = mutations[i].target;
      let name = mutations[i].attributeName;
      let oldValue = mutations[i].oldValue;
      let add2 = () => {
        if (!addedAttributes.has(el))
          addedAttributes.set(el, []);
        addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
      };
      let remove = () => {
        if (!removedAttributes.has(el))
          removedAttributes.set(el, []);
        removedAttributes.get(el).push(name);
      };
      if (el.hasAttribute(name) && oldValue === null) {
        add2();
      } else if (el.hasAttribute(name)) {
        remove();
        add2();
      } else {
        remove();
      }
    }
  }
  removedAttributes.forEach((attrs, el) => {
    cleanupAttributes(el, attrs);
  });
  addedAttributes.forEach((attrs, el) => {
    onAttributeAddeds.forEach((i) => i(el, attrs));
  });
  for (let node of removedNodes) {
    if (addedNodes.includes(node))
      continue;
    onElRemoveds.forEach((i) => i(node));
    if (node._x_cleanups) {
      while (node._x_cleanups.length)
        node._x_cleanups.pop()();
    }
  }
  addedNodes.forEach((node) => {
    node._x_ignoreSelf = true;
    node._x_ignore = true;
  });
  for (let node of addedNodes) {
    if (removedNodes.includes(node))
      continue;
    if (!node.isConnected)
      continue;
    delete node._x_ignoreSelf;
    delete node._x_ignore;
    onElAddeds.forEach((i) => i(node));
    node._x_ignore = true;
    node._x_ignoreSelf = true;
  }
  addedNodes.forEach((node) => {
    delete node._x_ignoreSelf;
    delete node._x_ignore;
  });
  addedNodes = null;
  removedNodes = null;
  addedAttributes = null;
  removedAttributes = null;
}
function scope(node) {
  return mergeProxies(closestDataStack(node));
}
function addScopeToNode(node, data2, referenceNode) {
  node._x_dataStack = [data2, ...closestDataStack(referenceNode || node)];
  return () => {
    node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
  };
}
function refreshScope(element, scope2) {
  let existingScope = element._x_dataStack[0];
  Object.entries(scope2).forEach(([key, value]) => {
    existingScope[key] = value;
  });
}
function closestDataStack(node) {
  if (node._x_dataStack)
    return node._x_dataStack;
  if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
    return closestDataStack(node.host);
  }
  if (!node.parentNode) {
    return [];
  }
  return closestDataStack(node.parentNode);
}
function mergeProxies(objects) {
  let thisProxy = new Proxy({}, {
    ownKeys: () => {
      return Array.from(new Set(objects.flatMap((i) => Object.keys(i))));
    },
    has: (target, name) => {
      return objects.some((obj) => obj.hasOwnProperty(name));
    },
    get: (target, name) => {
      return (objects.find((obj) => {
        if (obj.hasOwnProperty(name)) {
          let descriptor = Object.getOwnPropertyDescriptor(obj, name);
          if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) {
            return true;
          }
          if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
            let getter = descriptor.get;
            let setter = descriptor.set;
            let property = descriptor;
            getter = getter && getter.bind(thisProxy);
            setter = setter && setter.bind(thisProxy);
            if (getter)
              getter._x_alreadyBound = true;
            if (setter)
              setter._x_alreadyBound = true;
            Object.defineProperty(obj, name, {
              ...property,
              get: getter,
              set: setter
            });
          }
          return true;
        }
        return false;
      }) || {})[name];
    },
    set: (target, name, value) => {
      let closestObjectWithKey = objects.find((obj) => obj.hasOwnProperty(name));
      if (closestObjectWithKey) {
        closestObjectWithKey[name] = value;
      } else {
        objects[objects.length - 1][name] = value;
      }
      return true;
    }
  });
  return thisProxy;
}
function initInterceptors(data2) {
  let isObject2 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
  let recurse = (obj, basePath = "") => {
    Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value, enumerable }]) => {
      if (enumerable === false || value === void 0)
        return;
      let path = basePath === "" ? key : `${basePath}.${key}`;
      if (typeof value === "object" && value !== null && value._x_interceptor) {
        obj[key] = value.initialize(data2, path, key);
      } else {
        if (isObject2(value) && value !== obj && !(value instanceof Element)) {
          recurse(value, path);
        }
      }
    });
  };
  return recurse(data2);
}
function interceptor(callback, mutateObj = () => {
}) {
  let obj = {
    initialValue: void 0,
    _x_interceptor: true,
    initialize(data2, path, key) {
      return callback(this.initialValue, () => get(data2, path), (value) => set(data2, path, value), path, key);
    }
  };
  mutateObj(obj);
  return (initialValue) => {
    if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
      let initialize = obj.initialize.bind(obj);
      obj.initialize = (data2, path, key) => {
        let innerValue = initialValue.initialize(data2, path, key);
        obj.initialValue = innerValue;
        return initialize(data2, path, key);
      };
    } else {
      obj.initialValue = initialValue;
    }
    return obj;
  };
}
function get(obj, path) {
  return path.split(".").reduce((carry, segment) => carry[segment], obj);
}
function set(obj, path, value) {
  if (typeof path === "string")
    path = path.split(".");
  if (path.length === 1)
    obj[path[0]] = value;
  else if (path.length === 0)
    throw error;
  else {
    if (obj[path[0]])
      return set(obj[path[0]], path.slice(1), value);
    else {
      obj[path[0]] = {};
      return set(obj[path[0]], path.slice(1), value);
    }
  }
}
var magics = {};
function magic(name, callback) {
  magics[name] = callback;
}
function injectMagics(obj, el) {
  Object.entries(magics).forEach(([name, callback]) => {
    Object.defineProperty(obj, `$${name}`, {
      get() {
        let [utilities, cleanup2] = getElementBoundUtilities(el);
        utilities = { interceptor, ...utilities };
        onElRemoved(el, cleanup2);
        return callback(el, utilities);
      },
      enumerable: false
    });
  });
  return obj;
}
function tryCatch(el, expression, callback, ...args) {
  try {
    return callback(...args);
  } catch (e) {
    handleError(e, el, expression);
  }
}
function handleError(error2, el, expression = void 0) {
  Object.assign(error2, { el, expression });
  console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
  setTimeout(() => {
    throw error2;
  }, 0);
}
var shouldAutoEvaluateFunctions = true;
function dontAutoEvaluateFunctions(callback) {
  let cache = shouldAutoEvaluateFunctions;
  shouldAutoEvaluateFunctions = false;
  callback();
  shouldAutoEvaluateFunctions = cache;
}
function evaluate(el, expression, extras = {}) {
  let result;
  evaluateLater(el, expression)((value) => result = value, extras);
  return result;
}
function evaluateLater(...args) {
  return theEvaluatorFunction(...args);
}
var theEvaluatorFunction = normalEvaluator;
function setEvaluator(newEvaluator) {
  theEvaluatorFunction = newEvaluator;
}
function normalEvaluator(el, expression) {
  let overriddenMagics = {};
  injectMagics(overriddenMagics, el);
  let dataStack = [overriddenMagics, ...closestDataStack(el)];
  let evaluator = typeof expression === "function" ? generateEvaluatorFromFunction(dataStack, expression) : generateEvaluatorFromString(dataStack, expression, el);
  return tryCatch.bind(null, el, expression, evaluator);
}
function generateEvaluatorFromFunction(dataStack, func) {
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
    runIfTypeOfFunction(receiver, result);
  };
}
var evaluatorMemo = {};
function generateFunctionFromString(expression, el) {
  if (evaluatorMemo[expression]) {
    return evaluatorMemo[expression];
  }
  let AsyncFunction = Object.getPrototypeOf(async function() {
  }).constructor;
  let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(async()=>{ ${expression} })()` : expression;
  const safeAsyncFunction = () => {
    try {
      return new AsyncFunction(["__self", "scope"], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
    } catch (error2) {
      handleError(error2, el, expression);
      return Promise.resolve();
    }
  };
  let func = safeAsyncFunction();
  evaluatorMemo[expression] = func;
  return func;
}
function generateEvaluatorFromString(dataStack, expression, el) {
  let func = generateFunctionFromString(expression, el);
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    func.result = void 0;
    func.finished = false;
    let completeScope = mergeProxies([scope2, ...dataStack]);
    if (typeof func === "function") {
      let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
      if (func.finished) {
        runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
        func.result = void 0;
      } else {
        promise.then((result) => {
          runIfTypeOfFunction(receiver, result, completeScope, params, el);
        }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
      }
    }
  };
}
function runIfTypeOfFunction(receiver, value, scope2, params, el) {
  if (shouldAutoEvaluateFunctions && typeof value === "function") {
    let result = value.apply(scope2, params);
    if (result instanceof Promise) {
      result.then((i) => runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2) => handleError(error2, el, value));
    } else {
      receiver(result);
    }
  } else if (typeof value === "object" && value instanceof Promise) {
    value.then((i) => receiver(i));
  } else {
    receiver(value);
  }
}
var prefixAsString = "x-";
function prefix(subject = "") {
  return prefixAsString + subject;
}
function setPrefix(newPrefix) {
  prefixAsString = newPrefix;
}
var directiveHandlers = {};
function directive(name, callback) {
  directiveHandlers[name] = callback;
  return {
    before(directive2) {
      if (!directiveHandlers[directive2]) {
        console.warn(
          "Cannot find directive `${directive}`. `${name}` will use the default order of execution"
        );
        return;
      }
      const pos = directiveOrder.indexOf(directive2);
      directiveOrder.splice(pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"), 0, name);
    }
  };
}
function directives(el, attributes, originalAttributeOverride) {
  attributes = Array.from(attributes);
  if (el._x_virtualDirectives) {
    let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(vAttributes);
    vAttributes = vAttributes.map((attribute) => {
      if (staticAttributes.find((attr) => attr.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    attributes = attributes.concat(vAttributes);
  }
  let transformedAttributeMap = {};
  let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
  return directives2.map((directive2) => {
    return getDirectiveHandler(el, directive2);
  });
}
function attributesOnly(attributes) {
  return Array.from(attributes).map(toTransformedAttributes()).filter((attr) => !outNonAlpineAttributes(attr));
}
var isDeferringHandlers = false;
var directiveHandlerStacks = /* @__PURE__ */ new Map();
var currentHandlerStackKey = Symbol();
function deferHandlingDirectives(callback) {
  isDeferringHandlers = true;
  let key = Symbol();
  currentHandlerStackKey = key;
  directiveHandlerStacks.set(key, []);
  let flushHandlers = () => {
    while (directiveHandlerStacks.get(key).length)
      directiveHandlerStacks.get(key).shift()();
    directiveHandlerStacks.delete(key);
  };
  let stopDeferring = () => {
    isDeferringHandlers = false;
    flushHandlers();
  };
  callback(flushHandlers);
  stopDeferring();
}
function getElementBoundUtilities(el) {
  let cleanups = [];
  let cleanup2 = (callback) => cleanups.push(callback);
  let [effect3, cleanupEffect] = elementBoundEffect(el);
  cleanups.push(cleanupEffect);
  let utilities = {
    Alpine: alpine_default,
    effect: effect3,
    cleanup: cleanup2,
    evaluateLater: evaluateLater.bind(evaluateLater, el),
    evaluate: evaluate.bind(evaluate, el)
  };
  let doCleanup = () => cleanups.forEach((i) => i());
  return [utilities, doCleanup];
}
function getDirectiveHandler(el, directive2) {
  let noop = () => {
  };
  let handler3 = directiveHandlers[directive2.type] || noop;
  let [utilities, cleanup2] = getElementBoundUtilities(el);
  onAttributeRemoved(el, directive2.original, cleanup2);
  let fullHandler = () => {
    if (el._x_ignore || el._x_ignoreSelf)
      return;
    handler3.inline && handler3.inline(el, directive2, utilities);
    handler3 = handler3.bind(handler3, el, directive2, utilities);
    isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler3) : handler3();
  };
  fullHandler.runCleanups = cleanup2;
  return fullHandler;
}
var startingWith = (subject, replacement) => ({ name, value }) => {
  if (name.startsWith(subject))
    name = name.replace(subject, replacement);
  return { name, value };
};
var into = (i) => i;
function toTransformedAttributes(callback = () => {
}) {
  return ({ name, value }) => {
    let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform) => {
      return transform(carry);
    }, { name, value });
    if (newName !== name)
      callback(newName, name);
    return { name: newName, value: newValue };
  };
}
var attributeTransformers = [];
function mapAttributes(callback) {
  attributeTransformers.push(callback);
}
function outNonAlpineAttributes({ name }) {
  return alpineAttributeRegex().test(name);
}
var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
  return ({ name, value }) => {
    let typeMatch = name.match(alpineAttributeRegex());
    let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
    let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
    let original = originalAttributeOverride || transformedAttributeMap[name] || name;
    return {
      type: typeMatch ? typeMatch[1] : null,
      value: valueMatch ? valueMatch[1] : null,
      modifiers: modifiers.map((i) => i.replace(".", "")),
      expression: value,
      original
    };
  };
}
var DEFAULT = "DEFAULT";
var directiveOrder = [
  "ignore",
  "ref",
  "data",
  "id",
  "bind",
  "init",
  "for",
  "model",
  "modelable",
  "transition",
  "show",
  "if",
  DEFAULT,
  "teleport"
];
function byPriority(a, b) {
  let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
  let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
  return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
}
function dispatch(el, name, detail = {}) {
  el.dispatchEvent(
    new CustomEvent(name, {
      detail,
      bubbles: true,
      // Allows events to pass the shadow DOM barrier.
      composed: true,
      cancelable: true
    })
  );
}
function walk(el, callback) {
  if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
    Array.from(el.children).forEach((el2) => walk(el2, callback));
    return;
  }
  let skip = false;
  callback(el, () => skip = true);
  if (skip)
    return;
  let node = el.firstElementChild;
  while (node) {
    walk(node, callback);
    node = node.nextElementSibling;
  }
}
function warn(message, ...args) {
  console.warn(`Alpine Warning: ${message}`, ...args);
}
function start() {
  if (!document.body)
    warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
  dispatch(document, "alpine:init");
  dispatch(document, "alpine:initializing");
  startObservingMutations();
  onElAdded((el) => initTree(el, walk));
  onElRemoved((el) => destroyTree(el));
  onAttributesAdded((el, attrs) => {
    directives(el, attrs).forEach((handle) => handle());
  });
  let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
  Array.from(document.querySelectorAll(allSelectors())).filter(outNestedComponents).forEach((el) => {
    initTree(el);
  });
  dispatch(document, "alpine:initialized");
}
var rootSelectorCallbacks = [];
var initSelectorCallbacks = [];
function rootSelectors() {
  return rootSelectorCallbacks.map((fn) => fn());
}
function allSelectors() {
  return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
}
function addRootSelector(selectorCallback) {
  rootSelectorCallbacks.push(selectorCallback);
}
function addInitSelector(selectorCallback) {
  initSelectorCallbacks.push(selectorCallback);
}
function closestRoot(el, includeInitSelectors = false) {
  return findClosest(el, (element) => {
    const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
    if (selectors.some((selector) => element.matches(selector)))
      return true;
  });
}
function findClosest(el, callback) {
  if (!el)
    return;
  if (callback(el))
    return el;
  if (el._x_teleportBack)
    el = el._x_teleportBack;
  if (!el.parentElement)
    return;
  return findClosest(el.parentElement, callback);
}
function isRoot(el) {
  return rootSelectors().some((selector) => el.matches(selector));
}
var initInterceptors2 = [];
function interceptInit(callback) {
  initInterceptors2.push(callback);
}
function initTree(el, walker = walk, intercept = () => {
}) {
  deferHandlingDirectives(() => {
    walker(el, (el2, skip) => {
      intercept(el2, skip);
      initInterceptors2.forEach((i) => i(el2, skip));
      directives(el2, el2.attributes).forEach((handle) => handle());
      el2._x_ignore && skip();
    });
  });
}
function destroyTree(root) {
  walk(root, (el) => cleanupAttributes(el));
}
var tickStack = [];
var isHolding = false;
function nextTick(callback = () => {
}) {
  queueMicrotask(() => {
    isHolding || setTimeout(() => {
      releaseNextTicks();
    });
  });
  return new Promise((res) => {
    tickStack.push(() => {
      callback();
      res();
    });
  });
}
function releaseNextTicks() {
  isHolding = false;
  while (tickStack.length)
    tickStack.shift()();
}
function holdNextTicks() {
  isHolding = true;
}
function setClasses(el, value) {
  if (Array.isArray(value)) {
    return setClassesFromString(el, value.join(" "));
  } else if (typeof value === "object" && value !== null) {
    return setClassesFromObject(el, value);
  } else if (typeof value === "function") {
    return setClasses(el, value());
  }
  return setClassesFromString(el, value);
}
function setClassesFromString(el, classString) {
  let missingClasses = (classString2) => classString2.split(" ").filter((i) => !el.classList.contains(i)).filter(Boolean);
  let addClassesAndReturnUndo = (classes) => {
    el.classList.add(...classes);
    return () => {
      el.classList.remove(...classes);
    };
  };
  classString = classString === true ? classString = "" : classString || "";
  return addClassesAndReturnUndo(missingClasses(classString));
}
function setClassesFromObject(el, classObject) {
  let split = (classString) => classString.split(" ").filter(Boolean);
  let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
  let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
  let added = [];
  let removed = [];
  forRemove.forEach((i) => {
    if (el.classList.contains(i)) {
      el.classList.remove(i);
      removed.push(i);
    }
  });
  forAdd.forEach((i) => {
    if (!el.classList.contains(i)) {
      el.classList.add(i);
      added.push(i);
    }
  });
  return () => {
    removed.forEach((i) => el.classList.add(i));
    added.forEach((i) => el.classList.remove(i));
  };
}
function setStyles(el, value) {
  if (typeof value === "object" && value !== null) {
    return setStylesFromObject(el, value);
  }
  return setStylesFromString(el, value);
}
function setStylesFromObject(el, value) {
  let previousStyles = {};
  Object.entries(value).forEach(([key, value2]) => {
    previousStyles[key] = el.style[key];
    if (!key.startsWith("--")) {
      key = kebabCase(key);
    }
    el.style.setProperty(key, value2);
  });
  setTimeout(() => {
    if (el.style.length === 0) {
      el.removeAttribute("style");
    }
  });
  return () => {
    setStyles(el, previousStyles);
  };
}
function setStylesFromString(el, value) {
  let cache = el.getAttribute("style", value);
  el.setAttribute("style", value);
  return () => {
    el.setAttribute("style", cache || "");
  };
}
function kebabCase(subject) {
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function once(callback, fallback = () => {
}) {
  let called = false;
  return function() {
    if (!called) {
      called = true;
      callback.apply(this, arguments);
    } else {
      fallback.apply(this, arguments);
    }
  };
}
directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "function")
    expression = evaluate2(expression);
  if (!expression) {
    registerTransitionsFromHelper(el, modifiers, value);
  } else {
    registerTransitionsFromClassString(el, expression, value);
  }
});
function registerTransitionsFromClassString(el, classString, stage) {
  registerTransitionObject(el, setClasses, "");
  let directiveStorageMap = {
    "enter": (classes) => {
      el._x_transition.enter.during = classes;
    },
    "enter-start": (classes) => {
      el._x_transition.enter.start = classes;
    },
    "enter-end": (classes) => {
      el._x_transition.enter.end = classes;
    },
    "leave": (classes) => {
      el._x_transition.leave.during = classes;
    },
    "leave-start": (classes) => {
      el._x_transition.leave.start = classes;
    },
    "leave-end": (classes) => {
      el._x_transition.leave.end = classes;
    }
  };
  directiveStorageMap[stage](classString);
}
function registerTransitionsFromHelper(el, modifiers, stage) {
  registerTransitionObject(el, setStyles);
  let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
  let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
  let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
  if (modifiers.includes("in") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index) => index < modifiers.indexOf("out"));
  }
  if (modifiers.includes("out") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index) => index > modifiers.indexOf("out"));
  }
  let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
  let wantsOpacity = wantsAll || modifiers.includes("opacity");
  let wantsScale = wantsAll || modifiers.includes("scale");
  let opacityValue = wantsOpacity ? 0 : 1;
  let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
  let delay3 = modifierValue(modifiers, "delay", 0);
  let origin = modifierValue(modifiers, "origin", "center");
  let property = "opacity, transform";
  let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
  let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
  let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
  if (transitioningIn) {
    el._x_transition.enter.during = {
      transformOrigin: origin,
      transitionDelay: delay3,
      transitionProperty: property,
      transitionDuration: `${durationIn}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.enter.start = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
    el._x_transition.enter.end = {
      opacity: 1,
      transform: `scale(1)`
    };
  }
  if (transitioningOut) {
    el._x_transition.leave.during = {
      transformOrigin: origin,
      transitionDelay: delay3,
      transitionProperty: property,
      transitionDuration: `${durationOut}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.leave.start = {
      opacity: 1,
      transform: `scale(1)`
    };
    el._x_transition.leave.end = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
  }
}
function registerTransitionObject(el, setFunction, defaultValue = {}) {
  if (!el._x_transition)
    el._x_transition = {
      enter: { during: defaultValue, start: defaultValue, end: defaultValue },
      leave: { during: defaultValue, start: defaultValue, end: defaultValue },
      in(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.enter.during,
          start: this.enter.start,
          end: this.enter.end
        }, before, after);
      },
      out(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.leave.during,
          start: this.leave.start,
          end: this.leave.end
        }, before, after);
      }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
  const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
  let clickAwayCompatibleShow = () => nextTick2(show);
  if (value) {
    if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
      el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
    } else {
      el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
    }
    return;
  }
  el._x_hidePromise = el._x_transition ? new Promise((resolve, reject) => {
    el._x_transition.out(() => {
    }, () => resolve(hide));
    el._x_transitioning.beforeCancel(() => reject({ isFromCancelledTransition: true }));
  }) : Promise.resolve(hide);
  queueMicrotask(() => {
    let closest = closestHide(el);
    if (closest) {
      if (!closest._x_hideChildren)
        closest._x_hideChildren = [];
      closest._x_hideChildren.push(el);
    } else {
      nextTick2(() => {
        let hideAfterChildren = (el2) => {
          let carry = Promise.all([
            el2._x_hidePromise,
            ...(el2._x_hideChildren || []).map(hideAfterChildren)
          ]).then(([i]) => typeof i === "function" ? i() : void 0);
          delete el2._x_hidePromise;
          delete el2._x_hideChildren;
          return carry;
        };
        hideAfterChildren(el).catch((e) => {
          if (!e?.isFromCancelledTransition)
            throw e;
        });
      });
    }
  });
};
function closestHide(el) {
  let parent = el.parentNode;
  if (!parent)
    return;
  return parent._x_hidePromise ? parent : closestHide(parent);
}
function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
}, after = () => {
}) {
  if (el._x_transitioning)
    el._x_transitioning.cancel();
  if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
    before();
    after();
    return;
  }
  let undoStart, undoDuring, undoEnd;
  performTransition(el, {
    start() {
      undoStart = setFunction(el, start2);
    },
    during() {
      undoDuring = setFunction(el, during);
    },
    before,
    end() {
      undoStart();
      undoEnd = setFunction(el, end);
    },
    after,
    cleanup() {
      undoDuring();
      undoEnd();
    }
  });
}
function performTransition(el, stages) {
  let interrupted, reachedBefore, reachedEnd;
  let finish = once(() => {
    mutateDom(() => {
      interrupted = true;
      if (!reachedBefore)
        stages.before();
      if (!reachedEnd) {
        stages.end();
        releaseNextTicks();
      }
      stages.after();
      if (el.isConnected)
        stages.cleanup();
      delete el._x_transitioning;
    });
  });
  el._x_transitioning = {
    beforeCancels: [],
    beforeCancel(callback) {
      this.beforeCancels.push(callback);
    },
    cancel: once(function() {
      while (this.beforeCancels.length) {
        this.beforeCancels.shift()();
      }
      finish();
    }),
    finish
  };
  mutateDom(() => {
    stages.start();
    stages.during();
  });
  holdNextTicks();
  requestAnimationFrame(() => {
    if (interrupted)
      return;
    let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
    let delay3 = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
    if (duration === 0)
      duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
    mutateDom(() => {
      stages.before();
    });
    reachedBefore = true;
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      mutateDom(() => {
        stages.end();
      });
      releaseNextTicks();
      setTimeout(el._x_transitioning.finish, duration + delay3);
      reachedEnd = true;
    });
  });
}
function modifierValue(modifiers, key, fallback) {
  if (modifiers.indexOf(key) === -1)
    return fallback;
  const rawValue = modifiers[modifiers.indexOf(key) + 1];
  if (!rawValue)
    return fallback;
  if (key === "scale") {
    if (isNaN(rawValue))
      return fallback;
  }
  if (key === "duration") {
    let match = rawValue.match(/([0-9]+)ms/);
    if (match)
      return match[1];
  }
  if (key === "origin") {
    if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
      return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
    }
  }
  return rawValue;
}
var isCloning = false;
function skipDuringClone(callback, fallback = () => {
}) {
  return (...args) => isCloning ? fallback(...args) : callback(...args);
}
function onlyDuringClone(callback) {
  return (...args) => isCloning && callback(...args);
}
function clone(oldEl, newEl) {
  if (!newEl._x_dataStack)
    newEl._x_dataStack = oldEl._x_dataStack;
  isCloning = true;
  dontRegisterReactiveSideEffects(() => {
    cloneTree(newEl);
  });
  isCloning = false;
}
function cloneTree(el) {
  let hasRunThroughFirstEl = false;
  let shallowWalker = (el2, callback) => {
    walk(el2, (el3, skip) => {
      if (hasRunThroughFirstEl && isRoot(el3))
        return skip();
      hasRunThroughFirstEl = true;
      callback(el3, skip);
    });
  };
  initTree(el, shallowWalker);
}
function dontRegisterReactiveSideEffects(callback) {
  let cache = effect;
  overrideEffect((callback2, el) => {
    let storedEffect = cache(callback2);
    release(storedEffect);
    return () => {
    };
  });
  callback();
  overrideEffect(cache);
}
function bind(el, name, value, modifiers = []) {
  if (!el._x_bindings)
    el._x_bindings = reactive({});
  el._x_bindings[name] = value;
  name = modifiers.includes("camel") ? camelCase(name) : name;
  switch (name) {
    case "value":
      bindInputValue(el, value);
      break;
    case "style":
      bindStyles(el, value);
      break;
    case "class":
      bindClasses(el, value);
      break;
    default:
      bindAttribute(el, name, value);
      break;
  }
}
function bindInputValue(el, value) {
  if (el.type === "radio") {
    if (el.attributes.value === void 0) {
      el.value = value;
    }
    if (window.fromModel) {
      el.checked = checkedAttrLooseCompare(el.value, value);
    }
  } else if (el.type === "checkbox") {
    if (Number.isInteger(value)) {
      el.value = value;
    } else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
      el.value = String(value);
    } else {
      if (Array.isArray(value)) {
        el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
      } else {
        el.checked = !!value;
      }
    }
  } else if (el.tagName === "SELECT") {
    updateSelect(el, value);
  } else {
    if (el.value === value)
      return;
    el.value = value;
  }
}
function bindClasses(el, value) {
  if (el._x_undoAddedClasses)
    el._x_undoAddedClasses();
  el._x_undoAddedClasses = setClasses(el, value);
}
function bindStyles(el, value) {
  if (el._x_undoAddedStyles)
    el._x_undoAddedStyles();
  el._x_undoAddedStyles = setStyles(el, value);
}
function bindAttribute(el, name, value) {
  if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
    el.removeAttribute(name);
  } else {
    if (isBooleanAttr(name))
      value = name;
    setIfChanged(el, name, value);
  }
}
function setIfChanged(el, attrName, value) {
  if (el.getAttribute(attrName) != value) {
    el.setAttribute(attrName, value);
  }
}
function updateSelect(el, value) {
  const arrayWrappedValue = [].concat(value).map((value2) => {
    return value2 + "";
  });
  Array.from(el.options).forEach((option) => {
    option.selected = arrayWrappedValue.includes(option.value);
  });
}
function camelCase(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function checkedAttrLooseCompare(valueA, valueB) {
  return valueA == valueB;
}
function isBooleanAttr(attrName) {
  const booleanAttributes = [
    "disabled",
    "checked",
    "required",
    "readonly",
    "hidden",
    "open",
    "selected",
    "autofocus",
    "itemscope",
    "multiple",
    "novalidate",
    "allowfullscreen",
    "allowpaymentrequest",
    "formnovalidate",
    "autoplay",
    "controls",
    "loop",
    "muted",
    "playsinline",
    "default",
    "ismap",
    "reversed",
    "async",
    "defer",
    "nomodule"
  ];
  return booleanAttributes.includes(attrName);
}
function attributeShouldntBePreservedIfFalsy(name) {
  return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
}
function getBinding(el, name, fallback) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  let attr = el.getAttribute(name);
  if (attr === null)
    return typeof fallback === "function" ? fallback() : fallback;
  if (attr === "")
    return true;
  if (isBooleanAttr(name)) {
    return !![name, "true"].includes(attr);
  }
  return attr;
}
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function throttle(func, limit) {
  let inThrottle;
  return function() {
    let context = this, args = arguments;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
function plugin(callback) {
  callback(alpine_default);
}
var stores = {};
var isReactive = false;
function store(name, value) {
  if (!isReactive) {
    stores = reactive(stores);
    isReactive = true;
  }
  if (value === void 0) {
    return stores[name];
  }
  stores[name] = value;
  if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
    stores[name].init();
  }
  initInterceptors(stores[name]);
}
function getStores() {
  return stores;
}
var binds = {};
function bind2(name, bindings) {
  let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
  if (name instanceof Element) {
    applyBindingsObject(name, getBindings());
  } else {
    binds[name] = getBindings;
  }
}
function injectBindingProviders(obj) {
  Object.entries(binds).forEach(([name, callback]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback(...args);
        };
      }
    });
  });
  return obj;
}
function applyBindingsObject(el, obj, original) {
  let cleanupRunners = [];
  while (cleanupRunners.length)
    cleanupRunners.pop()();
  let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
  let staticAttributes = attributesOnly(attributes);
  attributes = attributes.map((attribute) => {
    if (staticAttributes.find((attr) => attr.name === attribute.name)) {
      return {
        name: `x-bind:${attribute.name}`,
        value: `"${attribute.value}"`
      };
    }
    return attribute;
  });
  directives(el, attributes, original).map((handle) => {
    cleanupRunners.push(handle.runCleanups);
    handle();
  });
}
var datas = {};
function data(name, callback) {
  datas[name] = callback;
}
function injectDataProviders(obj, context) {
  Object.entries(datas).forEach(([name, callback]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback.bind(context)(...args);
        };
      },
      enumerable: false
    });
  });
  return obj;
}
var Alpine = {
  get reactive() {
    return reactive;
  },
  get release() {
    return release;
  },
  get effect() {
    return effect;
  },
  get raw() {
    return raw;
  },
  version: "3.12.0",
  flushAndStopDeferringMutations,
  dontAutoEvaluateFunctions,
  disableEffectScheduling,
  startObservingMutations,
  stopObservingMutations,
  setReactivityEngine,
  closestDataStack,
  skipDuringClone,
  onlyDuringClone,
  addRootSelector,
  addInitSelector,
  addScopeToNode,
  deferMutations,
  mapAttributes,
  evaluateLater,
  interceptInit,
  setEvaluator,
  mergeProxies,
  findClosest,
  closestRoot,
  destroyTree,
  interceptor,
  // INTERNAL: not public API and is subject to change without major release.
  transition,
  // INTERNAL
  setStyles,
  // INTERNAL
  mutateDom,
  directive,
  throttle,
  debounce,
  evaluate,
  initTree,
  nextTick,
  prefixed: prefix,
  prefix: setPrefix,
  plugin,
  magic,
  store,
  start,
  clone,
  bound: getBinding,
  $data: scope,
  walk,
  data,
  bind: bind2
};
var alpine_default = Alpine;
function makeMap(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
}
var EMPTY_OBJ = Object.freeze({});
var extend = Object.assign;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var hasOwn = (val, key) => hasOwnProperty.call(val, key);
var isArray = Array.isArray;
var isMap = (val) => toTypeString(val) === "[object Map]";
var isString = (val) => typeof val === "string";
var isSymbol = (val) => typeof val === "symbol";
var isObject = (val) => val !== null && typeof val === "object";
var objectToString = Object.prototype.toString;
var toTypeString = (value) => objectToString.call(value);
var toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
var targetMap = /* @__PURE__ */ new WeakMap();
var effectStack = [];
var activeEffect;
var ITERATE_KEY = Symbol("iterate");
var MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function isEffect(fn) {
  return fn && fn._isEffect === true;
}
function effect2(fn, options = EMPTY_OBJ) {
  if (isEffect(fn)) {
    fn = fn.raw;
  }
  const effect3 = createReactiveEffect(fn, options);
  if (!options.lazy) {
    effect3();
  }
  return effect3;
}
function stop(effect3) {
  if (effect3.active) {
    cleanup(effect3);
    if (effect3.options.onStop) {
      effect3.options.onStop();
    }
    effect3.active = false;
  }
}
var uid = 0;
function createReactiveEffect(fn, options) {
  const effect3 = function reactiveEffect() {
    if (!effect3.active) {
      return fn();
    }
    if (!effectStack.includes(effect3)) {
      cleanup(effect3);
      try {
        enableTracking();
        effectStack.push(effect3);
        activeEffect = effect3;
        return fn();
      } finally {
        effectStack.pop();
        resetTracking();
        activeEffect = effectStack[effectStack.length - 1];
      }
    }
  };
  effect3.id = uid++;
  effect3.allowRecurse = !!options.allowRecurse;
  effect3._isEffect = true;
  effect3.active = true;
  effect3.raw = fn;
  effect3.deps = [];
  effect3.options = options;
  return effect3;
}
function cleanup(effect3) {
  const { deps } = effect3;
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].delete(effect3);
    }
    deps.length = 0;
  }
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function enableTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = true;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (!shouldTrack || activeEffect === void 0) {
    return;
  }
  let depsMap = targetMap.get(target);
  if (!depsMap) {
    targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
  }
  let dep = depsMap.get(key);
  if (!dep) {
    depsMap.set(key, dep = /* @__PURE__ */ new Set());
  }
  if (!dep.has(activeEffect)) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
    if (activeEffect.options.onTrack) {
      activeEffect.options.onTrack({
        effect: activeEffect,
        target,
        type,
        key
      });
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  const effects = /* @__PURE__ */ new Set();
  const add2 = (effectsToAdd) => {
    if (effectsToAdd) {
      effectsToAdd.forEach((effect3) => {
        if (effect3 !== activeEffect || effect3.allowRecurse) {
          effects.add(effect3);
        }
      });
    }
  };
  if (type === "clear") {
    depsMap.forEach(add2);
  } else if (key === "length" && isArray(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        add2(dep);
      }
    });
  } else {
    if (key !== void 0) {
      add2(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          add2(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap(target)) {
          add2(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  const run = (effect3) => {
    if (effect3.options.onTrigger) {
      effect3.options.onTrigger({
        effect: effect3,
        target,
        key,
        type,
        newValue,
        oldValue,
        oldTarget
      });
    }
    if (effect3.options.scheduler) {
      effect3.options.scheduler(effect3);
    } else {
      effect3();
    }
  };
  effects.forEach(run);
}
var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
var get2 = /* @__PURE__ */ createGetter();
var shallowGet = /* @__PURE__ */ createGetter(false, true);
var readonlyGet = /* @__PURE__ */ createGetter(true);
var shallowReadonlyGet = /* @__PURE__ */ createGetter(true, true);
var arrayInstrumentations = {};
["includes", "indexOf", "lastIndexOf"].forEach((key) => {
  const method = Array.prototype[key];
  arrayInstrumentations[key] = function(...args) {
    const arr = toRaw(this);
    for (let i = 0, l = this.length; i < l; i++) {
      track(arr, "get", i + "");
    }
    const res = method.apply(arr, args);
    if (res === -1 || res === false) {
      return method.apply(arr, args.map(toRaw));
    } else {
      return res;
    }
  };
});
["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
  const method = Array.prototype[key];
  arrayInstrumentations[key] = function(...args) {
    pauseTracking();
    const res = method.apply(this, args);
    resetTracking();
    return res;
  };
});
function createGetter(isReadonly = false, shallow = false) {
  return function get3(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
      return shouldUnwrap ? res.value : res;
    }
    if (isObject(res)) {
      return isReadonly ? readonly(res) : reactive2(res);
    }
    return res;
  };
}
var set2 = /* @__PURE__ */ createSetter();
var shallowSet = /* @__PURE__ */ createSetter(true);
function createSetter(shallow = false) {
  return function set3(target, key, value, receiver) {
    let oldValue = target[key];
    if (!shallow) {
      value = toRaw(value);
      oldValue = toRaw(oldValue);
      if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value, oldValue);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn(target, key);
  const oldValue = target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function has(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys$1(target) {
  track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
var mutableHandlers = {
  get: get2,
  set: set2,
  deleteProperty,
  has,
  ownKeys: ownKeys$1
};
var readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    {
      console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  },
  deleteProperty(target, key) {
    {
      console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  }
};
extend({}, mutableHandlers, {
  get: shallowGet,
  set: shallowSet
});
extend({}, readonlyHandlers, {
  get: shallowReadonlyGet
});
var toReactive = (value) => isObject(value) ? reactive2(value) : value;
var toReadonly = (value) => isObject(value) ? readonly(value) : value;
var toShallow = (value) => value;
var getProto = (v) => Reflect.getPrototypeOf(v);
function get$1(target, key, isReadonly = false, isShallow = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "get", key);
  }
  !isReadonly && track(rawTarget, "get", rawKey);
  const { has: has2 } = getProto(rawTarget);
  const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1(key, isReadonly = false) {
  const target = this[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "has", key);
  }
  !isReadonly && track(rawTarget, "has", rawKey);
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger(target, "add", key, value);
  } else if (hasChanged(value, oldValue)) {
    trigger(target, "set", key, value, oldValue);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3 ? get3.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const oldTarget = isMap(target) ? new Map(target) : new Set(target);
  const result = target.clear();
  if (hadItems) {
    trigger(target, "clear", void 0, void 0, oldTarget);
  }
  return result;
}
function createForEach(isReadonly, isShallow) {
  return function forEach(callback, thisArg) {
    const observed = this;
    const target = observed[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly, isShallow) {
  return function(...args) {
    const target = this[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    {
      const key = args[0] ? `on key "${args[0]}" ` : ``;
      console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
    }
    return type === "delete" ? false : this;
  };
}
var mutableInstrumentations = {
  get(key) {
    return get$1(this, key);
  },
  get size() {
    return size(this);
  },
  has: has$1,
  add,
  set: set$1,
  delete: deleteEntry,
  clear,
  forEach: createForEach(false, false)
};
var shallowInstrumentations = {
  get(key) {
    return get$1(this, key, false, true);
  },
  get size() {
    return size(this);
  },
  has: has$1,
  add,
  set: set$1,
  delete: deleteEntry,
  clear,
  forEach: createForEach(false, true)
};
var readonlyInstrumentations = {
  get(key) {
    return get$1(this, key, true);
  },
  get size() {
    return size(this, true);
  },
  has(key) {
    return has$1.call(this, key, true);
  },
  add: createReadonlyMethod(
    "add"
    /* ADD */
  ),
  set: createReadonlyMethod(
    "set"
    /* SET */
  ),
  delete: createReadonlyMethod(
    "delete"
    /* DELETE */
  ),
  clear: createReadonlyMethod(
    "clear"
    /* CLEAR */
  ),
  forEach: createForEach(true, false)
};
var shallowReadonlyInstrumentations = {
  get(key) {
    return get$1(this, key, true, true);
  },
  get size() {
    return size(this, true);
  },
  has(key) {
    return has$1.call(this, key, true);
  },
  add: createReadonlyMethod(
    "add"
    /* ADD */
  ),
  set: createReadonlyMethod(
    "set"
    /* SET */
  ),
  delete: createReadonlyMethod(
    "delete"
    /* DELETE */
  ),
  clear: createReadonlyMethod(
    "clear"
    /* CLEAR */
  ),
  forEach: createForEach(true, true)
};
var iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
iteratorMethods.forEach((method) => {
  mutableInstrumentations[method] = createIterableMethod(method, false, false);
  readonlyInstrumentations[method] = createIterableMethod(method, true, false);
  shallowInstrumentations[method] = createIterableMethod(method, false, true);
  shallowReadonlyInstrumentations[method] = createIterableMethod(method, true, true);
});
function createInstrumentationGetter(isReadonly, shallow) {
  const instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
var mutableCollectionHandlers = {
  get: createInstrumentationGetter(false, false)
};
var readonlyCollectionHandlers = {
  get: createInstrumentationGetter(true, false)
};
function checkIdentityKeys(target, has2, key) {
  const rawKey = toRaw(key);
  if (rawKey !== key && has2.call(target, rawKey)) {
    const type = toRawType(target);
    console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
  }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value[
    "__v_skip"
    /* SKIP */
  ] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive2(target) {
  if (target && target[
    "__v_isReadonly"
    /* IS_READONLY */
  ]) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject(target)) {
    {
      console.warn(`value cannot be made reactive: ${String(target)}`);
    }
    return target;
  }
  if (target[
    "__v_raw"
    /* RAW */
  ] && !(isReadonly && target[
    "__v_isReactive"
    /* IS_REACTIVE */
  ])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function toRaw(observed) {
  return observed && toRaw(observed[
    "__v_raw"
    /* RAW */
  ]) || observed;
}
function isRef(r) {
  return Boolean(r && r.__v_isRef === true);
}
magic("nextTick", () => nextTick);
magic("dispatch", (el) => dispatch.bind(dispatch, el));
magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 }) => (key, callback) => {
  let evaluate2 = evaluateLater2(key);
  let firstTime = true;
  let oldValue;
  let effectReference = effect3(() => evaluate2((value) => {
    JSON.stringify(value);
    if (!firstTime) {
      queueMicrotask(() => {
        callback(value, oldValue);
        oldValue = value;
      });
    } else {
      oldValue = value;
    }
    firstTime = false;
  }));
  el._x_effects.delete(effectReference);
});
magic("store", getStores);
magic("data", (el) => scope(el));
magic("root", (el) => closestRoot(el));
magic("refs", (el) => {
  if (el._x_refs_proxy)
    return el._x_refs_proxy;
  el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
  return el._x_refs_proxy;
});
function getArrayOfRefObject(el) {
  let refObjects = [];
  let currentEl = el;
  while (currentEl) {
    if (currentEl._x_refs)
      refObjects.push(currentEl._x_refs);
    currentEl = currentEl.parentNode;
  }
  return refObjects;
}
var globalIdMemo = {};
function findAndIncrementId(name) {
  if (!globalIdMemo[name])
    globalIdMemo[name] = 0;
  return ++globalIdMemo[name];
}
function closestIdRoot(el, name) {
  return findClosest(el, (element) => {
    if (element._x_ids && element._x_ids[name])
      return true;
  });
}
function setIdRoot(el, name) {
  if (!el._x_ids)
    el._x_ids = {};
  if (!el._x_ids[name])
    el._x_ids[name] = findAndIncrementId(name);
}
magic("id", (el) => (name, key = null) => {
  let root = closestIdRoot(el, name);
  let id = root ? root._x_ids[name] : findAndIncrementId(name);
  return key ? `${name}-${id}-${key}` : `${name}-${id}`;
});
magic("el", (el) => el);
warnMissingPluginMagic("Focus", "focus", "focus");
warnMissingPluginMagic("Persist", "persist", "persist");
function warnMissingPluginMagic(name, magicName, slug) {
  magic(magicName, (el) => warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
function entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
  let firstRun = true;
  let outerHash, outerHashLatest;
  let reference = effect(() => {
    let outer, inner;
    if (firstRun) {
      outer = outerGet();
      innerSet(outer);
      inner = innerGet();
      firstRun = false;
    } else {
      outer = outerGet();
      inner = innerGet();
      outerHashLatest = JSON.stringify(outer);
      JSON.stringify(inner);
      if (outerHashLatest !== outerHash) {
        inner = innerGet();
        innerSet(outer);
        inner = outer;
      } else {
        outerSet(inner);
        outer = inner;
      }
    }
    outerHash = JSON.stringify(outer);
    JSON.stringify(inner);
  });
  return () => {
    release(reference);
  };
}
directive("modelable", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
  let func = evaluateLater2(expression);
  let innerGet = () => {
    let result;
    func((i) => result = i);
    return result;
  };
  let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
  let innerSet = (val) => evaluateInnerSet(() => {
  }, { scope: { "__placeholder": val } });
  let initialValue = innerGet();
  innerSet(initialValue);
  queueMicrotask(() => {
    if (!el._x_model)
      return;
    el._x_removeModelListeners["default"]();
    let outerGet = el._x_model.get;
    let outerSet = el._x_model.set;
    let releaseEntanglement = entangle(
      {
        get() {
          return outerGet();
        },
        set(value) {
          outerSet(value);
        }
      },
      {
        get() {
          return innerGet();
        },
        set(value) {
          innerSet(value);
        }
      }
    );
    cleanup2(releaseEntanglement);
  });
});
var teleportContainerDuringClone = document.createElement("div");
directive("teleport", (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-teleport can only be used on a <template> tag", el);
  let target = skipDuringClone(() => {
    return document.querySelector(expression);
  }, () => {
    return teleportContainerDuringClone;
  })();
  if (!target)
    warn(`Cannot find x-teleport element for selector: "${expression}"`);
  let clone2 = el.content.cloneNode(true).firstElementChild;
  el._x_teleport = clone2;
  clone2._x_teleportBack = el;
  if (el._x_forwardEvents) {
    el._x_forwardEvents.forEach((eventName) => {
      clone2.addEventListener(eventName, (e) => {
        e.stopPropagation();
        el.dispatchEvent(new e.constructor(e.type, e));
      });
    });
  }
  addScopeToNode(clone2, {}, el);
  mutateDom(() => {
    if (modifiers.includes("prepend")) {
      target.parentNode.insertBefore(clone2, target);
    } else if (modifiers.includes("append")) {
      target.parentNode.insertBefore(clone2, target.nextSibling);
    } else {
      target.appendChild(clone2);
    }
    initTree(clone2);
    clone2._x_ignore = true;
  });
  cleanup2(() => clone2.remove());
});
var handler = () => {
};
handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
  modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
  cleanup2(() => {
    modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
  });
};
directive("ignore", handler);
directive("effect", (el, { expression }, { effect: effect3 }) => effect3(evaluateLater(el, expression)));
function on(el, event, modifiers, callback) {
  let listenerTarget = el;
  let handler3 = (e) => callback(e);
  let options = {};
  let wrapHandler = (callback2, wrapper) => (e) => wrapper(callback2, e);
  if (modifiers.includes("dot"))
    event = dotSyntax(event);
  if (modifiers.includes("camel"))
    event = camelCase2(event);
  if (modifiers.includes("passive"))
    options.passive = true;
  if (modifiers.includes("capture"))
    options.capture = true;
  if (modifiers.includes("window"))
    listenerTarget = window;
  if (modifiers.includes("document"))
    listenerTarget = document;
  if (modifiers.includes("prevent"))
    handler3 = wrapHandler(handler3, (next, e) => {
      e.preventDefault();
      next(e);
    });
  if (modifiers.includes("stop"))
    handler3 = wrapHandler(handler3, (next, e) => {
      e.stopPropagation();
      next(e);
    });
  if (modifiers.includes("self"))
    handler3 = wrapHandler(handler3, (next, e) => {
      e.target === el && next(e);
    });
  if (modifiers.includes("away") || modifiers.includes("outside")) {
    listenerTarget = document;
    handler3 = wrapHandler(handler3, (next, e) => {
      if (el.contains(e.target))
        return;
      if (e.target.isConnected === false)
        return;
      if (el.offsetWidth < 1 && el.offsetHeight < 1)
        return;
      if (el._x_isShown === false)
        return;
      next(e);
    });
  }
  if (modifiers.includes("once")) {
    handler3 = wrapHandler(handler3, (next, e) => {
      next(e);
      listenerTarget.removeEventListener(event, handler3, options);
    });
  }
  handler3 = wrapHandler(handler3, (next, e) => {
    if (isKeyEvent(event)) {
      if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) {
        return;
      }
    }
    next(e);
  });
  if (modifiers.includes("debounce")) {
    let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler3 = debounce(handler3, wait);
  }
  if (modifiers.includes("throttle")) {
    let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler3 = throttle(handler3, wait);
  }
  listenerTarget.addEventListener(event, handler3, options);
  return () => {
    listenerTarget.removeEventListener(event, handler3, options);
  };
}
function dotSyntax(subject) {
  return subject.replace(/-/g, ".");
}
function camelCase2(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function isNumeric(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function kebabCase2(subject) {
  if ([" ", "_"].includes(
    subject
  ))
    return subject;
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function isKeyEvent(event) {
  return ["keydown", "keyup"].includes(event);
}
function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
  let keyModifiers = modifiers.filter((i) => {
    return !["window", "document", "prevent", "stop", "once", "capture"].includes(i);
  });
  if (keyModifiers.includes("debounce")) {
    let debounceIndex = keyModifiers.indexOf("debounce");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.includes("throttle")) {
    let debounceIndex = keyModifiers.indexOf("throttle");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.length === 0)
    return false;
  if (keyModifiers.length === 1 && keyToModifiers(e.key).includes(keyModifiers[0]))
    return false;
  const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
  const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
  keyModifiers = keyModifiers.filter((i) => !selectedSystemKeyModifiers.includes(i));
  if (selectedSystemKeyModifiers.length > 0) {
    const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
      if (modifier === "cmd" || modifier === "super")
        modifier = "meta";
      return e[`${modifier}Key`];
    });
    if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
      if (keyToModifiers(e.key).includes(keyModifiers[0]))
        return false;
    }
  }
  return true;
}
function keyToModifiers(key) {
  if (!key)
    return [];
  key = kebabCase2(key);
  let modifierToKeyMap = {
    "ctrl": "control",
    "slash": "/",
    "space": " ",
    "spacebar": " ",
    "cmd": "meta",
    "esc": "escape",
    "up": "arrow-up",
    "down": "arrow-down",
    "left": "arrow-left",
    "right": "arrow-right",
    "period": ".",
    "equal": "=",
    "minus": "-",
    "underscore": "_"
  };
  modifierToKeyMap[key] = key;
  return Object.keys(modifierToKeyMap).map((modifier) => {
    if (modifierToKeyMap[modifier] === key)
      return modifier;
  }).filter((modifier) => modifier);
}
directive("model", (el, { modifiers, expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let scopeTarget = el;
  if (modifiers.includes("parent")) {
    scopeTarget = el.parentNode;
  }
  let evaluateGet = evaluateLater(scopeTarget, expression);
  let evaluateSet;
  if (typeof expression === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression} = __placeholder`);
  } else if (typeof expression === "function" && typeof expression() === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression()} = __placeholder`);
  } else {
    evaluateSet = () => {
    };
  }
  let getValue = () => {
    let result;
    evaluateGet((value) => result = value);
    return isGetterSetter(result) ? result.get() : result;
  };
  let setValue = (value) => {
    let result;
    evaluateGet((value2) => result = value2);
    if (isGetterSetter(result)) {
      result.set(value);
    } else {
      evaluateSet(() => {
      }, {
        scope: { "__placeholder": value }
      });
    }
  };
  if (modifiers.includes("fill") && el.hasAttribute("value") && (getValue() === null || getValue() === "")) {
    setValue(el.value);
  }
  if (typeof expression === "string" && el.type === "radio") {
    mutateDom(() => {
      if (!el.hasAttribute("name"))
        el.setAttribute("name", expression);
    });
  }
  var event = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
  let removeListener = isCloning ? () => {
  } : on(el, event, modifiers, (e) => {
    setValue(getInputValue(el, modifiers, e, getValue()));
  });
  if (!el._x_removeModelListeners)
    el._x_removeModelListeners = {};
  el._x_removeModelListeners["default"] = removeListener;
  cleanup2(() => el._x_removeModelListeners["default"]());
  if (el.form) {
    let removeResetListener = on(el.form, "reset", [], (e) => {
      nextTick(() => el._x_model && el._x_model.set(el.value));
    });
    cleanup2(() => removeResetListener());
  }
  el._x_model = {
    get() {
      return getValue();
    },
    set(value) {
      setValue(value);
    }
  };
  el._x_forceModelUpdate = (value) => {
    value = value === void 0 ? getValue() : value;
    if (value === void 0 && typeof expression === "string" && expression.match(/\./))
      value = "";
    window.fromModel = true;
    mutateDom(() => bind(el, "value", value));
    delete window.fromModel;
  };
  effect3(() => {
    let value = getValue();
    if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
      return;
    el._x_forceModelUpdate(value);
  });
});
function getInputValue(el, modifiers, event, currentValue) {
  return mutateDom(() => {
    if (event instanceof CustomEvent && event.detail !== void 0) {
      return typeof event.detail != "undefined" ? event.detail : event.target.value;
    } else if (el.type === "checkbox") {
      if (Array.isArray(currentValue)) {
        let newValue = modifiers.includes("number") ? safeParseNumber(event.target.value) : event.target.value;
        return event.target.checked ? currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
      } else {
        return event.target.checked;
      }
    } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
      return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option) => {
        let rawValue = option.value || option.text;
        return safeParseNumber(rawValue);
      }) : Array.from(event.target.selectedOptions).map((option) => {
        return option.value || option.text;
      });
    } else {
      let rawValue = event.target.value;
      return modifiers.includes("number") ? safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
    }
  });
}
function safeParseNumber(rawValue) {
  let number = rawValue ? parseFloat(rawValue) : null;
  return isNumeric2(number) ? number : rawValue;
}
function checkedAttrLooseCompare2(valueA, valueB) {
  return valueA == valueB;
}
function isNumeric2(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function isGetterSetter(value) {
  return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
addInitSelector(() => `[${prefix("init")}]`);
directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "string") {
    return !!expression.trim() && evaluate2(expression, {}, false);
  }
  return evaluate2(expression, {}, false);
}));
directive("text", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.textContent = value;
      });
    });
  });
});
directive("html", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.innerHTML = value;
        el._x_ignoreSelf = true;
        initTree(el);
        delete el._x_ignoreSelf;
      });
    });
  });
});
mapAttributes(startingWith(":", into(prefix("bind:"))));
directive("bind", (el, { value, modifiers, expression, original }, { effect: effect3 }) => {
  if (!value) {
    let bindingProviders = {};
    injectBindingProviders(bindingProviders);
    let getBindings = evaluateLater(el, expression);
    getBindings((bindings) => {
      applyBindingsObject(el, bindings, original);
    }, { scope: bindingProviders });
    return;
  }
  if (value === "key")
    return storeKeyForXFor(el, expression);
  let evaluate2 = evaluateLater(el, expression);
  effect3(() => evaluate2((result) => {
    if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
      result = "";
    }
    mutateDom(() => bind(el, value, result, modifiers));
  }));
});
function storeKeyForXFor(el, expression) {
  el._x_keyExpression = expression;
}
addRootSelector(() => `[${prefix("data")}]`);
directive("data", skipDuringClone((el, { expression }, { cleanup: cleanup2 }) => {
  expression = expression === "" ? "{}" : expression;
  let magicContext = {};
  injectMagics(magicContext, el);
  let dataProviderContext = {};
  injectDataProviders(dataProviderContext, magicContext);
  let data2 = evaluate(el, expression, { scope: dataProviderContext });
  if (data2 === void 0 || data2 === true)
    data2 = {};
  injectMagics(data2, el);
  let reactiveData = reactive(data2);
  initInterceptors(reactiveData);
  let undo = addScopeToNode(el, reactiveData);
  reactiveData["init"] && evaluate(el, reactiveData["init"]);
  cleanup2(() => {
    reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
    undo();
  });
}));
directive("show", (el, { modifiers, expression }, { effect: effect3 }) => {
  let evaluate2 = evaluateLater(el, expression);
  if (!el._x_doHide)
    el._x_doHide = () => {
      mutateDom(() => {
        el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
      });
    };
  if (!el._x_doShow)
    el._x_doShow = () => {
      mutateDom(() => {
        if (el.style.length === 1 && el.style.display === "none") {
          el.removeAttribute("style");
        } else {
          el.style.removeProperty("display");
        }
      });
    };
  let hide = () => {
    el._x_doHide();
    el._x_isShown = false;
  };
  let show = () => {
    el._x_doShow();
    el._x_isShown = true;
  };
  let clickAwayCompatibleShow = () => setTimeout(show);
  let toggle = once(
    (value) => value ? show() : hide(),
    (value) => {
      if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
        el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
      } else {
        value ? clickAwayCompatibleShow() : hide();
      }
    }
  );
  let oldValue;
  let firstTime = true;
  effect3(() => evaluate2((value) => {
    if (!firstTime && value === oldValue)
      return;
    if (modifiers.includes("immediate"))
      value ? clickAwayCompatibleShow() : hide();
    toggle(value);
    oldValue = value;
    firstTime = false;
  }));
});
directive("for", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let iteratorNames = parseForExpression(expression);
  let evaluateItems = evaluateLater(el, iteratorNames.items);
  let evaluateKey = evaluateLater(
    el,
    // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index"
  );
  el._x_prevKeys = [];
  el._x_lookup = {};
  effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
  cleanup2(() => {
    Object.values(el._x_lookup || {}).forEach((el2) => el2.remove());
    delete el._x_prevKeys;
    delete el._x_lookup;
  });
});
function loop(el, iteratorNames, evaluateItems, evaluateKey) {
  let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
  let templateEl = el;
  evaluateItems((items) => {
    if (isNumeric3(items) && items >= 0) {
      items = Array.from(Array(items).keys(), (i) => i + 1);
    }
    if (items === void 0)
      items = [];
    let lookup = el._x_lookup;
    let prevKeys = el._x_prevKeys;
    let scopes = [];
    let keys = [];
    if (isObject2(items)) {
      items = Object.entries(items).map(([key, value]) => {
        let scope2 = getIterationScopeVariables(iteratorNames, value, key, items);
        evaluateKey((value2) => keys.push(value2), { scope: { index: key, ...scope2 } });
        scopes.push(scope2);
      });
    } else {
      for (let i = 0; i < items.length; i++) {
        let scope2 = getIterationScopeVariables(iteratorNames, items[i], i, items);
        evaluateKey((value) => keys.push(value), { scope: { index: i, ...scope2 } });
        scopes.push(scope2);
      }
    }
    let adds = [];
    let moves = [];
    let removes = [];
    let sames = [];
    for (let i = 0; i < prevKeys.length; i++) {
      let key = prevKeys[i];
      if (keys.indexOf(key) === -1)
        removes.push(key);
    }
    prevKeys = prevKeys.filter((key) => !removes.includes(key));
    let lastKey = "template";
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      let prevIndex = prevKeys.indexOf(key);
      if (prevIndex === -1) {
        prevKeys.splice(i, 0, key);
        adds.push([lastKey, i]);
      } else if (prevIndex !== i) {
        let keyInSpot = prevKeys.splice(i, 1)[0];
        let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
        prevKeys.splice(i, 0, keyForSpot);
        prevKeys.splice(prevIndex, 0, keyInSpot);
        moves.push([keyInSpot, keyForSpot]);
      } else {
        sames.push(key);
      }
      lastKey = key;
    }
    for (let i = 0; i < removes.length; i++) {
      let key = removes[i];
      if (!!lookup[key]._x_effects) {
        lookup[key]._x_effects.forEach(dequeueJob);
      }
      lookup[key].remove();
      lookup[key] = null;
      delete lookup[key];
    }
    for (let i = 0; i < moves.length; i++) {
      let [keyInSpot, keyForSpot] = moves[i];
      let elInSpot = lookup[keyInSpot];
      let elForSpot = lookup[keyForSpot];
      let marker = document.createElement("div");
      mutateDom(() => {
        elForSpot.after(marker);
        elInSpot.after(elForSpot);
        elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
        marker.before(elInSpot);
        elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
        marker.remove();
      });
      refreshScope(elForSpot, scopes[keys.indexOf(keyForSpot)]);
    }
    for (let i = 0; i < adds.length; i++) {
      let [lastKey2, index] = adds[i];
      let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
      if (lastEl._x_currentIfEl)
        lastEl = lastEl._x_currentIfEl;
      let scope2 = scopes[index];
      let key = keys[index];
      let clone2 = document.importNode(templateEl.content, true).firstElementChild;
      addScopeToNode(clone2, reactive(scope2), templateEl);
      mutateDom(() => {
        lastEl.after(clone2);
        initTree(clone2);
      });
      if (typeof key === "object") {
        warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
      }
      lookup[key] = clone2;
    }
    for (let i = 0; i < sames.length; i++) {
      refreshScope(lookup[sames[i]], scopes[keys.indexOf(sames[i])]);
    }
    templateEl._x_prevKeys = keys;
  });
}
function parseForExpression(expression) {
  let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  let stripParensRE = /^\s*\(|\)\s*$/g;
  let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  let inMatch = expression.match(forAliasRE);
  if (!inMatch)
    return;
  let res = {};
  res.items = inMatch[2].trim();
  let item = inMatch[1].replace(stripParensRE, "").trim();
  let iteratorMatch = item.match(forIteratorRE);
  if (iteratorMatch) {
    res.item = item.replace(forIteratorRE, "").trim();
    res.index = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.collection = iteratorMatch[2].trim();
    }
  } else {
    res.item = item;
  }
  return res;
}
function getIterationScopeVariables(iteratorNames, item, index, items) {
  let scopeVariables = {};
  if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
    let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i) => i.trim());
    names.forEach((name, i) => {
      scopeVariables[name] = item[i];
    });
  } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
    let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i) => i.trim());
    names.forEach((name) => {
      scopeVariables[name] = item[name];
    });
  } else {
    scopeVariables[iteratorNames.item] = item;
  }
  if (iteratorNames.index)
    scopeVariables[iteratorNames.index] = index;
  if (iteratorNames.collection)
    scopeVariables[iteratorNames.collection] = items;
  return scopeVariables;
}
function isNumeric3(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function handler2() {
}
handler2.inline = (el, { expression }, { cleanup: cleanup2 }) => {
  let root = closestRoot(el);
  if (!root._x_refs)
    root._x_refs = {};
  root._x_refs[expression] = el;
  cleanup2(() => delete root._x_refs[expression]);
};
directive("ref", handler2);
directive("if", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let evaluate2 = evaluateLater(el, expression);
  let show = () => {
    if (el._x_currentIfEl)
      return el._x_currentIfEl;
    let clone2 = el.content.cloneNode(true).firstElementChild;
    addScopeToNode(clone2, {}, el);
    mutateDom(() => {
      el.after(clone2);
      initTree(clone2);
    });
    el._x_currentIfEl = clone2;
    el._x_undoIf = () => {
      walk(clone2, (node) => {
        if (!!node._x_effects) {
          node._x_effects.forEach(dequeueJob);
        }
      });
      clone2.remove();
      delete el._x_currentIfEl;
    };
    return clone2;
  };
  let hide = () => {
    if (!el._x_undoIf)
      return;
    el._x_undoIf();
    delete el._x_undoIf;
  };
  effect3(() => evaluate2((value) => {
    value ? show() : hide();
  }));
  cleanup2(() => el._x_undoIf && el._x_undoIf());
});
directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
  let names = evaluate2(expression);
  names.forEach((name) => setIdRoot(el, name));
});
mapAttributes(startingWith("@", into(prefix("on:"))));
directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
  let evaluate2 = expression ? evaluateLater(el, expression) : () => {
  };
  if (el.tagName.toLowerCase() === "template") {
    if (!el._x_forwardEvents)
      el._x_forwardEvents = [];
    if (!el._x_forwardEvents.includes(value))
      el._x_forwardEvents.push(value);
  }
  let removeListener = on(el, value, modifiers, (e) => {
    evaluate2(() => {
    }, { scope: { "$event": e }, params: [e] });
  });
  cleanup2(() => removeListener());
}));
warnMissingPluginDirective("Collapse", "collapse", "collapse");
warnMissingPluginDirective("Intersect", "intersect", "intersect");
warnMissingPluginDirective("Focus", "trap", "focus");
warnMissingPluginDirective("Mask", "mask", "mask");
function warnMissingPluginDirective(name, directiveName2, slug) {
  directive(directiveName2, (el) => warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
alpine_default.setEvaluator(normalEvaluator);
alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
var src_default$3 = alpine_default;
var module_default$3 = src_default$3;
var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var matches = typeof Element === "undefined" ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var isContentEditable = function isContentEditable2(node) {
  return node.contentEditable === "true";
};
var getTabindex = function getTabindex2(node) {
  var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  }
  if (isContentEditable(node)) {
    return 0;
  }
  if ((node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
    return 0;
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || node.ownerDocument;
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isHidden = function isHidden2(node, displayCheck) {
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full") {
    while (node) {
      if (getComputedStyle(node).display === "none") {
        return true;
      }
      node = node.parentElement;
    }
  } else if (displayCheck === "non-zero-area") {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (isInput(node) || node.tagName === "SELECT" || node.tagName === "TEXTAREA" || node.tagName === "BUTTON") {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            if (child.contains(node)) {
              return false;
            }
            return true;
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }
  return true;
};
var tabbable = function tabbable2(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function(candidate, i) {
    var candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function(a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};
var focusable = function focusable2(el, options) {
  options = options || {};
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  return candidates;
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var activeFocusTraps = function() {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }
      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
  return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = document;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var containersContain = function containersContain2(element) {
    return state.containers.some(function(container) {
      return container.contains(element);
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (!optionValue) {
      return null;
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` refers to no known node"));
      }
    }
    if (typeof optionValue === "function") {
      node = optionValue();
      if (!node) {
        throw new Error("`".concat(optionName, "` did not return a node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node;
    if (getOption({}, "initialFocus") === false) {
      return false;
    }
    if (getNodeForOption("initialFocus") !== null) {
      node = getNodeForOption("initialFocus");
    } else if (containersContain(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      var firstTabbableGroup = state.tabbableGroups[0];
      var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
      node = firstTabbableNode || getNodeForOption("fallbackFocus");
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.tabbableGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container);
      if (tabbableNodes.length > 0) {
        return {
          container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }
      return void 0;
    }).filter(function(group) {
      return !!group;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus");
    return node ? node : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    if (containersContain(e.target)) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(e.target)
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e) {
    var targetContained = containersContain(e.target);
    if (targetContained || e.target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = e.target;
      }
    } else {
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkTab = function checkTab2(e) {
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findIndex(state.tabbableGroups, function(_ref) {
        var container = _ref.container;
        return container.contains(e.target);
      });
      if (containerIndex < 0) {
        if (e.shiftKey) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return e.target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === e.target) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return e.target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === e.target) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick2(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (containersContain(e.target)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, "onDeactivate");
      var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
      var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
      if (onDeactivate) {
        onDeactivate();
      }
      var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
function src_default$2(Alpine2) {
  let lastFocused;
  let currentFocused;
  window.addEventListener("focusin", () => {
    lastFocused = currentFocused;
    currentFocused = document.activeElement;
  });
  Alpine2.magic("focus", (el) => {
    let within = el;
    return {
      __noscroll: false,
      __wrapAround: false,
      within(el2) {
        within = el2;
        return this;
      },
      withoutScrolling() {
        this.__noscroll = true;
        return this;
      },
      noscroll() {
        this.__noscroll = true;
        return this;
      },
      withWrapAround() {
        this.__wrapAround = true;
        return this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(el2) {
        return isFocusable(el2);
      },
      previouslyFocused() {
        return lastFocused;
      },
      lastFocused() {
        return lastFocused;
      },
      focused() {
        return currentFocused;
      },
      focusables() {
        if (Array.isArray(within))
          return within;
        return focusable(within, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(el2) {
        let els = this.all();
        return els[0] && els[0].isSameNode(el2);
      },
      isLast(el2) {
        let els = this.all();
        return els.length && els.slice(-1)[0].isSameNode(el2);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1)
          return;
        if (this.__wrapAround && list.indexOf(current) === list.length - 1) {
          return list[0];
        }
        return list[list.indexOf(current) + 1];
      },
      getPrevious() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1)
          return;
        if (this.__wrapAround && list.indexOf(current) === 0) {
          return list.slice(-1)[0];
        }
        return list[list.indexOf(current) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(el2) {
        if (!el2)
          return;
        setTimeout(() => {
          if (!el2.hasAttribute("tabindex"))
            el2.setAttribute("tabindex", "0");
          el2.focus({ preventScroll: this._noscroll });
        });
      }
    };
  });
  Alpine2.directive("trap", Alpine2.skipDuringClone(
    (el, { expression, modifiers }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
      let evaluator = evaluateLater2(expression);
      let oldValue = false;
      let trap = createFocusTrap(el, {
        escapeDeactivates: false,
        allowOutsideClick: true,
        fallbackFocus: () => el,
        initialFocus: el.querySelector("[autofocus]")
      });
      let undoInert = () => {
      };
      let undoDisableScrolling = () => {
      };
      const releaseFocus = () => {
        undoInert();
        undoInert = () => {
        };
        undoDisableScrolling();
        undoDisableScrolling = () => {
        };
        trap.deactivate({
          returnFocus: !modifiers.includes("noreturn")
        });
      };
      effect3(() => evaluator((value) => {
        if (oldValue === value)
          return;
        if (value && !oldValue) {
          setTimeout(() => {
            if (modifiers.includes("inert"))
              undoInert = setInert(el);
            if (modifiers.includes("noscroll"))
              undoDisableScrolling = disableScrolling();
            trap.activate();
          });
        }
        if (!value && oldValue) {
          releaseFocus();
        }
        oldValue = !!value;
      }));
      cleanup2(releaseFocus);
    },
    // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate: evaluate2 }) => {
      if (modifiers.includes("inert") && evaluate2(expression))
        setInert(el);
    }
  ));
}
function setInert(el) {
  let undos = [];
  crawlSiblingsUp(el, (sibling) => {
    let cache = sibling.hasAttribute("aria-hidden");
    sibling.setAttribute("aria-hidden", "true");
    undos.push(() => cache || sibling.removeAttribute("aria-hidden"));
  });
  return () => {
    while (undos.length)
      undos.pop()();
  };
}
function crawlSiblingsUp(el, callback) {
  if (el.isSameNode(document.body) || !el.parentNode)
    return;
  Array.from(el.parentNode.children).forEach((sibling) => {
    if (sibling.isSameNode(el)) {
      crawlSiblingsUp(el.parentNode, callback);
    } else {
      callback(sibling);
    }
  });
}
function disableScrolling() {
  let overflow = document.documentElement.style.overflow;
  let paddingRight = document.documentElement.style.paddingRight;
  let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.overflow = "hidden";
  document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
  return () => {
    document.documentElement.style.overflow = overflow;
    document.documentElement.style.paddingRight = paddingRight;
  };
}
var module_default$2 = src_default$2;
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.2.1
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.6.1
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/
function src_default$1(Alpine2) {
  Alpine2.directive("intersect", (el, { value, expression, modifiers }, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
    let evaluate2 = evaluateLater2(expression);
    let options = {
      rootMargin: getRootMargin(modifiers),
      threshold: getThreshhold(modifiers)
    };
    let observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting === (value === "leave"))
          return;
        evaluate2();
        modifiers.includes("once") && observer2.disconnect();
      });
    }, options);
    observer2.observe(el);
    cleanup2(() => {
      observer2.disconnect();
    });
  });
}
function getThreshhold(modifiers) {
  if (modifiers.includes("full"))
    return 0.99;
  if (modifiers.includes("half"))
    return 0.5;
  if (!modifiers.includes("threshold"))
    return 0;
  let threshold = modifiers[modifiers.indexOf("threshold") + 1];
  if (threshold === "100")
    return 1;
  if (threshold === "0")
    return 0;
  return Number(`.${threshold}`);
}
function getLengthValue(rawValue) {
  let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
  return match ? match[1] + (match[2] || "px") : void 0;
}
function getRootMargin(modifiers) {
  const key = "margin";
  const fallback = "0px 0px 0px 0px";
  const index = modifiers.indexOf(key);
  if (index === -1)
    return fallback;
  let values = [];
  for (let i = 1; i < 5; i++) {
    values.push(getLengthValue(modifiers[index + i] || ""));
  }
  values = values.filter((v) => v !== void 0);
  return values.length ? values.join(" ").trim() : fallback;
}
var module_default$1 = src_default$1;
function src_default(Alpine2) {
  let persist = () => {
    let alias;
    let storage = localStorage;
    return Alpine2.interceptor((initialValue, getter, setter, path, key) => {
      let lookup = alias || `_x_${path}`;
      let initial = storageHas(lookup, storage) ? storageGet(lookup, storage) : initialValue;
      setter(initial);
      Alpine2.effect(() => {
        let value = getter();
        storageSet(lookup, value, storage);
        setter(value);
      });
      return initial;
    }, (func) => {
      func.as = (key) => {
        alias = key;
        return func;
      }, func.using = (target) => {
        storage = target;
        return func;
      };
    });
  };
  Object.defineProperty(Alpine2, "$persist", { get: () => persist() });
  Alpine2.magic("persist", persist);
  Alpine2.persist = (key, { get: get3, set: set3 }, storage = localStorage) => {
    let initial = storageHas(key, storage) ? storageGet(key, storage) : get3();
    set3(initial);
    Alpine2.effect(() => {
      let value = get3();
      storageSet(key, value, storage);
      set3(value);
    });
  };
}
function storageHas(key, storage) {
  return storage.getItem(key) !== null;
}
function storageGet(key, storage) {
  return JSON.parse(storage.getItem(key, storage));
}
function storageSet(key, value, storage) {
  storage.setItem(key, JSON.stringify(value));
}
var module_default = src_default;
module_default$3.plugin(module_default);
module_default$3.plugin(module_default$2);
module_default$3.plugin(module_default$1);
window.Alpine = module_default$3;
module_default$3.start();
